(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("TrRoutePlanDialogController", TrRoutePlanDialogController);

    TrRoutePlanDialogController.$inject = [
        "$scope",
        "$state",
        "$rootScope",
        "entity",
        "AlertService",
        "pagingParams",
        "TrProject",
        "TrRouteBundle",
        "AllWorkFlowTypes",
        "AllCustomWorkFlowTypeAttribute",
        "AllCustomAssetTypeAttribute",
        "UserGroupIDs",
        "ActivatedUserSearch",
        "AllAssetsTypes",
        "Configs",
        "UserAccount",
        "FixedAssetExcelUpload",
        "SpreadAssetExcelUpload",
        "getConnectedNodes",
        "KmlToCoordinates",
        "$timeout",
        "assetsByRouteBundleId",
        "assetsLinking",
        "AssetDeleteByID",
        "Asset",
        "MappedAssets",
        "createSection",
        "RouteBundleByID",
        "TrRoute",
        "TrSection",
        "AssetByID",
        "routeDetail",
        "TrSectionById",
        "imageRoutePoint",
        "AssetUpload"
    ];

    function TrRoutePlanDialogController(
        $scope,
        $state,
        $rootScope,
        entity,
        AlertService,
        pagingParams,
        TrProject,
        TrRouteBundle,
        AllWorkFlowTypes,
        AllCustomWorkFlowTypeAttribute,
        AllCustomAssetTypeAttribute,
        UserGroupIDs,
        ActivatedUserSearch,
        AllAssetsTypes,
        Configs,
        UserAccount,
        FixedAssetExcelUpload,
        SpreadAssetExcelUpload,
        getConnectedNodes,
        KmlToCoordinates,
        $timeout,
        assetsByRouteBundleId,
        assetsLinking,
        AssetDeleteByID,
        Asset,
        MappedAssets,
        createSection,
        RouteBundleByID,
        TrRoute,
        TrSection,
        AssetByID,
        routeDetail,
        TrSectionById,
        imageRoutePoint,
        AssetUpload
    ) {
        var vm = this;
        var storeAssets = [];
        vm.mappedAssetsList = [];
        vm.importedSpread = [];
        vm.trRoute = [];
        vm.trRoute = entity;
        var entity_old = angular.copy(vm.trRoute);
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        initPage();
        vm.filterActivatedUser = filterActivatedUser;
        vm.saveEditAsset = saveEditAsset;
        vm.selectedGroup = selectedGroup;
        var openedInfoWindow = null;
        vm.connectSelectedAssets = connectSelectedAssets;
        vm.saveLinkPits = saveLinkPits;
        vm.connectMultipleAssets = connectMultipleAssets;
        vm.hideConnectMultipleAssetsModal = hideConnectMultipleAssetsModal;
        vm.refreshPage = refreshPage;
        vm.connectAssets = connectAssets;
        vm.recalculate = recalculate;
        vm.isSiteASelected = false;
        vm.isSiteBSelected = false;
        vm.selectedSiteA = {};
        vm.selectedSiteB = {};
        vm.linkAssetType = null;
        vm.manholeAssetType = null;
        vm.closeGotoLatitute = closeGotoLatitute;
        vm.showZoomLocation = showZoomLocation;
        vm.labelSaveNext = "Next";
        var tempSize = 11;
        vm.blockFilter = [];
        var blockPolyLine, blockMarker;
        var polylines = [];
        vm.editAsset = editAsset;
        vm.multigroup = [];
        vm.assetType = [];
        vm.mappedAssetsListImport = [];
        var storeRingOptions = [];
        var callAssets = false;
        var tempRingAssetStore = [];
        vm.deleteAssetModal = deleteAssetModal;
        vm.addExistAssetModal = addExistAssetModal;
        vm.closeAssetExistRing = closeAssetExistRing;
        vm.closeRingNameAlreadyExist = closeRingNameAlreadyExist;
        vm.closeUpdateRingNameModel = closeUpdateRingNameModel;
        vm.closeRingModal = closeRingModal;
        vm.confirmDeleteAsset = confirmDeleteAsset;
        vm.cleardeleteAsset = cleardeleteAsset;
        vm.clearCreateAsset = clearCreateAsset;
        var deleteAssetName = null;
        vm.createAssetModal = createAssetModal;
        vm.createAsset = createAsset;
        vm.assetNameVal = null;
        vm.getLocationCoordinate = null;
        var createAssetData = {};
        var tempCount = 0;
        var tempCountCycle = 0;
        vm.progressIsEnabled = true;
        vm.optimalTotalLength = 0;
        vm.routePlanningTotalLength = 0;
        vm.minCostTotalLength = 0;
        vm.isShowTotalLengthImport = false;
        vm.closeAssetAttributesModal = closeAssetAttributesModal;
        vm.closeEditAssetAttributeModal = closeEditAssetAttributeModal;
        vm.editAssetOnMapView = editAssetOnMapView;
        vm.closeEditAssetModal = closeEditAssetModal;
        vm.showAssetImage = false;
        var noDataText = null;
        vm.closeThreePointReference = closeThreePointReference;
        vm.saveEditAssetModal = saveEditAssetModal;
        vm.customAttributesMap = {};
        var usersMap = {};
        var mappedAssetTemp = {};
        vm.mappedAssetsList = [];
        vm.tempLinkWithPits = [];
        vm.deletedAssetsList = [];
        var selectedGroup = [];
        var assetsDeployedMap = null;
        vm.isShowing = true;
        vm.save = save;
        vm.handleTabClick = handleTabClick;
        vm.assetExisting = false;
        $scope.search = null;
        vm.assets = [];
        vm.showAssetName = false;
        var centerlatlng = null;
        vm.hideUser = true;
        var marker = null;
        var editAssetMap = null;
        vm.validUser = true;
        vm.assignedUsers = [];
        vm.validUser = true;
        vm.hideConnectSitesModal = hideConnectSitesModal;
        vm.previousId = sessionStorage.getItem("prevEditId");
        if (vm.previousId) {
            vm.validUser = false;
        }
        $scope.tab = 1;
        vm.siteAssets = [];
        vm.phaseAccess = true;
        vm.updateProgress = 0;
        vm.connectedLength = 0;
        vm.commonPathLength = 0;
        var storeAssets = [];
        var tempPayloadSection = [];
        var newSizeLevel;
        var CHAINAGE_ID = 1;
        var MARKER_ID = 2;
        var COORDINATE_ID = 3;
        vm.storeFixedResponse = [];
        vm.storeSpreadResponse = [];
        var infowindow = new google.maps.InfoWindow();
        var polylineTimer, spreadPoly, existingHighlightFixed;
        var labelFrom, labelTo;
        labelFrom = "A";
        labelTo = "B";
        var markersConnect = [];
        var tempObject = {};
        var tempRingAssetStoreInGraph = [];
        var storeMarkers = [];
        var commonPathMarkers = [];
        var ringId = 0;
        var tempGeofenceId,
            coordinatesSpread,
            markersPoints,
            tempPointNumber,
            chainagePoints;
        tempPointNumber = 0;
        var locations = {};
        var coordinateList = [];
        var markerList = [];
        var chainageList = [];
        var assetPoints = [];
        var iconSize = 20;
        var disVal = 0;
        var mappedAssetTemp = {};
        var cyclePolylines = [];
        var minCostPolylines = [];
        var anomalyPolylines = [];
        var moreThan10KmPolylines = [];
        vm.ringSize = [];
        vm.tempStoreNodes = [];
        vm.SpreadDataDuplicateCheck = [];
        vm.storeSpreadresponse = [];
        vm.routeFixedAssets = [];
        vm.totalLength = 0;
        vm.assetsLoaded = true;
        for (var i = 2; i <= 15; i++) {
            vm.ringSize.push({ name: i });
        }
        vm.displayRingDetails = "false";
        vm.popupMenuShow = true;
        vm.importkmlexisting = "false";
        vm.selectedAssetsToHighlightMultiRing = [];
        var markers = []
        var editPathMarkers = [];
        $scope.type = {
            block: {
                search: "Search",
                nothingSelected: "Block Filter",
                selectAll: "All",
                selectNone: "None",
                Done: "Done",
            },
        };

        vm.selectedAssetId = null;

        // Method to select an asset and highlight the row
        vm.selectAsset = function (asset) {
            if (vm.selectedAssetId === asset.id) {
                // If clicking the same row, unselect it (toggle)
                vm.selectedAssetId = null;
            } else {
                // Set the selected asset id
                vm.selectedAssetId = asset.id;
            }
        };
        if (!vm.trRoute.id) {
            vm.trRoute.routePoints = [];
            vm.isSaving = true;

            vm.trRoute.status = "NEW";
        }

        function steps() {
            var back = jQuery(".prev");
            var next = jQuery(".next");
            var steps = jQuery(".step");

            if (vm.trRoute.id) {
                steps.splice(1, 1);
            }

            next.bind("click", function () {
                jQuery.each(steps, function (i) {
                    if (
                        !jQuery(steps[i]).hasClass("current") &&
                        !jQuery(steps[i]).hasClass("done")
                    ) {
                        jQuery(steps[i]).addClass("current");
                        jQuery(steps[i - 1])
                            .removeClass("current")
                            .addClass("done");
                        return false;
                    }
                });
            });
            back.bind("click", function () {
                jQuery.each(steps, function (i) {
                    if (
                        jQuery(steps[i]).hasClass("done") &&
                        jQuery(steps[i + 1]).hasClass("current")
                    ) {
                        jQuery(steps[i + 1]).removeClass("current");
                        jQuery(steps[i]).removeClass("done").addClass("current");
                        return false;
                    }
                });
            });
        }
        function initPage() {
            TrProject.query(
                {
                    page: 0,
                    size: 300,
                    sort: sort(),
                },
                onSuccess,
                onError
            );

            function sort() {
                var result = [vm.predicate + "," + (vm.reverse ? "asc" : "desc")];
                if (vm.predicate !== "id") {
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.projects = data;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        $scope.label = {
            assetTypeLabel: {
                search: "Search",
                nothingSelected: "Select Asset Type",
            },
            ringSizeLabel: {
                search: "Search",
                nothingSelected: "Ring Topology Size",
            },
        };

        function myOption(zoom, center) {
            var myOptions;
            return (myOptions = {
                zoom: zoom,
                center: center,
                scaleControl: true,
                disableDoubleClickZoom: true,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                styles: [
                    {
                        featureType: "poi",
                        elementType: "labels.icon",
                        stylers: [
                            {
                                color: "#63666A",
                            },
                        ],
                    },
                    {
                        elementType: "labels.text.fill",
                        stylers: [
                            {
                                color: "#63666A",
                            },
                        ],
                    },
                    {
                        featureType: "transit",
                        elementType: "labels.icon",
                        stylers: [
                            {
                                color: "#63666A",
                            },
                        ],
                    },
                    {
                        featureType: "road",
                        elementType: "labels.icon",
                        stylers: [{ visibility: "off" }],
                    },
                    {
                        featureType: "landscape",
                        stylers: [
                            {
                                color: "#efefef",
                            },
                        ],
                    },
                    {
                        featureType: "road.highway",
                        elementType: "geometry",
                        stylers: [
                            {
                                color: "#ffffff",
                            },
                        ],
                    },
                ],
            });
        }

        var latlngs = new google.maps.LatLng(
            $rootScope.DEFAULT_LATITUDE,
            $rootScope.DEFAULT_LONGITUDE
        );

        if ($scope.tab == 1) {


            vm.toggleFirst = true;
            vm.toggleSecond = false;
            vm.toggleThird = false;

            if (vm.trRoute.id != null) {
                vm.hideUser = false;
            }

            UserGroupIDs.getAll(function (response) {
                vm.multigroup = response;
                response.forEach(function (val) {
                    if (val.name == "Planning Group") {
                        val.ticked = true;
                    }
                });
            });

            UserAccount.get(function (data) {
                vm.userId = data.id;
                data.authorities.find(function (val) {
                    if (val == "ROLE_PLAN_ADMIN" || val == "ROLE_ROLLOUT_ADMIN") {
                        vm.phaseAccess = false;
                    }
                });
            });

            AllAssetsTypes.getAll(function (response) {
                vm.storeAssetTypes = response.length ? response : null;

                vm.types = [];
                vm.types.push({ id: CHAINAGE_ID, name: "CHAINAGE" });
                vm.types.push({ id: MARKER_ID, name: "MARKER" });
                vm.types.push({ id: COORDINATE_ID, name: "COORDINATE" });

                vm.tempAssetDetail = null;
                vm.assetTypeResponse = [];

                response.filter(function (eachElement) {
                    if (eachElement.layout == "SPREAD") {
                        vm.assetTypeResponse.push(eachElement);
                    }

                    if (eachElement.name == "Planned Route") {
                        vm.tempAssetDetail = eachElement;
                    }
                });
                response.forEach(function (assettype) {
                    if (assettype.layout == "FIXED") {
                        assettype.icon =
                            '<img  src="' +
                            assettype.imagePath +
                            '"style="width: 24px; height: 24px;">';
                    } else {
                        assettype.icon = "";
                    }
                    vm.assetType.push(assettype);
                });
            });

        }

        $scope.isSet = function (tabNum) {
            return $scope.tab === tabNum;
        };

        $scope.setTab = function (newTab) {
            $scope.tab = newTab;
            $scope.search = "";

            if ($scope.tab == 1) {
                vm.toggleFirst = true;
                vm.toggleSecond = false;
                vm.toggleThird = false;

            } else if ($scope.tab == 2) {
                $scope.tabTable = 10;
                callAssetLink();
                vm.routePayload = {
                    status: "NEW",
                    routeBundleId: vm.trRoute.id,
                    routeBundleName: vm.trRoute.name,
                    phase: "PLANNING",
                    name: null,
                    assets: [],
                    projectId: vm.trRoute.projectId,
                };
				vm.getRouteSections();
                $scope.isShowMinCost = false;
                $scope.isShowMinCostText = "Show";

                $scope.isAnomaly = false;
                $scope.isAnomalyText = "Show";

                vm.ringSize.forEach(function (item) {
                    item.ticked = false;
                });

                vm.toggleFirst = false;
                vm.toggleSecond = true;
                vm.toggleThird = false;
                initPlanningMap();

                drawExistingkmlImports(locations.map);

                if (coordinatesSpread) {
                    locations.map.setCenter(coordinatesSpread[0]);

                    var polyline = new google.maps.Polyline({
                        path: coordinatesSpread,
                        geodesic: true,
                        strokeColor: "#FD7A24",
                        strokeOpacity: 1.0,
                        strokeWeight: 3,
                    });

                    // Set the map to display the polyline
                    polyline.setMap(locations.map);
                }

                if (chainagePoints) {
                    locations.map.setCenter(chainagePoints[0]);
                    chainagePoints.forEach(function (each) {
                        var marker = new google.maps.Marker({
                            position: { lat: each.lat, lng: each.lng },
                            map: locations.map,
                            icon: {
                                scaledSize: new google.maps.Size(iconSize, iconSize),
                                url: "content/images/chainagePoints.png",
                                anchor: new google.maps.Point(iconSize / 2, iconSize / 2),
                                labelOrigin: new google.maps.Point(25, 22),
                            },
                        });
                    });
                }

                vm.minCostTotalLength = 0;
                vm.routePlanningTotalLength = 0;
                vm.connectedLength = 0;

                vm.mappedAssetsList = [];
                callAssetsRouteByID(vm.trRoute.id, null);
                if (vm.storeRingPolylines.length) {
                    for (var i = 0; i < vm.storeRingPolylines.length; i++) {
                        vm.storeRingPolylines[i].polyline.setMap(null);
                    }
                }
                if (storeRingOptions.length) {
                    if (storeRingOptions.length) {
                        storeRingOptions.forEach(function (item) {
                            vm.mappedAssetsList.unshift(item);
                            vm.onChangeTopology(item);
                        });
                    }
                }

                vm.newOFCLength = 0;
                vm.ExistingUsed = 0;
                vm.ExistingUnused = 0;
                routeDetail.getNewAssetLengthByRouteBundleId(vm.trRoute.id, function (response) {
                    if (response !== null) {
                        vm.newOFCLength = response;
                    }

                });

                routeDetail.getexistingUnusedLengthByRouteBundleId(vm.trRoute.id, function (response) {
                    if (response !== null) {
                        vm.ExistingUnused = response;
                    }
                });

                routeDetail.getexistingUsedLengthByRouteBundleId(vm.trRoute.id, function (response) {
                    if (response !== null) {
                        vm.ExistingUsed = response;
                    }
                });


            } else if ($scope.tab == 3) {
                if (vm.storeRingPolylines.length) {
                    for (var i = 0; i < vm.storeRingPolylines.length; i++) {
                        vm.storeRingPolylines[i].polyline.setMap(null);
                    }
                }
                $scope.isShowMinCost = false;
                $scope.isShowMinCostText = "Show";
                $scope.isAnomaly = false;
                $scope.isAnomalyText = "Show";

                vm.toggleFirst = false;
                vm.toggleSecond = false;
                vm.toggleThird = true;
                var totalCost = 0;
                var totalPowerBudget = 0;
                var totalFiberDistance = 0.0;
                vm.mappedAssetsList.forEach(function (asset) {
                    if (asset.id == null) {
                        //asset.routeId = vm.trRoute.id;
                        asset.routeBundleId = vm.trRoute.id;
                        Asset.save(asset, onSaveSuccess, onSaveError);
                    }
                });

                assetsDeployedMap = new google.maps.Map(
                    document.getElementById("map_canvas_deployed"),
                    myOption(11, latlngs)

                );

                drawExistingkmlImports(assetsDeployedMap);

                if (coordinatesSpread) {
                    assetsDeployedMap.setCenter(coordinatesSpread[0]);

                    var polyline = new google.maps.Polyline({
                        path: coordinatesSpread,
                        geodesic: true,
                        strokeColor: "#FD7A24",
                        strokeOpacity: 1.0,
                        strokeWeight: 3,
                    });

                    // Set the map to display the polyline
                    polyline.setMap(assetsDeployedMap);
                }

                if (chainagePoints) {
                    assetsDeployedMap.setCenter(chainagePoints[0]);
                    chainagePoints.forEach(function (each) {
                        var marker = new google.maps.Marker({
                            position: { lat: each.lat, lng: each.lng },
                            map: assetsDeployedMap,
                            icon: {
                                scaledSize: new google.maps.Size(iconSize, iconSize),
                                url: "content/images/chainagePoints.png",
                                anchor: new google.maps.Point(iconSize / 2, iconSize / 2),
                                labelOrigin: new google.maps.Point(25, 22),
                            },
                        });
                    });
                }

                vm.mappedAssetsList = vm.mappedAssetsList.filter(function (item) {
                    return item.id != "True";
                });
                iterateMappedAssetsList(assetsDeployedMap, vm.mappedAssetsList);

                if (vm.mappedAssetsList.length > 0) {
                    vm.trRoute.pinLat =
                        vm.mappedAssetsList[0].assetCoordinates[0].latitude;
                    vm.trRoute.pinLong =
                        vm.mappedAssetsList[0].assetCoordinates[0].longitude;
                    vm.trRoute.address = "";
                    if (vm.trRoute.id == null) {
                        vm.trRoute.status = "NEW";
                    }
                }
                if (vm.mappedAssetsList.length > 0) {
                    assetsDeployedMap.setCenter(
                        new google.maps.LatLng(
                            vm.mappedAssetsList[0].assetCoordinates[0].latitude,
                            vm.mappedAssetsList[0].assetCoordinates[0].longitude
                        )
                    );
                }
            } else if ($scope.tab == 4) {
                if (vm.storeRingPolylines.length) {
                    for (var i = 0; i < vm.storeRingPolylines.length; i++) {
                        vm.storeRingPolylines[i].polyline.setMap(null);
                    }
                }

                locations.importMap = new google.maps.Map(
                    document.getElementById("map_import_planning"),
                    myOption(10, latlngs)
                );
                var legend = document.createElement("div");
                legend.id = "map-legend";
                legend.style.position = "absolute";
                legend.style.background = "#f3f3f3";
                legend.style.padding = "4px";
                legend.style.border = "1px solid rgb(204, 204, 204)";
                legend.style.fontFamily = "Arial, sans-serif";
                legend.style.borderRadius = "5px";
                legend.style.boxShadow = "1px 1px 1px 0px";
                legend.style.color = "black";

                // Using string concatenation instead of template literals
                legend.innerHTML =
                    '<div style="display: flex; align-items: center;">' +
                    '<div style="display: flex; align-items: center; margin-right: 15px;">' +
                    '<div style="width: 12px; height: 12px; background: #ff0025; margin-right: 5px;"></div>' +
                    '<span>NEW</span>' +
                    '</div>' +
                    '<div style="display: flex; align-items: center;">' +
                    '<div style="width: 12px; height: 12px; background: #00A36C; margin-right: 5px;"></div>' +
                    '<span>EXISTING</span>' +
                    '</div>' +
                    '</div>';

                locations.importMap.controls[google.maps.ControlPosition.BOTTOM_LEFT].push(legend);

                if (coordinatesSpread) {
                    locations.importMap.setCenter(coordinatesSpread[0]);

                    var polyline = new google.maps.Polyline({
                        path: coordinatesSpread,
                        geodesic: true,
                        strokeColor: "#FD7A24",
                        strokeOpacity: 1.0,
                        strokeWeight: 3,
                    });

                    // Set the map to display the polyline
                    polyline.setMap(locations.importMap);
                }

                if (chainagePoints) {
                    locations.importMap.setCenter(chainagePoints[0]);
                    chainagePoints.forEach(function (each) {
                        var marker = new google.maps.Marker({
                            position: { lat: each.lat, lng: each.lng },
                            map: locations.importMap,
                            icon: {
                                scaledSize: new google.maps.Size(iconSize, iconSize),
                                url: "content/images/chainagePoints.png",
                                anchor: new google.maps.Point(iconSize / 2, iconSize / 2),
                                labelOrigin: new google.maps.Point(25, 22),
                            },
                        });
                    });
                }

                vm.optimalTotalLength = 0;
                for (var i = 0; i < vm.mappedAssetsListImport.length; i++) {
                    if (vm.mappedAssetsListImport[i].assetType.layout == "FIXED") {
                        drawMarkers(vm.mappedAssetsListImport[i], locations.importMap, i);
                    } else if (
                        vm.mappedAssetsListImport[i].assetType.layout == "SPREAD"
                    ) {
                        if (vm.mappedAssetsListImport[i].assetCoordinates) {
                            var assetCoordinateValues = [];
                            vm.mappedAssetsListImport[i].assetCoordinates.forEach(function (
                                each
                            ) {
                                assetCoordinateValues.push({
                                    lat: each.latitude,
                                    lng: each.longitude,
                                    id: each.id,
                                });
                            });
                        }

                        var tmpColor = "#00A36C"; //var tmpColor = "red";
                        if (vm.mappedAssetsListImport[i].isCycle) {
                            tmpColor = "#FFD700";
                            // } else if (!vm.mappedAssetsListImport[i].isConnected) {
                        } else if (!vm.mappedAssetsListImport[i].isExisting) {
                            tmpColor = "#ff0025"; //tmpColor = "blue";
                        }

                        if(!vm.mappedAssetsListImport[i].isUsed && vm.mappedAssetsListImport[i].isExisting){
                            tmpColor = "#FFAE42"
                        }
                        // assetCoordinateValues.sort(function (a, b) {
                        //     return a.id - b.id; // Ascending order
                        // });
                        if (assetCoordinateValues[0].sortOrder != null) {
                            assetCoordinateValues.sort(function (a, b) {
                                return a.sortOrder - b.sortOrder; // Ascending order
                            });
                            // } else {
                            //     assetCoordinateValues.sort(function (a, b) {
                            //         return a.id - b.id; // Ascending order
                            //     });
                        }

                        if (!vm.mappedAssetsListImport[i].isCycle) {
                            drawPolyLines(
                                vm.mappedAssetsListImport[i],
                                tmpColor,
                                assetCoordinateValues,
                                locations.importMap
                            );
                        }

                    }
                }

                if (vm.mappedAssetsListImport.length > 0) {
                    var len = Math.floor(vm.mappedAssetsListImport.length / 2);
                    locations.importMap.setCenter(
                        new google.maps.LatLng(
                            vm.mappedAssetsListImport[len].assetCoordinates[0].latitude,
                            vm.mappedAssetsListImport[len].assetCoordinates[0].longitude
                        )
                    );
                }
            }
        };

        vm.processing = function () {
            vm.isDisableNext = true;
            vm.showSaveButton = false;

            vm.mappedAssetsList.forEach(function (assetVal) {
                if (assetVal.assetType.layout == "SPREAD") {
                    var fromFixedAsset = vm.mappedAssetsList.find(function (asset) {
                        return asset.name === assetVal.connectedNode1;
                    });
                    var toFixedAsset = vm.mappedAssetsList.find(function (asset) {
                        return asset.name === assetVal.connectedNode2;
                    });

                    assetVal.userId = vm.userId;
                    assetVal.ownedBy = [];

                    if (assetVal.isConnected == null) {
                        assetVal.isConnected = false;
                    }

                    assetVal.mappedAssets = [];
                    if (fromFixedAsset) {
                        assetVal.mappedAssets.push(fromFixedAsset);
                    }
                    if (toFixedAsset) {
                        assetVal.mappedAssets.push(toFixedAsset);
                    }
                    var assetCoordinatesValues = assetVal.assetCoordinates;
                    var assetCoordinatesSort = [];
                    for (var index = 0; index < assetCoordinatesValues.length; index++) {
                        var assetCoorByIndex = assetCoordinatesValues[index];
                        assetCoorByIndex.sortOrder = index;
                        assetCoordinatesSort.push(assetCoorByIndex);
                    }
                    assetVal.assetCoordinates = assetCoordinatesSort;
                    storeAssets.push(assetVal);
                }
            });
            var uniqueAssets = storeAssets.reduce(function (acc, asset) {
                var existingAsset = null;

                for (var i = 0; i < acc.length; i++) {
                    if (acc[i].name === asset.name) {
                        existingAsset = acc[i];
                        break;
                    }
                }

                if (!existingAsset || (asset["min-cost"] === true && !existingAsset["min-cost"])) {
                    acc = acc.filter(function (a) { return a.name !== asset.name; });
                    acc.push(asset);
                }

                return acc;
            }, []);
            RouteBundleByID.postBulkAssets(vm.trRoute.id, uniqueAssets, function () {

                vm.labelSaveNext = "Next";
                vm.isDisableNext = false;
                vm.updateProgress = 1;

            });
        };

        function handleTabClick($event) {
            $event.preventDefault();
            $event.stopImmediatePropagation();
        }

        function clearCreateAsset() {
            $("#create-asset").removeClass("in");
            $(".modal-backdrop").remove();
            $("#create-asset").hide();
        }

        vm.isShowRefresh = true;
        function createAssetModal(item) {
            vm.isShowRefresh = false;
            vm.assetNameVal = null;
            vm.tempItem = item;
            vm.assetExisting = false;
            if (item.name == "LINK_WITH_MH") {
                connectMultipleAssets();
            } else {
                vm.CreateAssetName = item.name;
                vm.getLocationCoordinate = null;
                $("#create-asset").show();
                createAssetData = item;
                vm.showAssetName = false;
            }
        }

        function getConsolidatedAssetTypeAttributeValue(assetType) {
            var assetTypeAttributeValuesList = [];

            for (var index in assetType.assetTypeAttributes) {
                var assetTypeAttribute1 = assetType.assetTypeAttributes[index];
                assetTypeAttributeValuesList.push({
                    assetTypeAttribute: assetTypeAttribute1,
                    attributeValue: assetType.assetTypeAttributes[index].defaultValue,
                });
            }

            assetTypeAttributeValuesList.sort(function (a, b) {
                var nameA = a.assetTypeAttribute.name.toLowerCase(),
                    nameB = b.assetTypeAttribute.name.toLowerCase();
                if (nameA < nameB)
                    // sort string ascending
                    return -1;
                if (nameA > nameB) return 1;
                return 0; // default return value (no sorting)
            });
            return assetTypeAttributeValuesList;
        }

        function createAsset() {
            var assetName = vm.assetNameVal;
            vm.assetExisting = false;
            var coOrdinate = [];
            if (marker != null) {
                marker.setMap(null);
            }

            if (assetName && assetName.length > 2) {
                if (!isAssetAvailable(assetName)) {
                    iterateMappedAssetsList(locations.map, vm.mappedAssetsList);
                    mappedAssetTemp = {};
                    mappedAssetTemp.name = assetName;
                    mappedAssetTemp.inGraph = true;
                    mappedAssetTemp.assetColor = "BLUE";
                    mappedAssetTemp.transparency = null;
                    mappedAssetTemp.lineWidth = null;
                    mappedAssetTemp.healthIndicator = null;
                    mappedAssetTemp.healthRemarks = null;
                    mappedAssetTemp.burried = null;
                    mappedAssetTemp.minCost = null;
                    mappedAssetTemp.phase = "PLANNING";
                    mappedAssetTemp.description = assetName;
                    mappedAssetTemp.assetType = createAssetData;
                    mappedAssetTemp.routeBundleId= vm.trRoute.id
                    var date = new Date();
                    mappedAssetTemp.createDate = date.getTime();
                    mappedAssetTemp.assetTypeAttributeValues = getConsolidatedAssetTypeAttributeValue(
                        createAssetData
                    );
                    mappedAssetTemp.isConnected = false;
                    mappedAssetTemp.isExisting = false;
                    mappedAssetTemp.isUsed = false;
                    if (createAssetData.layout == "SPREAD") {
                        drawingManagerSpread();
                        drawingManagerValue("polylinecomplete", locations.map, false);
                    } else if (createAssetData.layout == "FIXED") {
                        if (vm.getLocationCoordinate) {
                            vm.fixedArray = [];
                            var coordinates = {};
                            var latlng = vm.getLocationCoordinate.split(",");
                            coordinates.latitude = latlng[0];
                            coordinates.longitude = latlng[1];
                            vm.fixedArray.push(coordinates);
                            mappedAssetTemp.assetCoordinates = vm.fixedArray;
                            addMappedAssets(mappedAssetTemp);
                            vm.isShowing = false;
                            initPlanningMap();
                            for (var i = 0; i < vm.mappedAssetsList.length; i++) {
                                if (vm.mappedAssetsList[i].assetType.layout == "FIXED") {
                                    drawMarkers(vm.mappedAssetsList[i], locations.map, i);
                                } else if (
                                    vm.mappedAssetsList[i].assetType.layout == "SPREAD"
                                ) {
                                    if (vm.mappedAssetsList[i].assetCoordinates) {
                                        var assetCoordinateValues = [];
                                        vm.mappedAssetsList[i].assetCoordinates.forEach(function (
                                            each
                                        ) {
                                            assetCoordinateValues.push({
                                                lat: each.latitude,
                                                lng: each.longitude,
                                                id: each.id,
                                            });
                                        });
                                    }

                                    var tmpColor = "#00A36C"; //var tmpColor = "red";
                                    if (vm.mappedAssetsList[i].isCycle) {
                                        tmpColor = "#FFD700";
                                        // } else if (!vm.mappedAssetsList[i].isConnected) {
                                    } else if (!vm.mappedAssetsList[i].isExisting) {
                                        tmpColor = "#ff0025"; //tmpColor = "blue";
                                    }

                                    if(!vm.mappedAssetsList[i].isUsed && vm.mappedAssetsList[i].isExisting){
                                        tmpColor = "#FFAE42";
                                    }
                                    // assetCoordinateValues.sort(function (a, b) {
                                    //     return a.id - b.id; // Ascending order
                                    // });
                                    if (assetCoordinateValues[0].sortOrder != null) {
                                        assetCoordinateValues.sort(function (a, b) {
                                            return a.sortOrder - b.sortOrder; // Ascending order
                                        });
                                        // } else {
                                        //     assetCoordinateValues.sort(function (a, b) {
                                        //         return a.id - b.id; // Ascending order
                                        //     });
                                    }

                                    drawPolyLines(
                                        vm.mappedAssetsList[i],
                                        tmpColor,
                                        assetCoordinateValues,
                                        locations.map
                                    );


                                }
                            }
                            var centerlatlng = {
                                lat: parseFloat(latlng[0]),
                                lng: parseFloat(latlng[1]),
                            };
                            locations.map.setCenter(centerlatlng);
                        } else {
                            drawingManagerFixed();
                            drawingManagerValue("click", locations.map);
                        }
                    }
                } else {
                    initPlanningMap();
                    for (var i = 0; i < vm.mappedAssetsList.length; i++) {
                        if (vm.mappedAssetsList[i].assetType.layout == "FIXED") {
                            createMarkerForSelectedAsset(
                                vm.mappedAssetsList[i],
                                locations.map
                            );
                        } else if (vm.mappedAssetsList[i].assetType.layout == "SPREAD") {
                            var assetCoordinateValues =
                                vm.mappedAssetsList[i].assetCoordinates;
                            drawPolylineForGeneratedLoc(
                                vm.mappedAssetsList[i],
                                assetCoordinateValues,
                                locations.map,
                                "yellow"
                            );
                        }
                    }
                }

                drawExistingkmlImports(locations.map);

                if (storeRingOptions.length) {
                    storeRingOptions.forEach(function (item) {
                        vm.onChangeTopology(item);
                    });
                }
                $("#create-asset").removeClass("in");
                $(".modal-backdrop").remove();
                $("#create-asset").hide();
            }
        }

        function drawExistingkmlImports(map) {
            if (
                vm.trRoute.id &&
                vm.trRoute.routePoints != null &&
                vm.trRoute.routePoints.length
            ) {
                vm.isShowing = false;
                vm.trRoute.routePoints.forEach(function (each) {
                    if (each.routePointType == "COORDINATE") {
                        coordinateList.push({ lat: each.latitude, lng: each.longitude });
                    } else if (each.routePointType == "MARKER") {
                        markerList.push({ lat: each.latitude, lng: each.longitude });
                    } else if (each.routePointType == "CHAINAGE") {
                        chainageList.push({ lat: each.latitude, lng: each.longitude });
                    }
                });

                if (coordinateList.length) {
                    map.setCenter(coordinateList[0]);
                    var polyline = new google.maps.Polyline({
                        path: coordinateList,
                        geodesic: true,
                        strokeColor: "#FD7A24",
                        strokeOpacity: 1.0,
                        strokeWeight: 3,
                    });

                    // Set the map to display the polyline
                    polyline.setMap(map);
                }

                if (markerList.length) {
                    map.setCenter(markerList[0]);
                    createMarkers(markerList, "content/images/markersPoint.png", map);
                }

                if (chainageList.length) {
                    map.setCenter(chainageList[0]);
                    createMarkers(chainageList, "content/images/chainagePoints.png", map);
                }
            }
        }
        function initPlanningMap() {
            if ($scope.tab == 4) {
                vm.getCenter = locations.importMap.center;
                vm.currentZoom1 = locations.importMap.getZoom();
            } else if ($scope.tab == 2) {
                vm.getCenter = locations.map.center;
                vm.currentZoom1 = locations.map.getZoom();
            }

            locations.map = new google.maps.Map(
                document.getElementById("map_canvas_planning"),
                myOption(vm.currentZoom1, vm.getCenter)

            );
            var legend = document.createElement("div");
            legend.id = "map-legend";
            legend.style.position = "absolute";
            legend.style.background = "#f3f3f3";
            legend.style.padding = "4px";
            legend.style.border = "1px solid rgb(204, 204, 204)";
            legend.style.fontFamily = "Arial, sans-serif";
            legend.style.borderRadius = "5px";
            legend.style.boxShadow = "1px 1px 1px 0px";
            legend.style.color = "black";

            // Using string concatenation instead of template literals
            legend.innerHTML =
                '<div style="display: flex; align-items: center;">' +
                '<div style="display: flex; align-items: center; margin-right: 15px;">' +
                '<div style="width: 12px; height: 12px; background: #ff0025; margin-right: 5px;"></div>' +
                '<span>NEW</span>' +
                '</div>' +
                '<div style="display: flex; align-items: center;">' +
                '<div style="width: 12px; height: 12px; background: #00A36C; margin-right: 5px;"></div>' +
                '<span>EXISTING</span>' +
                '</div>' +
                '</div>';

            locations.map.controls[google.maps.ControlPosition.BOTTOM_LEFT].push(legend);
            var drawingManager = new google.maps.drawing.DrawingManager({
                drawingMode: null,
                drawingControl: true,
                drawingControlOptions: {
                    position: google.maps.ControlPosition.TOP_CENTER,
                    drawingModes: [google.maps.drawing.OverlayType.POLYGON],
                },
                polygonOptions: {
                    fillColor: "#ff0000",
                    fillOpacity: 0.2,
                    strokeWeight: 2,
                    clickable: true,
                    editable: true,
                    zIndex: 1,
                },
            });

            drawingManager.setMap(locations.map);

            function isPointInPolygon(point, polygon) {
                var paths = polygon.getPath();
                return google.maps.geometry.poly.containsLocation(point, polygon);
            }

            function isAssetInPolygon(asset, polygon) {
                return asset.assetCoordinates.some(function (coordinate) {
                    var point = new google.maps.LatLng(coordinate.latitude, coordinate.longitude);
                    return isPointInPolygon(point, polygon);
                });
            }

            google.maps.event.addListener(drawingManager, "overlaycomplete", function (event) {
                if (event.type === "polygon") {
                    var polygon = event.overlay;

                    // Filter assets inside the polygon
                    vm.selectedAssets = [];
                    for (var i = 0; i < vm.mappedAssetsList.length; i++) {
                        var asset = vm.mappedAssetsList[i];
                        if (isAssetInPolygon(asset, polygon)) {
                            vm.selectedAssets.push(asset);
                        }
                    }

                    vm.totalLengthPolygon = 0;
                    for (var j = 0; j < vm.selectedAssets.length; j++) {
                        var asset = vm.selectedAssets[j];
                        vm.addAssetToRingStack(asset);
                        vm.highlightSelectedSpan(asset);
                    }
                    event.overlay.setMap(null);
                }
            });

            var toggleMenuButton = document.getElementById("togglePopup");
            var popup = document.getElementById("popupMenu");
            popup.style.display = "block";
            vm.isSidebarVisible = true;
            toggleMenuButton.addEventListener("click", function () {
                if (popup.style.display === "block" || popup.style.display === "") {
                    popup.style.display = "none";
                    vm.popupMenuShow = false;
                } else {
                    popup.style.display = "block";
                    vm.popupMenuShow = true;
                }
            });

            geoLocation(locations.map);

            google.maps.event.addListener(locations.map, "dblclick", function () {
                if (vm.tempItem) {
                    createAssetModal(vm.tempItem);
                }
            });

        }

        function geoLocation(map) {
            var goTo = document.createElement("button");
            goTo.setAttribute("title", "Location Coordinates");
            goTo.classList.add("custom-map-control-button");
            var gotoIcon = document.createElement("i");
            gotoIcon.classList.add("fa");
            gotoIcon.classList.add("fa-location-arrow");
            gotoIcon.classList.add("geo");
            goTo.appendChild(gotoIcon);
            map.controls[google.maps.ControlPosition.RIGHT_TOP].push(goTo);
            goTo.addEventListener("click", function () {
                vm.getLocationCoordinates = null;
                gotoLatitute();
            });
        }

        function refreshPage() {
            $scope.isAnomaly = false;
            $scope.isAnomalyText = "Show";

            $scope.isShowMinCost = false;
            $scope.isShowMinCostText = "Show";

            if (marker != null) {
                marker.setMap(null);
            }

            initPlanningMap();

            if (coordinatesSpread) {
                locations.map.setCenter(coordinatesSpread[0]);

                var polyline = new google.maps.Polyline({
                    path: coordinatesSpread,
                    geodesic: true,
                    strokeColor: "#FD7A24",
                    strokeOpacity: 1.0,
                    strokeWeight: 3,
                });

                // Set the map to display the polyline
                polyline.setMap(locations.map);
            }

            if (chainagePoints) {
                locations.map.setCenter(chainagePoints[0]);
                chainagePoints.forEach(function (each) {
                    var marker = new google.maps.Marker({
                        position: { lat: each.lat, lng: each.lng },
                        map: locations.map,
                        icon: {
                            scaledSize: new google.maps.Size(iconSize, iconSize),
                            url: "content/images/chainagePoints.png",
                            anchor: new google.maps.Point(iconSize / 2, iconSize / 2),
                            labelOrigin: new google.maps.Point(25, 22),
                        },
                    });
                });
            }

            drawExistingkmlImports(locations.map);

            vm.selectedAssetsToHighlightMultiRing = [];
            angular.forEach(vm.ringRouteAssets, function (asset) {
                asset.isOption = false;
            });
            vm.routeFixedAssets = [];
            vm.sectionAssetDetails = [];
            vm.sectionAssetCount = [];
            vm.minCostTotalLength = 0;
            vm.routePlanningTotalLength = 0;
            vm.connectedLength = 0;
            iterateMappedAssetsList(locations.map, vm.mappedAssetsList);

            if (storeRingOptions.length) {
                storeRingOptions.forEach(function (item) {
                    vm.onChangeTopology(item);
                });
            }
        }

        function showZoomLocation() {
            var latlng = vm.getLocationCoordinates.split(","),
                gotoMarker = null;
            if (gotoMarker != null) {
                gotoMarker.setMap(null);
            }

            if (vm.getLocationCoordinates != null) {
                var assetCenterLatLng = {
                    lat: parseFloat(latlng[0]),
                    lng: parseFloat(latlng[1]),
                };

                locations.map.setCenter(assetCenterLatLng);
                locations.map.setZoom(14);
                var startMarker = new google.maps.Marker({
                    map: locations.map,
                    position: assetCenterLatLng,
                });

                gotoMarker = startMarker;
                $("#modalLatLongs").removeClass("in");
                $(".modal-backdrop").remove();
                $("#modalLatLongs").hide();
            }
        }
        function gotoLatitute() {
            $("#modalLatLongs").show();
        }

        function closeGotoLatitute(id) {
            $("#" + id).removeClass("in");
            $(".modal-backdrop").remove();
            $("#" + id).hide();
        }

        function getPointsRoute(assetA, assetB, map, dist) {
            var pointA = new google.maps.LatLng(
                assetA.assetCoordinates[0].latitude,
                assetA.assetCoordinates[0].longitude
            );
            var pointB = new google.maps.LatLng(
                assetB.assetCoordinates[0].latitude,
                assetB.assetCoordinates[0].longitude
            );

            var directionsService = new google.maps.DirectionsService();

            directionsService.route(
                {
                    origin: pointA,
                    destination: pointB,
                    travelMode: google.maps.TravelMode.DRIVING,
                },
                function (response, status) {
                    if (status == google.maps.DirectionsStatus.OK) {
                        var route = response.routes[0];
                        var az = 0;
                        for (var i = 0; i < route.legs.length; ++i) {
                            if (route.legs[i].distance) {
                                az += route.legs[i].distance.value;
                            }
                        }
                        dist = Math.max(dist, Math.round(az / 100));
                        var markerPoints = gMilestone(route, dist);
                        var polylinePathPoints = gMilestone(route, 100);
                        var responsePaths = response.routes;
                        vm.spreadArray = [];
                        var overViewPath = route.overview_path;
                        polylinePathPoints.forEach(function (value, index) {
                            var coordinates = {};
                            coordinates.latitude = value.lat();
                            coordinates.longitude = value.lng();
                            vm.spreadArray.push(coordinates);
                        });
                        var newLinkAsset = {};
                        newLinkAsset.name = assetA.name + " To " + assetB.name;
                        newLinkAsset.description = newLinkAsset.name;
                        newLinkAsset.assetCoordinates = vm.spreadArray;
                        newLinkAsset.assetType = vm.linkAssetType.assetType;
                        var fiberDistance = 0.0;
                        var spreadCoordinates = newLinkAsset.assetCoordinates;
                        if (spreadCoordinates.length > 0) {
                            for (var index in spreadCoordinates) {
                                if (index > 0) {
                                    fiberDistance += distanceCal(
                                        spreadCoordinates[index].latitude,
                                        spreadCoordinates[index].longitude,
                                        spreadCoordinates[index - 1].latitude,
                                        spreadCoordinates[index - 1].longitude
                                    );
                                }
                            }
                        }
                        fiberDistance = fiberDistance.toFixed(2);
                        var spreadAV = vm.linkAssetType.assetTypeAttributeValues;
                        for (
                            var spreadAssetIndex = 0;
                            spreadAssetIndex < spreadAV.length;
                            spreadAssetIndex++
                        ) {
                            if (
                                spreadAV[spreadAssetIndex].assetTypeAttribute.name ===
                                "Fiber Distance (km)"
                            ) {
                                spreadAV[spreadAssetIndex].attributeValue = fiberDistance;
                            }
                        }
                        newLinkAsset.assetTypeAttributeValues = spreadAV;
                        newLinkAsset.isChecked = true;
                        vm.tempLinkWithPits.push(newLinkAsset);
                        markerPoints.forEach(function (point, index) {
                            var newManholeAsset = {};
                            newManholeAsset.name =
                                assetA.name + " To " + assetB.name + " Pit" + (index + 1);
                            newManholeAsset.description = newManholeAsset.name;
                            newManholeAsset.assetType = vm.manholeAssetType.assetType;
                            newManholeAsset.assetTypeAttributeValues =
                                vm.manholeAssetType.assetTypeAttributeValues;
                            vm.fixedArray = [];
                            var coordinates = {};
                            coordinates.latitude = point.lat();
                            coordinates.longitude = point.lng();
                            vm.fixedArray.push(coordinates);
                            newManholeAsset.assetCoordinates = vm.fixedArray;
                            newManholeAsset.isChecked = true;
                            vm.tempLinkWithPits.push(newManholeAsset);
                        });
                        for (var i = 0; i < vm.tempLinkWithPits.length; i++) {
                            if (vm.tempLinkWithPits[i].assetType.layout == "FIXED") {
                                createMarkerForSelectedAsset(vm.tempLinkWithPits[i], map);
                            } else if (vm.tempLinkWithPits[i].assetType.layout == "SPREAD") {
                                var assetCoordinateValues =
                                    vm.tempLinkWithPits[i].assetCoordinates;
                                drawPolylineForGeneratedLoc(
                                    vm.tempLinkWithPits[i],
                                    assetCoordinateValues,
                                    map,
                                    "yellow"
                                );
                            }
                        }
                    } else {
                        window.alert("Directions request failed due to " + status);
                    }
                }
            );
        }

        function saveLinkPits() {
            vm.tempLinkWithPits.forEach(function (asset) {
                vm.mappedAssetsList.push(asset);
            });
            hideConnectMultipleAssetsModal();
        }
        function gMilestone(route, dist) {
            var path = route.overview_path;
            var geo = google.maps.geometry.spherical;
            var point = path[0];
            var distance = 0;
            var overflow = null;
            var pos = null;
            var leg = null;
            var pointsPosition = [];
            var d1 = 0;

            for (var p = 1; p < path.length; ++p) {
                leg = Math.round(geo.computeDistanceBetween(point, path[p]));
                d1 = distance + 0;
                distance += leg;
                overflow = dist - (d1 % dist);

                if (distance >= dist && leg >= overflow) {
                    if (overflow && leg >= overflow) {
                        pos = geo.computeOffset(
                            point,
                            overflow,
                            geo.computeHeading(point, path[p])
                        );
                        pointsPosition.push(pos);
                        distance -= dist;
                    }

                    while (distance >= dist) {
                        pos = geo.computeOffset(
                            point,
                            dist + overflow,
                            geo.computeHeading(point, path[p])
                        );
                        pointsPosition.push(pos);
                        distance -= dist;
                    }
                }
                point = path[p];
            }
            return pointsPosition;
        }

        function createMarkerForSelectedAsset(asset, map) {
            if (asset.assetCoordinates.length > 0) {
                var myLatLng = {
                    lat: parseFloat(asset.assetCoordinates[0].latitude),
                    lng: parseFloat(asset.assetCoordinates[0].longitude),
                };
                var iconSize = 24;
                var marker = new google.maps.Marker({
                    position: myLatLng,
                    map: map,
                    icon: {
                        scaledSize: new google.maps.Size(iconSize, iconSize),
                        url: asset.assetType.imagePath,
                        anchor: new google.maps.Point(iconSize / 2, iconSize / 2),
                        labelOrigin: new google.maps.Point(24, 0),
                    }
                });
            }
        }

        function createMarkerForSiteAsset(asset, map) {
            if (asset.assetCoordinates.length > 0) {
                var myLatLng = {
                    lat: parseFloat(asset.assetCoordinates[0].latitude),
                    lng: parseFloat(asset.assetCoordinates[0].longitude),
                };
                if (asset.assetType.name == "Manhole") {
                    var iconSize = 4;
                    var marker = new google.maps.Marker({
                        position: myLatLng,
                        map: map,
                        icon: {
                            scaledSize: new google.maps.Size(iconSize, iconSize),
                            url: "content/images/green_circle.png",
                            anchor: new google.maps.Point(iconSize / 2, iconSize / 2),
                        },
                    });
                } else {
                    var marker = new google.maps.Marker({
                        position: myLatLng,
                        map: map,
                        icon: "http://maps.google.com/mapfiles/ms/icons/yellow-dot.png"
                    });
                }
            }
        }

        function drawPolylineForGeneratedLoc(asset, latlngsToDraw, map, color) {
            var spreadAssetCoordinates = [];

            latlngsToDraw.forEach(function (value) {
                spreadAssetCoordinates.push({
                    lat: value.latitude,
                    lng: value.longitude,
                });
            });

            if (asset.assetType.name == "GP") {
                asset.assetTypeAttributeValues.forEach(function (value, index) {
                    if (value.assetTypeAttribute.name == "GP Status") {
                        if (value.attributeValue == "Not Connected") {
                            asset.isConnected = false;
                        }
                    }
                });
            }

            if (spreadAssetCoordinates.length > 0) {

                var ColorValue = "red";
                // if (!asset.isConnected) {
                if (!asset.isExisting) {
                    ColorValue = "blue";
                }

                if (asset.isCycle) {
                    ColorValue = "#FFD700";
                }
                // spreadAssetCoordinates.sort(function (a, b) {
                //     return a.id - b.id; // Ascending order
                // });
                if (spreadAssetCoordinates[0].sortOrder != null) {
                    spreadAssetCoordinates.sort(function (a, b) {
                        return a.sortOrder - b.sortOrder; // Ascending order
                    });
                    // } else {
                    //     spreadAssetCoordinates.sort(function (a, b) {
                    //         return a.id - b.id; // Ascending order
                    //     });
                }
                var polylinepath = new google.maps.Polyline({
                    path: spreadAssetCoordinates,
                    geodesic: true,
                    strokeColor: ColorValue,
                    strokeOpacity: 1.0,
                    strokeWeight: 2.5,
                    fillOpacity: 0.3,
                    editable: false,
                });

                polylinepath.setMap(map);

            }
        }

        function drawingManagerSpread() {
            vm.drawingManager = new google.maps.drawing.DrawingManager({
                drawingMode: google.maps.drawing.OverlayType.POLYLINE,
                drawingControl: true,
                drawingControlOptions: {
                    position: google.maps.ControlPosition.TOP_CENTER,
                    drawingModes: ["polyline"],
                },
                polylineOptions: {
                    fillColor: "#ffff00",
                    fillOpacity: 1,
                    strokeWeight: 5,
                    clickable: true,

                    editable: true,
                    zIndex: 1,
                    geodesic: true,
                },
            });
        }

        function drawingManagerFixed() {
            vm.drawingManager = new google.maps.drawing.DrawingManager({
                drawingMode: google.maps.drawing.OverlayType.MARKER,
                drawingControl: true,
                drawingControlOptions: {
                    position: google.maps.ControlPosition.TOP_CENTER,
                    drawingModes: ["marker"],
                },
            });
        }

        function drawingManagerValue(option, map, isEdit) {
            if (option == "polylinecomplete") {
                vm.isShowing = false;
                google.maps.event.addListener(
                    vm.drawingManager,
                    option,
                    function (event) {
                        google.maps.event.addListener(
                            event.getPath(),
                            "insert_at",
                            function () {
                                setGoefenceCoordinate(event, isEdit);
                            }
                        );
                        google.maps.event.addListener(
                            event.getPath(),
                            "set_at",
                            function (path) {
                                setGoefenceCoordinate(event, isEdit);
                            }
                        );
                        vm.drawingManager.setOptions({
                            drawingControl: false,
                        });
                        vm.drawingManager.setMap(null);
                        setGoefenceCoordinate(event, isEdit);
                        if (mappedAssetTemp.assetType.layout == "SPREAD") {
                            var fiberDistance = 0.0;
                            var spreadCoordinates = mappedAssetTemp.assetCoordinates;
                            if (spreadCoordinates.length > 0) {
                                for (var index in spreadCoordinates) {
                                    if (index > 0) {
                                        fiberDistance += distanceCal(
                                            spreadCoordinates[index].latitude,
                                            spreadCoordinates[index].longitude,
                                            spreadCoordinates[index - 1].latitude,
                                            spreadCoordinates[index - 1].longitude
                                        );
                                    }
                                }
                            }
                            fiberDistance = fiberDistance.toFixed(2);
                            mappedAssetTemp.assetLength = parseFloat(fiberDistance);
                            vm.routePlanningTotalLength += parseFloat(fiberDistance);
                            var spreadAV = mappedAssetTemp.assetTypeAttributeValues;
                            for (
                                var spreadAssetIndex = 0;
                                spreadAssetIndex < spreadAV.length;
                                spreadAssetIndex++
                            ) {
                                if (
                                    spreadAV[spreadAssetIndex].assetTypeAttribute.name ===
                                    "Fiber Distance (km)"
                                ) {
                                    spreadAV[spreadAssetIndex].attributeValue = fiberDistance;
                                }
                            }
                            mappedAssetTemp.assetTypeAttributeValues = spreadAV;
                        }
                        addMappedAssets(mappedAssetTemp);
                    }
                );
                vm.drawingManager.setMap(map);
            } else if (option == "click") {
                vm.isShowing = false;
                marker = new google.maps.Marker({
                    position: location,
                    map: map,
                });

                google.maps.event.addListener(map, "click", function (e) {
                    placeMarker(e.latLng, map);
                    vm.fixedArray = [];
                    var coordinates = {};
                    coordinates.latitude = e.latLng.lat();
                    coordinates.longitude = e.latLng.lng();
                    vm.fixedArray.push(coordinates);
                    mappedAssetTemp.assetCoordinates = vm.fixedArray;
                    addMappedAssets(mappedAssetTemp);
                });
            }
        }

        function placeMarker(location, map) {
            if (marker) {
                if (location.lat != null && location.lng != null) {
                    marker.setPosition(location);
                }
            } else {
                marker = new google.maps.Marker({
                    position: location,
                    map: map,
                });
            }
        }

        function addMappedAssets(newAsset) {
            if (!isAssetAvailable(newAsset.name)) {
                newAsset.isChecked = true;
                // vm.mappedAssetsList.push(newAsset);
                Asset.save(newAsset, function(response){
					newAsset.id = response.id;
					vm.mappedAssetsList.push(newAsset);
					initPlanningMap();
					iterateMappedAssetsList(locations.map, vm.mappedAssetsList);
				});

            }
        }

        function isAssetAvailable(assetName) {
            var isAssetAvailable = false;

            vm.mappedAssetsList.forEach(function (assetVal) {
                if (assetVal.name === assetName) {
                    isAssetAvailable = true;
                }
            });
            return isAssetAvailable;
        }

        function deleteAssetModal(name, id) {
            $("#delete-asset").show();
            deleteAssetName = name;
            vm.assetId = id;
        }

        function confirmDeleteAsset() {
            if (vm.assetId && (vm.trRoute.id || vm.trRoute.tempId)) {
                AssetDeleteByID.delete(vm.assetId, function () { });
            }

            var assetArray = vm.mappedAssetsList;
            for (var i = assetArray.length - 1; i >= 0; --i) {
                if (assetArray[i].name == deleteAssetName) {
                    vm.deletedAssetsList.push(assetArray[i]);
                    vm.routePlanningTotalLength -= assetArray[i].assetLength;
                    assetArray.splice(i, 1);
                }
            }

            for (var i = vm.tempCycleAssets.length - 1; i >= 0; --i) {
                if (vm.tempCycleAssets[i].name == deleteAssetName) {
                    vm.tempCycleAssets.splice(i, 1);
                }
            }

            vm.mappedAssetsList = [];
            assetArray.forEach(function (asset) {
                vm.mappedAssetsList.push(asset);
            });

            initPlanningMap();

            drawExistingkmlImports(locations.map);

            locations.map.setCenter(vm.getCenter);
            locations.map.setZoom(vm.currentZoom1);

            iterateMappedAssetsList(locations.map, vm.mappedAssetsList);

            if (storeRingOptions.length) {
                storeRingOptions.forEach(function (item) {
                    vm.onChangeTopology(item);
                });
            }
            $("#delete-asset").hide();
        }

        function cleardeleteAsset() {
            $("#delete-asset").removeClass("in");
            $(".modal-backdrop").remove();
            $("#delete-asset").hide();
        }

        function setGoefenceCoordinate(event, isEdit) {
            vm.assetCoordinateValues = [];
            var tempAsset = {};
            tempAsset.assetCoordinates = [];
            var radius = event.getPath();
            for (var i = 0; i < radius.getLength(); i++) {
                var coordinates = {};
                coordinates.latitude = radius.getAt(i).lat();
                coordinates.longitude = radius.getAt(i).lng();
                tempAsset.assetCoordinates.push(coordinates);
            }
            if (isEdit) {
                vm.asset.assetCoordinates = tempAsset.assetCoordinates;
            } else {
                mappedAssetTemp.assetCoordinates = tempAsset.assetCoordinates;
                mappedAssetTemp.routeBundleId = vm.trRoute.id
                    ? vm.trRoute.id
                    : vm.trRoute.tempId;
                (mappedAssetTemp.userId = vm.userId), (mappedAssetTemp.ownedBy = []);
            }
        }

        function saveEditAsset() {
            var rId = vm.trRoute.id ? vm.trRoute.id : vm.trRoute.tempId;

            if (vm.assetId && rId) {
                var temp = vm.storeAssetTypes.find(function (item) {
                    return item.name == vm.asset.assetType.name;
                });
                vm.asset.assetType = temp;
                /* vm.asset.assetTypeAttributeValues = getConsolidatedAssetTypeAttributeValue(
                     temp
                 );*/
                // vm.asset.routeId = rId;
                vm.asset.routeBundleId = rId;
                var assetCoordinatesValues = vm.asset.assetCoordinates;
                var assetCoordinatesSort = [];
                for (var index = 0; index < assetCoordinatesValues.length; index++) {
                    var assetCoorByIndex = assetCoordinatesValues[index];
                    assetCoorByIndex.sortOrder = index;
                    assetCoordinatesSort.push(assetCoorByIndex);
                }
                vm.asset.assetCoordinates = assetCoordinatesSort;
                (vm.asset.userId = vm.userId), (vm.asset.ownedBy = []);
                var fixedAssets = [];
                for (var i = 0; i < vm.mappedAssetsList.length; i++) {
                    if (vm.mappedAssetsList[i].assetType.layout == "FIXED") {
                        fixedAssets.push(vm.mappedAssetsList[i]);
                    }
                }
                if (vm.asset.assetCoordinates.length > 1) {
                    var firstCoord = vm.asset.assetCoordinates[0];
                    var lastCoord = vm.asset.assetCoordinates[vm.asset.assetCoordinates.length - 1];
                
                    var minFirstDist = 20; // meters
                    var minLastDist = 20; // meters
                
                    var nearestFirst = null;
                    var nearestLast = null;
                
                    for (var i = 0; i < fixedAssets.length; i++) {
                        var mappedAssetCoor = fixedAssets[i].assetCoordinates[0];
                        if(mappedAssetCoor){
                        var mappedLat = mappedAssetCoor.latitude;
                        var mappedLon = mappedAssetCoor.longitude;
                        }
                
                        var distToFirst = getDistanceMeters(firstCoord.latitude, firstCoord.longitude, mappedLat, mappedLon);
                        if (distToFirst <= minFirstDist) {
                            minFirstDist = distToFirst;
                            nearestFirst = mappedAssetCoor;
                        }
                
                        var distToLast = getDistanceMeters(lastCoord.latitude, lastCoord.longitude, mappedLat, mappedLon);
                        if (distToLast <= minLastDist) {
                            minLastDist = distToLast;
                            nearestLast = mappedAssetCoor;
                        }
                    }
                
                    if (nearestFirst) {
                        firstCoord.latitude = nearestFirst.latitude;
                        firstCoord.longitude = nearestFirst.longitude;
                    }
                
                    if (nearestLast) {
                        lastCoord.latitude = nearestLast.latitude;
                        lastCoord.longitude = nearestLast.longitude;
                    }
                    if (firstCoord != null && firstCoord != undefined) {
                        vm.asset.assetCoordinates[0].latitude = firstCoord.latitude;
                        vm.asset.assetCoordinates[0].longitude = firstCoord.longitude;
                    }
                    if (lastCoord != null && lastCoord != undefined) {
                        vm.asset.assetCoordinates[vm.asset.assetCoordinates.length - 1].latitude = lastCoord.latitude;
                        vm.asset.assetCoordinates[vm.asset.assetCoordinates.length - 1].longitude = lastCoord.longitude;
                    }

                }


                Asset.update(vm.asset, function (response) { 
                vm.mappedAssetsList.find(function(asset){
                  if(asset.id==response.id){
                    asset.assetCoordinates=[]
                    asset.assetCoordinates=response.assetCoordinates
                   }
                   })
                   vm.asset = [];
                   hideUserEditModal();
                   initPlanningMap();
                   iterateMappedAssetsList(locations.map, vm.mappedAssetsList);
                   if (storeRingOptions.length) {
                       storeRingOptions.forEach(function (item) {
                           vm.onChangeTopology(item);
                       });
                   }
                });
            }
            // vm.mappedAssetsList = [];
            // vm.tempAssetArray.forEach(function (assetVal) {
            //     if (vm.assetId == assetVal.id) {
            //         assetVal.isChecked = true;
            //         var spreadCoordinates = assetVal.assetCoordinates;
            //         var fiberDistance = 0;
            //         for (var index in spreadCoordinates) {
            //             if (index > 0) {
            //                 fiberDistance += distanceCal(
            //                     spreadCoordinates[index].latitude,
            //                     spreadCoordinates[index].longitude,
            //                     spreadCoordinates[index - 1].latitude,
            //                     spreadCoordinates[index - 1].longitude
            //                 );
            //             }
            //         }
            //         vm.routePlanningTotalLength -= assetVal.assetLength;
            //         assetVal.assetLength = fiberDistance.toFixed(2);
            //         vm.routePlanningTotalLength += parseFloat(fiberDistance.toFixed(2));
            //     }
            //     vm.mappedAssetsList.push(assetVal);
            // });
       
        }

        // Helper to calculate distance between two lat/lon points in meters
        function getDistanceMeters(lat1, lon1, lat2, lon2) {
            var R = 6371000; // Radius of Earth in meters
            var dLat = (lat2 - lat1) * Math.PI / 180;
            var dLon = (lon2 - lon1) * Math.PI / 180;
            var a = 
                Math.sin(dLat/2) * Math.sin(dLat/2) +
                Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
                Math.sin(dLon/2) * Math.sin(dLon/2);
            var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
            return R * c;
        }


        function hideUserEditModal() {
            $("#userPathModal").removeClass("in");
            $(".modal-backdrop").remove();
            $("#userPathModal").hide();
        }
        vm.assetattributevaluesDisplay = [];
        function editAsset(asset) {
            for (var i = 0; i < editPathMarkers.length; i++) {
                editPathMarkers[i].setMap(null);
            }
            vm.tempAssetArray = [];

            vm.mappedAssetsList.forEach(function (assetVal) {
                vm.tempAssetArray.push(assetVal);
            });
            for (var i = 0; i >= vm.tempAssetArray.length; --i) {
                if (vm.tempAssetArray[i].name == asset.name) {
                    vm.tempAssetArray.splice(i, 1);
                }
            }

            vm.asset = asset;
            vm.assetId = asset.id;
            var maplatlng = {
                lat: parseFloat(asset.assetCoordinates[0].latitude),
                lng: parseFloat(asset.assetCoordinates[0].longitude),
            };
            editAssetMap = new google.maps.Map(
                document.getElementById("map_canvas_edit_asset"),
                myOption(13, maplatlng)
            );

            if (asset.assetType.layout == "SPREAD") {
                drawingManagerSpread();
                drawingManagerValue("polylinecomplete", editAssetMap);
            } else if (asset.assetType.layout == "FIXED") {
                drawingManagerFixed();
                drawingManagerValue("click", editAssetMap);
            }

            editPathMarkers = [];
            for (var i = 0; i < vm.mappedAssetsList.length; i++) {
               if(vm.mappedAssetsList[i].assetCoordinates[0]){
                if (vm.mappedAssetsList[i].assetType.layout == "FIXED") {
                    (function(asset){
                    var myLatLng = {
                        lat: parseFloat(vm.mappedAssetsList[i].assetCoordinates[0].latitude),
                        lng: parseFloat(vm.mappedAssetsList[i].assetCoordinates[0].longitude),
                    };

                    var marker = new google.maps.Marker(
                        {
                            position: myLatLng,
                            map: editAssetMap,
                            label: vm.mappedAssetsList[i].name,
                            icon: {
                                scaledSize: new google.maps.Size(24, 24),
                                url: vm.mappedAssetsList[i].assetType.imagePath,
                                anchor: new google.maps.Point(
                                    12, 24
                                ),
                                labelOrigin: new google.maps.Point(25, 40),
                            },
                        });
                    marker.setLabel({
                        color: "black",
                        fontWeight: "bold",
                        fontSize: "12px",
                        text: vm.mappedAssetsList[i].name,
                    });

                    var contentString =
                        '<div class="infoWindowhead">' +
                        asset.id +
                        "<br><b>Name </b> : " +
                        asset.name +
                        '</div><div class="infoWindowContent">' +
                        "<b>Asset Type </b> : " +
                        asset.assetType.name +
                        "<br><b>Latitude </b> : " +
                        asset.assetCoordinates[0].latitude +
                        "<br><b>Longitude </b> : " +
                        asset.assetCoordinates[0].longitude +
                        "<br></div>";

                    var infoWindow = new google.maps.InfoWindow({
                        content: contentString,
                    });

                    google.maps.event.addListener(marker, "click", function () {
                        infoWindow.open(editAssetMap, marker);
                    });


                    editPathMarkers.push(marker);
                })(vm.mappedAssetsList[i])
                }
               }
            }
            if (asset.name && asset.name != null) {
                if (asset.assetType.layout == "SPREAD") {
                    drawPolyline(function (polyline) {
                        polyline.setMap(editAssetMap);
                        google.maps.event.addListener(
                            polyline.getPath(),
                            "insert_at",
                            function () {
                                setGoefenceCoordinate(polyline, true);
                            }
                        );
                        google.maps.event.addListener(
                            polyline.getPath(),
                            "set_at",
                            function (path) {
                                setGoefenceCoordinate(polyline, true);
                            }
                        );

                        vm.drawingManager.setOptions({
                            drawingControl: false,
                        });
                        vm.drawingManager.setMap(null);
                    });
                } else if (asset.assetType.layout == "FIXED") {
                    setValues();
                    drawingManagerFixed();
                    drawMarker(editAssetMap, vm.coOrdinate);
                }
 
                function drawPolyline(callback) {
                    setValues();
                    var centerlatlng = {};
                    if (vm.coOrdinates.length > 1) {
                        vm.coOrdinates.forEach(function (value) {
                            centerlatlng = {
                                lat: value.lat,
                                lng: value.lng,
                            };
                        });
                        if(vm.coOrdinates[0].sortOrder!=null){
                            vm.coOrdinates.sort(function (a, b) {
                                return a.sortOrder - b.sortOrder;
                            });
                        }

                        callback(
                            new google.maps.Polyline({
                                path: vm.coOrdinates,
                                geodesic: true,
                                strokeColor: vm.asset.assetType.colorcode,
                                strokeOpacity: 0.8,
                                strokeWeight: 2,
                                fillColor: vm.asset.assetType.colorcode,
                                fillOpacity: 0.3,
                                editable: true,
                            })
                        );
                        editAssetMap.setCenter(centerlatlng);
                    }
                }
            }
            var ele = document.getElementById("userPathModal");
            $(ele).modal("show");
            $("#userPathModal").show();

            $("#location-map-edit").css("width", "100%");
            $("#map_canvas_edit_asset").css("width", "100%");
        }

        function hideConnectAssetsModal() {
            $("#connectAssetsModal").removeClass("in");
            $(".modal-backdrop").remove();
            $("#connectAssetsModal").hide();
        }

        function hideConnectSitesModal() {
            $("#connectAssetsModal").hide();
        }

        var input = document.getElementById("field_pinLat");
        input.addEventListener("input", function () {
            this.value = this.value.replace(/[^-0-9\,\.]/, "");
        });

        $(".select2").select2();

        $("#toAssetsView").select2({
            dropdownParent: $("#connectAssetsModal"),
        });
        $("#spreadType").select2({
            dropdownParent: $("#connectAssetsModal"),
        });
        $("#fromAssetsView").select2({
            dropdownParent: $("#connectAssetsModal"),
        });
        $("#ringDropdown").select2({
            dropdownParent: $("#ringTopology"),
        });
        $("#assettypeDropdown").select2({
            dropdownParent: $("#importKml"),
            width: '100%'
        });

        Configs.get("Phases", function (response) {
            vm.workFlowPhase = []; // Response need to be changed
            vm.workFlowPhase.push({ id: "PLANNING", configKey: "PLANNING" });
            vm.workFlowPhase.push({ id: "PROPOSED", configKey: "PROPOSED" });
            vm.workFlowPhase.push({ id: "ROLLOUT", configKey: "ROLLOUT" });
            vm.workFlowPhase.push({ id: "MAINTENANCE", configKey: "MAINTENANCE" });
        });

        Configs.get("RolloutTaskStatus", function (response) {
            vm.rolloutTaskStatus = response;
        });

        function connectSelectedAssets() {
            locations.mapConnect = new google.maps.Map(
                document.getElementById("map_canvas_connect_assets"),
                myOption(14, latlngs)
            );
            $("#fromAssetsView").val(null).trigger("change.select2");
            $("#toAssetsView").val(null).trigger("change.select2");
            $("#spreadType").val(null).trigger("change.select2");

            vm.connectTwoAssets = vm.mappedAssetsList.filter(function (item) {
                return item.id != "True" && item.assetType.layout == "FIXED";
            });
            var ele = document.getElementById("connectAssetsModal");
            $(ele).modal("show");
            $("#connectAssetsModal").show();
            $("#location-map-edit").css("width", "100%");
            $("#map_canvas_connect_assets").css("width", "100%");
        }

        function hideConnectMultipleAssetsModal() {
            $("#connectMultipleAssetsModal").removeClass("in");
            $(".modal-backdrop").remove();
            $("#connectMultipleAssetsModal").hide();
            vm.tempLinkWithPits = [];
            initPlanningMap();
            for (var i = 0; i < vm.mappedAssetsList.length; i++) {
                if (vm.mappedAssetsList[i].assetType.layout == "FIXED") {
                    createMarkerForSelectedAsset(vm.mappedAssetsList[i], locations.map);
                } else if (vm.mappedAssetsList[i].assetType.layout == "SPREAD") {
                    var assetCoordinateValues = vm.mappedAssetsList[i].assetCoordinates;
                    drawPolylineForGeneratedLoc(
                        vm.mappedAssetsList[i],
                        assetCoordinateValues,
                        locations.map,
                        "yellow"
                    );
                }
            }
        }

        function connectMultipleAssets() {
            vm.siteAssets = [];
            vm.tempLinkWithPits = [];

            var ele = document.getElementById("connectMultipleAssetsModal");
            $(ele).modal("show");
            $("#connectMultipleAssetsModal").show();
            $("#location-map-edit").css("width", "100%");
            $("#map_canvas_connect_multiple_assets").css("width", "100%");
            var multipleSiteMap = new google.maps.Map(
                document.getElementById("map_canvas_connect_multiple_assets"),
                {
                    center: new google.maps.LatLng(
                        vm.mappedAssetsList[0].assetCoordinates[0].latitude,
                        vm.mappedAssetsList[0].assetCoordinates[0].longitude
                    ),
                    zoom: 12,
                    fullscreenControl: true,
                }
            );
            for (var i = 0; i < vm.mappedAssetsList.length; i++) {
                if (
                    vm.mappedAssetsList[i].assetType.layout == "FIXED" &&
                    vm.mappedAssetsList[i].assetType.name == "Site" &&
                    vm.mappedAssetsList[i].id == null
                ) {
                    vm.siteAssets.push(vm.mappedAssetsList[i]);
                    createMarkerForSiteAsset(vm.mappedAssetsList[i], multipleSiteMap);
                }
            }

            vm.siteAssets.sort(function (assetA, assetB) {
                var assetATime = assetA.createDate,
                    assetBTime = assetB.createDate;
                if (assetATime < assetBTime)
                    // sort string ascending
                    return -1;
                if (assetATime > assetBTime) return 1;
                return 0; // default return value (no sorting)
            });
            for (var siteIndex = 1; siteIndex < vm.siteAssets.length; siteIndex++) {
                getPointsRoute(
                    vm.siteAssets[siteIndex - 1],
                    vm.siteAssets[siteIndex],
                    multipleSiteMap,
                    200
                );
            }
        }

        function recalculate() {
            var totalCost = 0;
            var totalPowerBudget = 0;
            var totalFiberDistance = 0.0;
            for (
                var assetIndex = 0;
                assetIndex < vm.mappedAssetsList.length;
                assetIndex++
            ) {
                var isSpread = false;
                var fiberDistance = 0.0;

                if (vm.mappedAssetsList[assetIndex].assetType.layout == "SPREAD") {
                    isSpread = true;
                    var spreadAV =
                        vm.mappedAssetsList[assetIndex].assetTypeAttributeValues;
                    for (
                        var spreadAssetIndex = 0;
                        spreadAssetIndex < spreadAV.length;
                        spreadAssetIndex++
                    ) {
                        if (
                            spreadAV[spreadAssetIndex].assetTypeAttribute.name ===
                            "Fiber Distance (km)"
                        ) {
                            fiberDistance = parseFloat(
                                "0" + spreadAV[spreadAssetIndex].attributeValue
                            );
                        }
                    }
                }

                for (
                    var attrIndex = 0;
                    attrIndex <
                    vm.mappedAssetsList[assetIndex].assetTypeAttributeValues.length;
                    attrIndex++
                ) {
                    var item =
                        vm.mappedAssetsList[assetIndex].assetTypeAttributeValues[attrIndex];
                    var value = parseFloat(item.assetTypeAttribute.defaultValue);

                    if (item.assetTypeAttribute.name == "Cost") {
                        var tempCost = parseFloat(value);
                        if (isSpread) {
                            tempCost = parseFloat(value) * fiberDistance;
                        }
                        if (tempCost > 0) {
                            totalCost += tempCost;
                        }
                        item.attributeValue = value;
                    }
                    if (item.assetTypeAttribute.name == "Power Budget") {
                        var tempPowerBudget = parseFloat(value);
                        if (isSpread) {
                            tempPowerBudget = parseFloat(value) * fiberDistance;
                        }
                        if (tempPowerBudget > 0) {
                            totalPowerBudget += tempPowerBudget;
                        }
                        item.attributeValue = value;
                    }
                    vm.mappedAssetsList[assetIndex].assetTypeAttributeValues[
                        attrIndex
                    ] = item;
                }
                totalFiberDistance += fiberDistance;
            }
        }

        function connectAssets() {
            if (!vm.isSiteASelected) {
                alert("Please select Site A");
                return;
            }
            if (!vm.isSiteBSelected) {
                alert("Please select Site B");
                return;
            }
            var siteALatLng = new google.maps.LatLng(
                vm.selectedSiteA.assetCoordinates[0].latitude,
                vm.selectedSiteA.assetCoordinates[0].longitude
            );
            var siteBLatLng = new google.maps.LatLng(
                vm.selectedSiteB.assetCoordinates[0].latitude,
                vm.selectedSiteB.assetCoordinates[0].longitude
            );
            var mapOptions = {
                center: siteALatLng,
                zoom: 16,
                fullscreenControl: true,
            };
            var map = new google.maps.Map(
                document.getElementById("map_canvas_connect_assets"),
                mapOptions
            );
            createMarker(map, vm.selectedSiteA.name, siteALatLng);
            createMarker(map, vm.selectedSiteB.name, siteBLatLng);
            var selectedTravelMode =
                document.getElementById("travelMode").value || "DRIVING";
            var fromAssetName = document.getElementById("fromAssetsView").value;
            var toAssetName = document.getElementById("toAssetsView").value;

            if (!fromAssetName || !toAssetName) {
                alert("Please select both Site A and Site B.");
                return;
            }
            var fromAsset = vm.connectTwoAssets.find(function (asset) {
                return asset.name === fromAssetName;
            });
            var toAsset = vm.connectTwoAssets.find(function (asset) {
                return asset.name === toAssetName;
            });

            if (!fromAsset || !toAsset) {
                alert("Selected assets not found.");
                return;
            }
            getShortestRoute(fromAsset, toAsset, map, selectedTravelMode);
        }
        function setValues() {
            vm.coOrdinates = [];
            for (var i = 0; i < vm.asset.assetCoordinates.length; i++) {
                vm.coOrdinates.push({
                    lat: vm.asset.assetCoordinates[i].latitude,
                    lng: vm.asset.assetCoordinates[i].longitude,
                    sortOrder:vm.asset.assetCoordinates[i].sortOrder,
                });
                if (i == vm.asset.assetCoordinates.length - 1) {
                    vm.coOrdinate = JSON.stringify(vm.coOrdinates);
                }
            }
        }

        $("#fromAssetsView").change(function () {
            $("#toAssetsView")[0].selectedIndex = 0;
            var result = $("#fromAssetsView").val();
            if (result != null) {
                for (var i = 0; i < vm.mappedAssetsList.length; i++) {
                    if (vm.mappedAssetsList[i].name == result) {
                        vm.selectedSiteA = vm.mappedAssetsList[i];
                    }
                }
                vm.isSiteASelected = true;
            }
        });

        $("#toAssetsView").change(function () {
            if (vm.isSiteASelected == true) {
                var result = $("#toAssetsView").val();
                if (result != null) {
                    for (var i = 0; i < vm.mappedAssetsList.length; i++) {
                        if (vm.mappedAssetsList[i].name == result) {
                            vm.selectedSiteB = vm.mappedAssetsList[i];
                        }
                    }
                    vm.isSiteBSelected = true;
                }
            } else {
                $("#toAssetsView")[0].selectedIndex = 0;
                alert("Please Select Site A");
            }
        });

        function createMarker(map, assetName, myLatLng) {
            var marker = new google.maps.Marker({
                position: myLatLng,
                map: map,
                icon: {
                    scaledSize: new google.maps.Size(24, 24),
                    origin: new google.maps.Point(0, 0),
                    url: "content/images/yellow.png",
                    anchor: new google.maps.Point(16, 16),
                }
            });
        }

        function drawMarker(map, response) {
            $.each(JSON.parse(response), function (index, value) {
                centerlatlng = {
                    lat: value.lat,
                    lng: value.lng,
                };

                if (marker) {
                    marker.setMap(null);
                }
                marker = new google.maps.Marker({
                    position: centerlatlng,
                    icon: {
                        size: new google.maps.Size(220, 220),
                        scaledSize: new google.maps.Size(32, 32),
                        origin: new google.maps.Point(0, 0),
                        anchor: new google.maps.Point(16, 16),
                    },
                });

                marker.setMap(map);
                vm.fixedArray = [];
                var coordinates = {};
                coordinates.latitude = centerlatlng.lat;
                coordinates.longitude = centerlatlng.lng;
                vm.fixedArray.push(coordinates);
                mappedAssetTemp.assetCoordinates = vm.fixedArray;
            });
        }

        function getShortestRoute(SiteA, SiteB, map, travelMode) {
            var pointA = new google.maps.LatLng(
                SiteA.assetCoordinates[0].latitude,
                SiteA.assetCoordinates[0].longitude
            );
            var pointB = new google.maps.LatLng(
                SiteB.assetCoordinates[0].latitude,
                SiteB.assetCoordinates[0].longitude
            );

            var newAsset = {
                name: "",
                assetCoordinates: [],
            };
            newAsset.name = SiteA.name + " To " + SiteB.name;

            var directionsService = new google.maps.DirectionsService();

            directionsService.route(
                {
                    origin: pointA,
                    destination: pointB,
                    avoidTolls: true,
                    avoidHighways: true,
                    provideRouteAlternatives: true,
                    travelMode: google.maps.TravelMode[travelMode.toUpperCase()],
                },
                function (response, status) {
                    if (status == google.maps.DirectionsStatus.OK) {
                        var responsePaths = response.routes;
                        responsePaths.forEach(function (pathVal, index) {
                            if (index < 3) {
                                vm.fixedArray = [];
                                var route = pathVal;
                                var legs = route.legs;

                                var polylinePathPoints = [];
                                for (var i = 0; i < legs.length; i++) {
                                    var steps = legs[i].steps;
                                    for (var j = 0; j < steps.length; j++) {
                                        var nextSegment = steps[j].path;
                                        for (var k = 0; k < nextSegment.length; k++) {
                                            polylinePathPoints.push(nextSegment[k]);
                                        }
                                    }
                                }
                                vm.fixedArray.push({ lat: SiteA.assetCoordinates[0].latitude, lng: SiteA.assetCoordinates[0].longitude });
                                polylinePathPoints.forEach(function (value) {
                                    var coordinates = {};
                                    coordinates.lat = value.lat();
                                    coordinates.lng = value.lng();
                                    vm.fixedArray.push(coordinates);
                                });
                                vm.fixedArray.push({ lat: SiteB.assetCoordinates[0].latitude, lng: SiteB.assetCoordinates[0].longitude });
                                drawPolylineForSelectedPath(
                                    SiteA.name + " To " + SiteB.name,
                                    vm.fixedArray,
                                    map,
                                    index
                                );
                            }
                        });
                    } else {
                        window.alert("Directions request failed due to " + status);
                    }
                }
            );
            return newAsset;
        }
        function drawPolylineForSelectedPath(
            assetName,
            spreadAssetCoordinates,
            map,
            index
        ) {
            if (spreadAssetCoordinates.length > 0) {
                map.setZoom(14);

                var ColorValue = "#ff0000";
                if (index == 0) {
                    ColorValue = "#ff0000";
                } else if (index == 1) {
                    ColorValue = "#000000";
                } else {
                    ColorValue = "#208000";
                }
                map.setCenter(spreadAssetCoordinates[0])
                var polylinepath = new google.maps.Polyline({
                    path: spreadAssetCoordinates,
                    geodesic: true,
                    strokeColor: ColorValue || "#ff0000",
                    strokeOpacity: 1.0,
                    strokeWeight: 2.5,
                    fillColor: ColorValue,
                    fillOpacity: 0.3,
                    editable: false,
                    zIndex: 2
                });

                polylinepath.setOptions({
                    strokeColor: ColorValue,
                });

                polylinepath.setMap(map);

                google.maps.event.addListener(
                    polylinepath,
                    "mouseover",
                    function (event) {
                        if (openedInfoWindow != null) {
                            openedInfoWindow.close();
                        }
                        var pointContent = document.createElement("div"),
                            button,
                            clearButton;

                        pointContent.innerHTML =
                            '<div class="infoWindowhead">Point ' + (index + 1) + "</div>";
                        button = pointContent.appendChild(document.createElement("input"));
                        button.type = "button";
                        button.value = "Click to select";
                        button.className = "button";
                        clearButton = pointContent.appendChild(document.createElement("input"));
                        clearButton.type = "button";
                        clearButton.value = "Clear";
                        clearButton.className = "button";
                        clearButton.style.marginLeft = "5px";
                        google.maps.event.addDomListener(button, "click", function () {
                            var newAsset = {};
                            newAsset.name = assetName;
                            newAsset.assetCoordinates = [];
                            newAsset.phase = "PLANNING";
                            spreadAssetCoordinates.forEach(function (assetCoor, index) {
                                newAsset.assetCoordinates.push({
                                    latitude: assetCoor.lat,
                                    longitude: assetCoor.lng,
                                    sortOrder: index + 1
                                });
                            });

                            vm.assetTypeResponse.forEach(function (item) {
                                if (item.name == "Planned Route") {
                                    vm.isShowing = false;
                                    newAsset.assetType = item;
                                    newAsset.assetTypeAttributeValues = getConsolidatedAssetTypeAttributeValue(
                                        newAsset.assetType
                                    );
                                    if (newAsset.assetType.layout == "SPREAD") {
                                        var fiberDistance = 0.0;
                                        var spreadCoordinates = newAsset.assetCoordinates;
                                        if (spreadCoordinates.length > 0) {
                                            for (var index in spreadCoordinates) {
                                                if (index > 0) {
                                                    fiberDistance += distanceCal(
                                                        spreadCoordinates[index].latitude,
                                                        spreadCoordinates[index].longitude,
                                                        spreadCoordinates[index - 1].latitude,
                                                        spreadCoordinates[index - 1].longitude
                                                    );
                                                }
                                            }
                                        }
                                        fiberDistance = fiberDistance.toFixed(2);
                                        newAsset.assetLength = parseFloat(fiberDistance);
                                        vm.routePlanningTotalLength += parseFloat(fiberDistance);
                                        $scope.$apply();
                                        var spreadAV = newAsset.assetTypeAttributeValues;
                                        for (
                                            var spreadAssetIndex = 0;
                                            spreadAssetIndex < spreadAV.length;
                                            spreadAssetIndex++
                                        ) {
                                            if (
                                                spreadAV[spreadAssetIndex].assetTypeAttribute.name ===
                                                "Fiber Distance (km)"
                                            ) {
                                                spreadAV[
                                                    spreadAssetIndex
                                                ].attributeValue = fiberDistance;
                                            }
                                        }
                                        newAsset.assetTypeAttributeValues = spreadAV;
                                    }
                                    newAsset.isChecked = true;
                                    newAsset.inGraph = true;
                                    newAsset.block = vm.blockName;
                                    newAsset.state = vm.stateName;
                                    newAsset.district = vm.districtName;
                                    newAsset.routeBundleId = vm.trRoute.id ? vm.trRoute.id: vm.trRoute.tempId;			
                					(newAsset.userId = vm.userId), (newAsset.ownedBy = []);
                                    Asset.save(newAsset, function(response){
									newAsset.id = response.id;
									vm.mappedAssetsList.push(newAsset);
									 initPlanningMap();

                                    for (var i = 0; i < vm.mappedAssetsList.length; i++) {
                                        if (vm.mappedAssetsList[i].assetType.layout == "FIXED") {
                                            drawMarkers(
                                                vm.mappedAssetsList[i],
                                                locations.map,i
                                            );
                                        } else if (
                                            vm.mappedAssetsList[i].assetType.layout == "SPREAD"
                                        ) {
                                            if (vm.mappedAssetsList[i].name == assetName) {
                                                vm.mappedAssetsList[i].isConnected = false;
                                            }

                                            if (vm.mappedAssetsList[i].assetCoordinates) {
                                                var assetCoordinateValues = [];
                                                vm.mappedAssetsList[i].assetCoordinates.forEach(
                                                    function (each, index) {
                                                        assetCoordinateValues.push({
                                                            lat: each.latitude,
                                                            lng: each.longitude,
                                                        });
                                                    }
                                                );
                                            }
                                            var tmpColor = "#00A36C"; //var tmpColor = "red";
                                            if (vm.mappedAssetsList[i].isCycle) {
                                                tmpColor = "#FFD700";
                                                // } else if (!vm.mappedAssetsList[i].isConnected) {
                                            } else if (!vm.mappedAssetsList[i].isExisting) {
                                                tmpColor = "#ff0025"; //tmpColor = "blue";
                                            }

                                            if(!vm.mappedAssetsList[i].isUsed && vm.mappedAssetsList[i].isExisting){
                                                tmpColor = "#FFAE42"
                                            }
                                            // assetCoordinateValues.sort(function (a, b) {
                                            //     return a.id - b.id; // Ascending order
                                            // });
                                            if (assetCoordinateValues[0].sortOrder != null) {
                                                assetCoordinateValues.sort(function (a, b) {
                                                    return a.sortOrder - b.sortOrder; // Ascending order
                                                });
                                                // } else {
                                                //     assetCoordinateValues.sort(function (a, b) {
                                                //         return a.id - b.id; // Ascending order
                                                //     });
                                            }
                                            drawPolyLines(
                                                vm.mappedAssetsList[i],
                                                tmpColor,
                                                assetCoordinateValues,
                                                locations.map
                                            );
                                        }
                                    }
                                })
                                }
                            });

                            vm.ringSize.forEach(function (item) {
                                item.ticked = false;
                            });
                            drawExistingkmlImports(locations.map);
                            hideConnectAssetsModal();
                            vm.refreshPage();
                        });
                        google.maps.event.addDomListener(clearButton, "click", function () {
                            polylinepath.setMap(null);
                            if (openedInfoWindow != undefined) {
                                openedInfoWindow.close();
                            };
                        });

                        var infoWindow2 = new google.maps.InfoWindow({
                            content: pointContent,
                        });
                        infoWindow2.open(map);
                        infoWindow2.setPosition(event.latLng);
                        openedInfoWindow = infoWindow2;
                    }
                );
            }
        }

        function save(bool) {
            vm.isShowing = false;
            vm.trRoute.assets = [];
            vm.trRoute.deletedAssets = [];


            vm.deletedAssetsList.forEach(function (asset) {
                vm.trRoute.deletedAssets.push(asset);
            });

            if (!vm.trRoute.id && (markerList || coordinateList || chainageList)) {
                vm.trRoute.routePoints = (coordinateList || []).concat(
                    markerList || [],
                    chainageList || []
                );
            }


            vm.isShowing = true;
            vm.isSaving = true;

            if (vm.trRoute.tempId || vm.trRoute.id) {
                vm.trRoute.id = vm.trRoute.tempId ? vm.trRoute.tempId : vm.trRoute.id;

                function onMappedAssetsSuccess(data) {
                    if (data.length > 0) {
                        var assets = vm.trRoute.assets;
                        var mappingData = [];
                        data.forEach(function (value) {
                            mappingData.push(value);
                        });

                        // Create a lookup object for assets by ID
                        var assetLookup = {};
                        for (var i = 0; i < assets.length; i++) {
                            var asset = assets[i];
                            assetLookup[asset.id] = asset;
                        }

                        // Create a mapping object for quick lookup of mappedIds by ID
                        var mapping = {};
                        for (var j = 0; j < mappingData.length; j++) {
                            try {
                                var item = mappingData[j];

                                var str = item.mappedIds.slice(1, -1);

                                // Split the string by comma and trim each element
                                var strArray = str.split(",").map(function (element) {
                                    return element.trim();
                                });

                                // Convert each element to a number
                                var numArray = strArray.map(function (element) {
                                    return Number(element);
                                });
                                mapping[item.id] = numArray;
                            } catch (error) {
                                console.error(error);
                            }
                        }

                        // Augment each asset object with its corresponding mappedAssets
                        var mappedAssetsList = assets.map(function (asset) {
                            var mappedIds = mapping[asset.id] || [];
                            var mappedAssetsList = mappedIds.map(function (mappedId) {
                                return assetLookup[mappedId];
                            });
                            // Clone the asset object and add the mappedAssets property
                            var mappedAsset = Object.assign({}, asset, {
                                mappedAssets: mappedAssetsList,
                            });
                            return mappedAsset;
                        });
                        vm.trRoute.assets = mappedAssetsList;
                    }
                }
                onSaveSuccess();
            } else {
                TrRouteBundle.save(
                    vm.trRoute,
                    function (response) {
                        vm.isUpdateProgress = true;
                        if (bool) {
                            vm.updateProgress = 1;
                            assetsLinking.postLinkAsset(
                                {
                                    entityName: "ROUTE",
                                    entityLayout: "SPREAD",
                                    entityTypeId: response.id,
                                    reqByUserId: vm.userId,
                                    messageType: "ASSET_LINK",
                                },
                                function (responseLink) {
                                    vm.trRoute.tempId = response.id;
                                    vm.entityId = responseLink.id;

                                    vm.updateProgress = 12;

                                },
                                function (err) {
                                    clearInterval(vm.assetLinkInterval);
                                }
                            );
                        } else {
                            $state.go("tr-route-plan");
                            vm.isSaving = false;
                        }
                    },
                    onSaveError
                );
            }
        }

        function onSaveSuccess(result) {
            $state.go("tr-route-plan");
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.showRingCreation = false;
        function callAssetLink() {
            assetsLinking.linkAsset(
                function (responseLink) {
                    var temp = responseLink.find(function (item) {
                        return item.entityTypeId == vm.trRoute.id;
                    });

                    if (temp != undefined) {
                        if (temp.messageStatus == "COMPLETE") {
                            vm.showRingCreation = true;
                        }
                    }
                },
                function (err) { }
            );
        }

        function selectedGroup(value) {
            var input = document.getElementById("field_assignedToUser");
            input.value = "";
            vm.hideUser = false;
        }
        function filterActivatedUser() {
            if (
                vm.trRoute.assignedToUser != null &&
                vm.trRoute.assignedToUser != "" &&
                vm.trRoute.assignedToUser != "." &&
                !angular.isUndefined(vm.trRoute.assignedToUser)
            ) {
                $('input[name="assignedToUser"]').keyup(function () {
                    vm.user = $(this).val();
                });
                ActivatedUserSearch.query(
                    {
                        userId: vm.trRoute.groups[0].id,
                        user: vm.user,
                    },
                    onSuccess,
                    onError
                );

                function onSuccess(data, headers) {
                    data.forEach(function (users) {
                        vm.assignedUsers.push(users.login);
                    });
                    vm.activatedusers = data;

                    angular.forEach(vm.activatedusers, function (value, key) {
                        usersMap[value.login] = value.id;
                    });
                }
                function onError(error) {
                    AlertService.error(error.data.message);
                }
            }
        }

        function distanceCal(lat1, lon1, lat2, lon2) {
            var theta = lon1 - lon2;
            var dist =
                Math.sin(degrees_to_radians(lat1)) *
                Math.sin(degrees_to_radians(lat2)) +
                Math.cos(degrees_to_radians(lat1)) *
                Math.cos(degrees_to_radians(lat2)) *
                Math.cos(degrees_to_radians(theta));
            dist = Math.acos(dist);
            dist = radians_to_degrees(dist);
            dist = dist * 60 * 1.1515;
            dist = dist * 1.609344;
            if (isNaN(dist)) {
                return 0.0;
            } else {
                return dist;
            }
        }

        function degrees_to_radians(degrees) {
            var pi = Math.PI;
            return degrees * (pi / 180);
        }

        function radians_to_degrees(radians) {
            var pi = Math.PI;
            return radians * (180 / pi);
        }
        $(document).on("change", "input", function () {
            var dataList = $("datalist");
            if (dataList.length > 0) {
                var options = dataList[0].options;
                for (var i = 0; i < options.length; i++) {
                    if (options[i].value == $(this).val()) {
                        if (vm.assignedUsers.includes($(this).val())) {
                            vm.validUser = false;
                        } else {
                            vm.validUser = true;
                        }
                        break;
                    }
                }
            }
        });

        vm.openImportExcel = function () {
            $(":file").filestyle({
                buttonBefore: true,
                buttonText: "Browse File",
            });

            vm.importxl = /^(.*?)\.(xlsx)$/;
            $("#importExcelFixed").show();
            $(":file").filestyle("clear");
        };

        vm.closeImportExcelFixedModal = function () {
            $("#importExcelFixed").removeClass("in");
            $(".modal-backdrop").remove();
            $("#importExcelFixed").hide();
        }

        vm.openImportKml = function () {
            $(":file").filestyle({
                buttonBefore: true,
                buttonText: "Browse File",
            });

            vm.importkml = /^(.*?)\.(kml)$/;
            $("#importKml").show();
            $(":file").filestyle("clear");
        };

        vm.closeImportKmlModal = function () {
            $("#importKml").removeClass("in");
            $(".modal-backdrop").remove();
            $("#importKml").hide();
        }

        var getFile, formData;
        vm.uploadFixedAssets = function () {
            getFile = document.getElementById("uploadfileAssetFixed").files[0];
            formData = new FormData();
            formData.append("file", getFile);

            FixedAssetExcelUpload.assetupload(
                vm.trRoute.id,
                formData,
                function (response) {
                    storeAssets = [];
                    vm.mappedAssetsList = [];
                    vm.success = response.status == 200 ? "success" : "";
                    if (vm.success) {
                        setTimeout(function () {
                            vm.success = "";
                            vm.closeImportExcelFixedModal();
                            // vm.closeModal("importExcelFixed");
                            vm.isSaving = false;
                        }, 500);
                    }

                    if (response.data.length) {
                        vm.showSaveButton = true;
                        vm.isDisableNext = true;

                        vm.tempStoreNodes = [];
                        vm.storeFixedResponse = response.data;
                        locations.importMap.setCenter({
                            lat: vm.storeFixedResponse[0].assetCoordinates[0].latitude,
                            lng: vm.storeFixedResponse[0].assetCoordinates[0].longitude,
                        });

                        vm.storeFixedResponse.forEach(function (each, index) {
                            each.isChecked = true;
                            each.inGraph = true;
                            each.minCost = true;

                            vm.mappedAssetsList.push(each);
                            vm.mappedAssetsListImport.push(each);

                            if (each.name && each.assetCoordinates) {
                                if (each.assetType.name == "GP") {
                                    each.assetTypeAttributeValues.forEach(function (
                                        value,
                                        index
                                    ) {
                                        if (value.assetTypeAttribute.name == "GP Status") {
                                            if (value.attributeValue == "Not Connected") {
                                                each.isConnected = false;
                                            }
                                        }
                                    });
                                } else {
                                    each.isConnected = true;
                                }
                                if (each.isConnected == null) {
                                    each.isConnected = false;
                                }
                                vm.tempStoreNodes.push({
                                    name: each.name,
                                    assetCoordinates: [
                                        {
                                            latitude: each.assetCoordinates[0].latitude,
                                            longitude: each.assetCoordinates[0].longitude,
                                        },
                                    ],
                                    isConnected: each.isConnected,
                                    assetTypeName: each.assetType.name,
                                    block: each.block,
                                    district: each.district,
                                    state: each.state,
                                    isBlockHQ: each.isBlockHQ,
                                });

                                drawMarkers(each, locations.importMap, index);
                            }
                        });
                    }
                }
            );
        };

        var getKmlFile, formKmlData;
        vm.uploadKmlAssets = function () {
            getKmlFile = document.getElementById("uploadkmlfileAsset").files[0];
            formKmlData = new FormData();
            formKmlData.append("assettype", vm.importkmlassettype.name);
            formKmlData.append("isexisting", vm.importkmlexisting);
            formKmlData.append("routeBundleId", vm.trRoute.id);
            formKmlData.append("file", getKmlFile);

            AssetUpload.assetupload(formKmlData, function (response, headers) {
                if (response.status == 200) {
                    setTimeout(function () {
                        vm.success = "";
                        vm.closeImportKmlModal();
                        // vm.closeModal("importExcelFixed");
                        vm.isSaving = false;
                    }, 1000);
                    if (vm.importkmlassettype.layout == 'FIXED') {


                        if (response.data.length) {
                            vm.showSaveButton = true;
                            vm.isDisableNext = true;


                            vm.storeFixedResponse = response.data;
                            locations.importMap.setCenter({
                                lat: vm.storeFixedResponse[0].assetCoordinates[0].latitude,
                                lng: vm.storeFixedResponse[0].assetCoordinates[0].longitude,
                            });

                            vm.storeFixedResponse.forEach(function (each, index) {
                                each.isChecked = true;
                                each.inGraph = true;
                                each.minCost = true;
                                if (each.assetType.name == "OLT") {
                                    each.isBlockHQ = true;
                                    each.isConnected = true;
                                }
                                vm.mappedAssetsList.push(each);
                                vm.mappedAssetsListImport.push(each);
                                if (each.assetType.name == "GP") {
                                    each.assetTypeAttributeValues.forEach(function (
                                        value,
                                        index
                                    ) {
                                        if (value.assetTypeAttribute.name == "GP Status") {
                                            if (value.attributeValue == "Not Connected") {
                                                each.isConnected = false;
                                            }
                                        }
                                    });
                                } else if (each.assetType.name == "OLT") {
                                    each.isBlockHQ = true;
                                    each.isConnected = true;
                                } else {
                                    each.isConnected = true;
                                }

                                if (each.isConnected == null) {
                                    each.isConnected = false;
                                }
                                each.isConnected = vm.importkmlexisting;
                                if (each.name && each.assetCoordinates) {
                                    vm.tempStoreNodes.push({
                                        name: each.name,
                                        assetCoordinates: [
                                            {
                                                latitude: each.assetCoordinates[0].latitude,
                                                longitude: each.assetCoordinates[0].longitude,
                                            },
                                        ],
                                        isConnected: each.isConnected,
                                        assetTypeName: each.assetType.name,
                                        block: each.block,
                                        district: each.district,
                                        state: each.state,
                                        isBlockHQ: true,
                                    });

                                    drawMarkers(each, locations.importMap, index);
                                }
                            });
                        }
                    } else if (vm.importkmlassettype.layout == 'SPREAD') {
                        if (response.data.length) {
                            vm.showSaveButton = true;
                            vm.isDisableNext = true;

                            // vm.tempStoreNodes = [];
                            vm.storeSpreadresponse = response.data;
                            locations.importMap.setCenter({
                                lat: vm.storeSpreadresponse[0].assetCoordinates[0].latitude,
                                lng: vm.storeSpreadresponse[0].assetCoordinates[0].longitude,
                            });

                            vm.storeSpreadresponse.forEach(function (each, index) {
                                each.isChecked = true;
                                each.inGraph = true;
                                each.minCost = true;
                                vm.mappedAssetsList.push(each);
                                vm.mappedAssetsListImport.push(each);
                                each.isConnected = vm.importkmlexisting;
                                var assetCoor = [];
                                each.assetCoordinates.forEach(function (latlng) {
                                    assetCoor.push({ lat: latlng.latitude, lng: latlng.longitude });
                                });
                                if (each.name && each.assetCoordinates) {
                                    try {
                                        var polyline = new google.maps.Polyline({
                                            path: assetCoor,
                                            geodesic: true,
                                            strokeColor: '#ff0025',
                                            strokeOpacity: 1.0,
                                            strokeWeight: 2
                                        });
                                        polyline.setMap(locations.importMap);
                                        vm.importedSpread.push(polyline);
                                    } catch (error) {
                                        console.log(error);
                                    }

                                }
                            });
                        }
                    }
                }
                if (response.status == 400) {
                    vm.success = null;
                    vm.error = 'error';
                    vm.closeImportKmlModal();
                }
            });
        };

        function addMarker(location, name, isConnected) {
            infowindow.close();
            var markerText;

            if (markersConnect.length == 0) {
                tempObject.source = location;
                tempObject.srcName = name;
                markerText = labelFrom;

            } else if (markersConnect.length == 1) {
                markerText = labelTo;
                tempObject.destination = location;
                tempObject.desName = name;

                callDirectionApi(
                    {
                        source: tempObject.source,
                        destination: tempObject.destination,
                        sourceName: tempObject.srcName,
                        destinationName: tempObject.desName,
                        isConnected: false,
                    },
                    true
                );
            }
            // Create a marker
            var marker = new google.maps.Marker({
                position: location,
                map: locations.map,
                label: {
                    text: markerText,
                },
            });

            // Add the marker to the markers array
            markersConnect.push(marker);
        }

        function clearMarkers() {
            markersConnect.forEach(function (marker) {
                marker.setMap(null);
            });

            // Clear the markers array
            markersConnect = [];
        }

        var directionsService;
        vm.storeDirectionLatlngs = [];
        vm.tempCycleAssets = [];
        directionsService = new google.maps.DirectionsService();
        vm.storeLocations = [];
        var num = 0;
        var tempShortestPath = [];

        vm.showPathsClicked = false;

        vm.showPaths = function () {
            if (!vm.showPathsClicked) {

                getConnectedNodes.postAdjacency(
                    vm.tempStoreNodes,
                    function (response) {
                        if (response.length) {
                            vm.storeLocations = [];
                            response.forEach(function (item) {
                                item.destinationNode.forEach(function (eachDestination) {
                                    var isConnected = false;

                                    if (
                                        item.sourceNode.isConnected &&
                                        eachDestination.isConnected
                                    ) {
                                        isConnected = true;
                                    }
                                    if (vm.storeSpreadresponse.length > 0) {
                                        var storeSpreadFound = false;
                                        for (var i = 0; i < vm.storeSpreadresponse.length; i++) {
                                            var existingSpread = vm.storeSpreadresponse[i].name;
                                            vm.SpreadDataDuplicateCheck.push(existingSpread);
                                            var assetName = existingSpread.split(" TO ");
                                            var assetSourceName = assetName[0];
                                            var assetDestName = assetName[1];
                                            if (
                                                (assetSourceName === item.sourceNode.name && assetDestName === eachDestination.name) ||
                                                (assetSourceName === eachDestination.name && assetDestName === item.sourceNode.name)
                                            ) {
                                                storeSpreadFound = true;
                                                break;
                                            }
                                        }
                                        if (!storeSpreadFound) {
                                            vm.SpreadDataDuplicateCheck.push(item.sourceNode.name + " TO " + eachDestination.name);
                                            vm.storeLocations.push({
                                                source: new google.maps.LatLng(
                                                    item.sourceNode.assetCoordinates[0].latitude,
                                                    item.sourceNode.assetCoordinates[0].longitude
                                                ),
                                                destination: new google.maps.LatLng(
                                                    eachDestination.assetCoordinates[0].latitude,
                                                    eachDestination.assetCoordinates[0].longitude
                                                ),
                                                sourceName: item.sourceNode.name,
                                                destinationName: eachDestination.name,
                                                isConnected: isConnected,
                                                inGraph: true,
                                                minCost: true,
                                                block: item.sourceNode.block,
                                                district: item.sourceNode.district,
                                                state: item.sourceNode.state,
                                            });
                                        }
                                    } else {
                                        vm.storeLocations.push({
                                            source: new google.maps.LatLng(
                                                item.sourceNode.assetCoordinates[0].latitude,
                                                item.sourceNode.assetCoordinates[0].longitude
                                            ),
                                            destination: new google.maps.LatLng(
                                                eachDestination.assetCoordinates[0].latitude,
                                                eachDestination.assetCoordinates[0].longitude
                                            ),
                                            sourceName: item.sourceNode.name,
                                            destinationName: eachDestination.name,
                                            isConnected: isConnected,
                                            inGraph: true,
                                            minCost: true,
                                            block: item.sourceNode.block,
                                            district: item.sourceNode.district,
                                            state: item.sourceNode.state,
                                        });
                                    }

                                });
                            });

                            vm.storeLocations.forEach(function (location) {
                                callDirectionApi1(location);
                            });
                        }
                    });
                vm.showPathsClicked = true;
            }
        };
        vm.showLinerPths = false;
        vm.showLinerPaths = function () {
            if (!vm.showLinerPths) {
                getConnectedNodes.postAdjacency(
                    vm.tempStoreNodes,
                    function (response) {
                        if (response.length) {
                            vm.storePoints = [];
                            response.forEach(function (item) {
                                item.destinationNode.forEach(function (eachDestination) {
                                    var isConnected = false;

                                    if (
                                        item.sourceNode.isConnected &&
                                        eachDestination.isConnected
                                    ) {
                                        isConnected = true;
                                    }

                                    vm.storePoints.push({
                                        source: new google.maps.LatLng(
                                            item.sourceNode.assetCoordinates[0].latitude,
                                            item.sourceNode.assetCoordinates[0].longitude
                                        ),
                                        destination: new google.maps.LatLng(
                                            eachDestination.assetCoordinates[0].latitude,
                                            eachDestination.assetCoordinates[0].longitude
                                        ),
                                        sourceName: item.sourceNode.name,
                                        destinationName: eachDestination.name,
                                        isConnected: isConnected,
                                        inGraph: true,
                                        minCost: true,
                                        block: item.sourceNode.block,
                                        district: item.sourceNode.district,
                                        state: item.sourceNode.state,
                                    });
                                });
                            });
                            vm.storePoints.forEach(function (location) {
                                callDirectionApi2(location);
                            });
                        }
                    });
                vm.showLinerPths = true
            }
        }


        vm.showDirection = function () {
            var OltData = [];
            OltData.push(vm.oltAssetDetails);
            if (!vm.showDirectionClicked && OltData.length > 0) {
                OltData.forEach(function (asset) {
                    getConnectedNodes.postSuggestPlan(asset.name, vm.tempStoreNodes, function (Response) {
                        if (Response.length) {
                            vm.storePlanLocations = [];
                            Response.forEach(function (itemPlan) {
                                if (itemPlan.destinationNode.length) {
                                    itemPlan.destinationNode.forEach(function (eachDestination) {
                                        var found1 = false;
                                        for (var i = 0; i < vm.SpreadDataDuplicateCheck.length; i++) {
                                            var existingLocation = vm.SpreadDataDuplicateCheck[i];
                                            var assetName = existingLocation.split(" TO ");
                                            var assetSourceName = assetName[0];
                                            var assetDestName = assetName[1];
                                            if (
                                                (assetSourceName === itemPlan.sourceNode.name && assetDestName === eachDestination.name) ||
                                                (assetSourceName === eachDestination.name && assetDestName === itemPlan.sourceNode.name)
                                            ) {
                                                found1 = true;
                                                break;
                                            }
                                        }
                                        if (!found1) {
                                            vm.storePlanLocations.push({
                                                source: new google.maps.LatLng(
                                                    itemPlan.sourceNode.assetCoordinates[0].latitude,
                                                    itemPlan.sourceNode.assetCoordinates[0].longitude),
                                                destination: new google.maps.LatLng(
                                                    eachDestination.assetCoordinates[0].latitude,
                                                    eachDestination.assetCoordinates[0].longitude),
                                                sourceName: itemPlan.sourceNode.name,
                                                destinationName: eachDestination.name,
                                                isConnected: false,
                                                inGraph: false,
                                                block: eachDestination.block,
                                                district: eachDestination.district,
                                                state: eachDestination.state,
                                            });

                                        }
                                    });
                                }
                            });
                            vm.storePlanLocations.forEach(function (location) {
                                callDirectionApi1(location, false, false);

                            });



                        }
                    });
                });
                vm.showDirectionClicked = true;
            } else {
                alert("please select  OLT")
            }
        }

        vm.notConnectedPaths = [];
        vm.loactionNot = [];
        vm.dropdownItems = [];
        vm.activeRoutes = [];

        function processDestination(eachDestination, source) {
            if (!eachDestination.assetCoordinates || eachDestination.assetCoordinates.length === 0) {
                return;
            }

            var destinationName = eachDestination.name || "Unknown";
            var destination = {
                name: destinationName,
                lat: parseFloat(eachDestination.assetCoordinates[0].latitude),
                lng: parseFloat(eachDestination.assetCoordinates[0].longitude)
            };

            var locationObj = {
                source: source,
                destination: destination,
                isConnected: false,
                inGraph: true,
                minCost: true,
                block: eachDestination.block,
                district: eachDestination.district,
                state: eachDestination.state
            };
            vm.loactionNot.push(locationObj);

            vm.dropdownItems.push({
                display: source.name + " → " + destination.name,
                source: source,
                destination: destination,
                selected: false
            });
        }
        function processSource(sourceKey, destinations) {
            var sourceNameMatch = sourceKey.match(/name=([^,]+)/);
            var sourceMatch = sourceKey.match(/latitude=([\d.]+), longitude=([\d.]+)/);

            if (!sourceMatch) {
                return; // Skip this source entirely.
            }

            var sourceName = sourceNameMatch ? sourceNameMatch[1].trim() : "Unknown";
            var source = {
                name: sourceName,
                lat: parseFloat(sourceMatch[1]),
                lng: parseFloat(sourceMatch[2])
            };

            if (!destinations || destinations.length === 0) {
                return;
            }

            for (var j = 0; j < destinations.length; j++) {
                processDestination(destinations[j], source);
            }
        }

        vm.showNotConnected = function () {
            if (vm.tempStoreNodes.length > 0) {
                getConnectedNodes.postSuggestNotConnectedPath(vm.trRoute.id, vm.tempStoreNodes, function (response) {
                    if (!response || typeof response !== "object") {
                        return;
                    }
                    if (vm.dropdownItems.length !== 0) {
                        return;
                    }
                    vm.notConnectedPaths = [];
                    for (var key in response) {
                        if (response.hasOwnProperty(key)) {
                            vm.notConnectedPaths.push([key, response[key]]);
                        }
                    }

                    if (vm.notConnectedPaths.length === 0) {
                        return;
                    }

                    vm.loactionNot = [];
                    vm.dropdownItems = [];
                    for (var i = 0; i < vm.notConnectedPaths.length; i++) {
                        var pair = vm.notConnectedPaths[i];
                        var sourceKey = pair[0];
                        var destinations = pair[1];
                        processSource(sourceKey, destinations);
                    }
                });
            }
        };

        vm.showNotConnected();
        vm.clearConnected = function () {
            vm.refreshPage()
        };


        vm.connectSelectedPaths = function () {
            vm.nearByDestination = {}
            vm.nearBySource = {}
            vm.clearConnected();
            for (var i = 0; i < vm.dropdownItems.length; i++) {
                var item = vm.dropdownItems[i];
                if (item.selected) {
                    vm.fetchRoute(item.source, item.destination);
                }
            }
        };

        vm.reverseSelected = function () {
            vm.clearConnected();
            for (var i = 0; i < vm.dropdownItems.length; i++) {
                var item = vm.dropdownItems[i];
                if (item.selected) {
                    vm.fetchRoute(item.destination, item.source);
                }
            }
        };

        vm.fetchRoute = function (source, destination) {
            var request = {
                origin: new google.maps.LatLng(source.lat, source.lng),
                destination: new google.maps.LatLng(destination.lat, destination.lng),
                travelMode: google.maps.TravelMode.DRIVING,
                avoidTolls: true,
                avoidHighways: true,
                provideRouteAlternatives: true
            };

            directionsService.route(request, function (response, status) {
                if (status === google.maps.DirectionsStatus.OK) {
                    var responsePaths = response.routes;
                    responsePaths.forEach(function (pathVal, index) {
                        if (index < 3) {
                            vm.fixedAssets = [];
                            var route = pathVal;
                            var legs = route.legs;

                            var polylinePathPoints = [];
                            for (var i = 0; i < legs.length; i++) {
                                var steps = legs[i].steps;
                                for (var j = 0; j < steps.length; j++) {
                                    var nextSegment = steps[j].path;
                                    for (var k = 0; k < nextSegment.length; k++) {
                                        polylinePathPoints.push(nextSegment[k]);
                                    }
                                }
                            }
                            polylinePathPoints.forEach(function (value) {
                                var coordinates = {};
                                coordinates.lat = value.lat();
                                coordinates.lng = value.lng();
                                vm.fixedAssets.push(coordinates);
                            });
                            drawPolylineForSelectedPath(
                                source.name + " To " + destination.name,
                                vm.fixedAssets,
                                locations.map,
                                index
                            );
                        }
                    });
                } else {
                    console.error("Directions request failed due to " + status);
                }
            });
        };


        function callDirectionApi(location, isSwitch, isCycle) {
            var assetDetails = JSON.parse(
                '{"id":null,"name":"PlannnedRoute1","description":"","createDate":null,"updateDate":null,"userId":null,"assetType":{"id":14463282,"name":"Planned Route","description":"Planned Route","layout":"SPREAD","colorcode":"BLUE","userId":10008413,"createDate":1742368347206,"updateDate":1742906068596,"createdBy":"fiberifyinc","transparency":100,"lineWidth":100,"authorities":["ROLE_ASSISTANT_MANAGER","ROLE_PATROLLER","ROLE_USER_ADMIN","ROLE_CITY_MANAGER","ROLE_FRT","ROLE_CITY_PLANNER","ROLE_NETWORK_ENGINEER"],"assetTypeAttributes":[{"id":14463284,"name":"FID","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":1,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14463285,"name":"Name","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":2,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14463283,"name":"Type","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":3,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14463286,"name":"Blk_Code","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":4,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14463287,"name":"DT_Code","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":5,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14463288,"name":"ST_Code","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":6,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14463289,"name":"Seg_Length","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":7,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14463290,"name":"Start_Node","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":8,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14463292,"name":"End_Node","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":9,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14463293,"name":"Num_Fibre","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":10,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14463294,"name":"Ring_ID","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":11,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14463291,"name":"Remarks","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":12,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925924,"name":"e_coil_len","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925925,"name":"olt_code","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925926,"name":"cs","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925927,"name":"asset_code","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925928,"name":"owner","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925929,"name":"s_coil_len","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925930,"name":"status","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925931,"name":"st_length_","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925932,"name":"traverse","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925933,"name":"route_code","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925934,"name":"obs","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925935,"name":"mp4","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925936,"name":"phase","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925937,"name":"direction","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925938,"name":"created_da","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925939,"name":"created_us","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925940,"name":"fiber_pos","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925941,"name":"last_edite","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925942,"name":"svcready","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925943,"name":"GlobalID","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925944,"name":"ontcode","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925945,"name":"last_edi_1","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false}],"assetTypeReferenceAttributes":[],"imagePath":null,"zoomLevel":12,"zoomLevelLabel":null,"isSeniorElement":null},"assetTypeAttributeValues":[{"assetTypeAttribute":{"id":14463284,"name":"FID","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":1,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14463285,"name":"Name","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":2,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14463283,"name":"Type","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":3,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14463286,"name":"Blk_Code","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":4,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14463287,"name":"DT_Code","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":5,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14463288,"name":"ST_Code","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":6,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14463289,"name":"Seg_Length","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":7,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14463290,"name":"Start_Node","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":8,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14463292,"name":"End_Node","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":9,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14463293,"name":"Num_Fibre","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":10,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14463294,"name":"Ring_ID","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":11,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14463291,"name":"Remarks","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":12,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925924,"name":"e_coil_len","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925925,"name":"olt_code","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925926,"name":"cs","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925927,"name":"asset_code","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925928,"name":"owner","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925929,"name":"s_coil_len","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925930,"name":"status","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925931,"name":"st_length_","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925932,"name":"traverse","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925933,"name":"route_code","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925934,"name":"obs","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925935,"name":"mp4","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925936,"name":"phase","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925937,"name":"direction","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925938,"name":"created_da","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925939,"name":"created_us","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925940,"name":"fiber_pos","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925941,"name":"last_edite","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925942,"name":"svcready","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925943,"name":"GlobalID","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925944,"name":"ontcode","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925945,"name":"last_edi_1","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""}],"assetCoordinates":[{"latitude":12.967849262505046,"longitude":77.5883731118908},{"latitude":12.965841854217818,"longitude":77.59008972566033},{"latitude":12.961994276406937,"longitude":77.59208869746462}],"assetImport":false,"phase":"ROLLOUT","assetImages":[],"groups":[{"id":10008423}],"ownedBy":[],"assetReferenceAttributes":[]}'
            );

            var request = {
                origin: location.source,
                destination: location.destination,
                travelMode: "DRIVING",
                avoidTolls: true,
                avoidHighways: true,
            };

            if (isSwitch) {
                request.provideRouteAlternatives = true;
            }
            vm.allPaths = [];
            directionsService
                .route(request)
                .then(function (result) {
                    if (result.status == google.maps.DirectionsStatus.OK) {
                        var responsePaths = result.routes;
                        responsePaths.forEach(function (pathVal, index) {
                            if (index < 3) {
                                var distance = pathVal.legs[0].distance.value;
                                distance = distance / 1000;

                                var tempColor = "red";
                                var tempConnected = "Connected";

                                if (isCycle) {
                                    tempColor = "#FFD700";
                                    tempConnected = "Not Connected";
                                    location.isConnected = false;
                                    // } else if (!location.isConnected) {
                                } else if (!location.isExisting) {
                                    tempColor = "#00A36C";
                                    tempConnected = "Not Connected";
                                }

                                if(!location.isUsed && location.isExisting){
                                    tempColor = "#FFAE42"
                                }
                                if (pathVal.overview_path.length > 0) {
                                    var assetValue = assetDetails;
                                    assetValue.name =
                                        location.sourceName + " to " + location.destinationName;
                                    var assetCoor = [];
                                    pathVal.overview_path.forEach(function (val, index) {
                                        assetCoor.push({
                                            latitude: val.lat(),
                                            longitude: val.lng(),
                                        });
                                    });

                                    assetValue.assetCoordinates = assetCoor;
                                    assetValue.isChecked = true;
                                    assetValue.isConnected = location.isConnected;
                                    assetValue.isCycle = false;
                                    assetValue.inGraph = location.inGraph;
                                    assetValue.minCost = location.minCost;
                                    assetValue.block = location.block;
                                    assetValue.state = location.state;
                                    assetValue.district = location.district;

                                    assetValue.strStatus = tempConnected;
                                    assetValue.assetLength = distance;

                                    if (isCycle) {
                                        assetValue.isCycle = true;
                                        vm.tempCycleAssets.push(assetValue);
                                    }

                                    vm.mappedAssetsList.push(assetValue);
                                    vm.mappedAssetsListImport.push(assetValue);
                                }

                                if (markersConnect.length == 2) {
                                    clearMarkers();
                                }

                                vm.allPaths.push({
                                    assetValue: assetValue,
                                    tempColor: tempColor,
                                    path: pathVal.overview_path,
                                });
                            }
                        });
                    }
                })
                .catch(function (e) {
                    console.log("Directions request failed due to " + e);
                });
        }

        function callDirectionApi1(location, isSwitch, isCycle) {
            var assetDetails = JSON.parse(
                '{"id":null,"name":"PlannnedRoute1","description":"","createDate":null,"updateDate":null,"userId":null,"assetType":{"id":14463282,"name":"Planned Route","description":"Planned Route","layout":"SPREAD","colorcode":"BLUE","userId":10008413,"createDate":1742368347206,"updateDate":1742906068596,"createdBy":"fiberifyinc","transparency":100,"lineWidth":100,"authorities":["ROLE_ASSISTANT_MANAGER","ROLE_PATROLLER","ROLE_USER_ADMIN","ROLE_CITY_MANAGER","ROLE_FRT","ROLE_CITY_PLANNER","ROLE_NETWORK_ENGINEER"],"assetTypeAttributes":[{"id":14463284,"name":"FID","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":1,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14463285,"name":"Name","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":2,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14463283,"name":"Type","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":3,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14463286,"name":"Blk_Code","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":4,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14463287,"name":"DT_Code","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":5,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14463288,"name":"ST_Code","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":6,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14463289,"name":"Seg_Length","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":7,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14463290,"name":"Start_Node","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":8,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14463292,"name":"End_Node","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":9,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14463293,"name":"Num_Fibre","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":10,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14463294,"name":"Ring_ID","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":11,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14463291,"name":"Remarks","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":12,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925924,"name":"e_coil_len","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925925,"name":"olt_code","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925926,"name":"cs","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925927,"name":"asset_code","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925928,"name":"owner","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925929,"name":"s_coil_len","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925930,"name":"status","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925931,"name":"st_length_","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925932,"name":"traverse","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925933,"name":"route_code","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925934,"name":"obs","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925935,"name":"mp4","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925936,"name":"phase","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925937,"name":"direction","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925938,"name":"created_da","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925939,"name":"created_us","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925940,"name":"fiber_pos","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925941,"name":"last_edite","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925942,"name":"svcready","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925943,"name":"GlobalID","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925944,"name":"ontcode","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925945,"name":"last_edi_1","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false}],"assetTypeReferenceAttributes":[],"imagePath":null,"zoomLevel":12,"zoomLevelLabel":null,"isSeniorElement":null},"assetTypeAttributeValues":[{"assetTypeAttribute":{"id":14463284,"name":"FID","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":1,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14463285,"name":"Name","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":2,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14463283,"name":"Type","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":3,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14463286,"name":"Blk_Code","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":4,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14463287,"name":"DT_Code","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":5,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14463288,"name":"ST_Code","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":6,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14463289,"name":"Seg_Length","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":7,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14463290,"name":"Start_Node","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":8,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14463292,"name":"End_Node","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":9,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14463293,"name":"Num_Fibre","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":10,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14463294,"name":"Ring_ID","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":11,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14463291,"name":"Remarks","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":12,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925924,"name":"e_coil_len","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925925,"name":"olt_code","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925926,"name":"cs","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925927,"name":"asset_code","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925928,"name":"owner","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925929,"name":"s_coil_len","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925930,"name":"status","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925931,"name":"st_length_","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925932,"name":"traverse","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925933,"name":"route_code","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925934,"name":"obs","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925935,"name":"mp4","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925936,"name":"phase","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925937,"name":"direction","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925938,"name":"created_da","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925939,"name":"created_us","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925940,"name":"fiber_pos","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925941,"name":"last_edite","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925942,"name":"svcready","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925943,"name":"GlobalID","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925944,"name":"ontcode","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925945,"name":"last_edi_1","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""}],"assetCoordinates":[{"latitude":12.967849262505046,"longitude":77.5883731118908},{"latitude":12.965841854217818,"longitude":77.59008972566033},{"latitude":12.961994276406937,"longitude":77.59208869746462}],"assetImport":false,"phase":"ROLLOUT","assetImages":[],"groups":[{"id":10008423}],"ownedBy":[],"assetReferenceAttributes":[]}'
            );
            var request = {
                origin: location.source,
                destination: location.destination,
                travelMode: "DRIVING",
                avoidTolls: true,
                avoidHighways: true,
            };

            if (isSwitch) {
                request.provideRouteAlternatives = true;
            }
            vm.allPath = [];
            directionsService
                .route(request)
                .then(function (result) {
                    if (result.status == google.maps.DirectionsStatus.OK) {
                        var responsePaths = result.routes;
                        responsePaths.forEach(function (pathVal, index) {
                            if (index < 3) {
                                var distance = pathVal.legs[0].distance.value;
                                distance = distance / 1000;

                                var tempColor = "#00A36C";
                                var tempConnected = "Connected";

                                if (isCycle) {
                                    tempColor = "#FFD700";
                                    tempConnected = "Not Connected";
                                    location.isConnected = false;
                                    // } else if (!location.isConnected) {
                                } else if (!location.isExisting) {
                                    tempColor = "#00A36C";
                                    tempConnected = "Not Connected";
                                }
                                if(!location.isUsed && location.isExisting){
                                    tempColor = "#FFAE42"
                                }
                                if (pathVal.overview_path.length > 0) {
                                    var assetValue = assetDetails;
                                    assetValue.name =
                                        location.sourceName + " to " + location.destinationName;
                                    var assetCoor = [];
                                    pathVal.overview_path.forEach(function (val, index) {
                                        assetCoor.push({
                                            latitude: val.lat(),
                                            longitude: val.lng(),
                                        });

                                    });
                                    assetValue.connectedNode1 = location.sourceName;
                                    assetValue.connectedNode2 = location.destinationName;
                                    assetValue.assetCoordinates = assetCoor;
                                    assetValue.isChecked = true;
                                    assetValue.isConnected = location.isConnected;
                                    assetValue.isCycle = false;
                                    assetValue.inGraph = location.inGraph;
                                    assetValue.minCost = location.minCost;
                                    assetValue.block = location.block;
                                    assetValue.state = location.state;
                                    assetValue.district = location.district;

                                    assetValue.strStatus = tempConnected;
                                    assetValue.assetLength = distance;

                                    if (isCycle) {
                                        assetValue.isCycle = true;
                                        vm.tempCycleAssets.push(assetValue);
                                    }

                                    vm.mappedAssetsList.push(assetValue);
                                    vm.mappedAssetsListImport.push(assetValue);
                                }

                                if (markersConnect.length == 2) {
                                    clearMarkers();
                                }
                                drawPolyLines(
                                    assetValue,
                                    tempColor,
                                    pathVal.overview_path,
                                    locations.importMap
                                );
                                vm.allPath.push({
                                    assetValue: assetValue,
                                    tempColor: tempColor,
                                    path: pathVal.overview_path,
                                })
                            }
                        });
                    }
                })
                .catch(function (e) {
                    console.log("Directions request failed due to " + e);
                });
        }
        function callDirectionApi2(location, isSwitch, isCycle) {
            var assetDetails = JSON.parse(
                '{"id":null,"name":"PlannnedRoute1","description":"","createDate":null,"updateDate":null,"userId":null,"assetType":{"id":14463282,"name":"Planned Route","description":"Planned Route","layout":"SPREAD","colorcode":"BLUE","userId":10008413,"createDate":1742368347206,"updateDate":1742906068596,"createdBy":"fiberifyinc","transparency":100,"lineWidth":100,"authorities":["ROLE_ASSISTANT_MANAGER","ROLE_PATROLLER","ROLE_USER_ADMIN","ROLE_CITY_MANAGER","ROLE_FRT","ROLE_CITY_PLANNER","ROLE_NETWORK_ENGINEER"],"assetTypeAttributes":[{"id":14463284,"name":"FID","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":1,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14463285,"name":"Name","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":2,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14463283,"name":"Type","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":3,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14463286,"name":"Blk_Code","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":4,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14463287,"name":"DT_Code","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":5,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14463288,"name":"ST_Code","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":6,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14463289,"name":"Seg_Length","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":7,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14463290,"name":"Start_Node","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":8,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14463292,"name":"End_Node","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":9,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14463293,"name":"Num_Fibre","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":10,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14463294,"name":"Ring_ID","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":11,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14463291,"name":"Remarks","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":12,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925924,"name":"e_coil_len","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925925,"name":"olt_code","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925926,"name":"cs","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925927,"name":"asset_code","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925928,"name":"owner","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925929,"name":"s_coil_len","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925930,"name":"status","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925931,"name":"st_length_","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925932,"name":"traverse","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925933,"name":"route_code","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925934,"name":"obs","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925935,"name":"mp4","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925936,"name":"phase","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925937,"name":"direction","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925938,"name":"created_da","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925939,"name":"created_us","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925940,"name":"fiber_pos","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925941,"name":"last_edite","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925942,"name":"svcready","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925943,"name":"GlobalID","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925944,"name":"ontcode","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},{"id":14925945,"name":"last_edi_1","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false}],"assetTypeReferenceAttributes":[],"imagePath":null,"zoomLevel":12,"zoomLevelLabel":null,"isSeniorElement":null},"assetTypeAttributeValues":[{"assetTypeAttribute":{"id":14463284,"name":"FID","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":1,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14463285,"name":"Name","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":2,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14463283,"name":"Type","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":3,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14463286,"name":"Blk_Code","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":4,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14463287,"name":"DT_Code","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":5,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14463288,"name":"ST_Code","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":6,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14463289,"name":"Seg_Length","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":7,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14463290,"name":"Start_Node","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":8,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14463292,"name":"End_Node","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":9,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14463293,"name":"Num_Fibre","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":10,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14463294,"name":"Ring_ID","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":11,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14463291,"name":"Remarks","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":12,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925924,"name":"e_coil_len","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925925,"name":"olt_code","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925926,"name":"cs","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925927,"name":"asset_code","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925928,"name":"owner","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925929,"name":"s_coil_len","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925930,"name":"status","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925931,"name":"st_length_","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925932,"name":"traverse","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925933,"name":"route_code","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925934,"name":"obs","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925935,"name":"mp4","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925936,"name":"phase","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925937,"name":"direction","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925938,"name":"created_da","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925939,"name":"created_us","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925940,"name":"fiber_pos","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925941,"name":"last_edite","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925942,"name":"svcready","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925943,"name":"GlobalID","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925944,"name":"ontcode","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""},{"assetTypeAttribute":{"id":14925945,"name":"last_edi_1","defaultValue":"","attributeDataType":{"id":10008451,"name":"STRING","description":"STRING data values"},"assetAttributeTypes":"NON_REFERENCE","assetTypeAttribOrder":99,"assetTypePopupDisplay":false,"assetTypeListViewDisplay":false},"attributeValue":""}],"assetCoordinates":[{"latitude":12.967849262505046,"longitude":77.5883731118908},{"latitude":12.965841854217818,"longitude":77.59008972566033},{"latitude":12.961994276406937,"longitude":77.59208869746462}],"assetImport":false,"phase":"ROLLOUT","assetImages":[],"groups":[{"id":10008423}],"ownedBy":[],"assetReferenceAttributes":[]}'
            );
            var request = {
                origin: location.source,
                destination: location.destination,
                travelMode: "DRIVING",
                avoidTolls: true,
                avoidHighways: true,
            };

            if (isSwitch) {
                request.provideRouteAlternatives = true;
            }
            vm.allPath = [];
            directionsService
                .route(request)
                .then(function (result) {
                    if (result.status == google.maps.DirectionsStatus.OK) {
                        var responsePaths = result.routes;
                        responsePaths.forEach(function (pathVal, index) {
                            if (index < 3) {
                                var distance = pathVal.legs[0].distance.value;
                                distance = distance / 1000;

                                var tempColor = "#00A36C";
                                var tempConnected = "Connected";

                                if (isCycle) {
                                    tempColor = "#FFD700";
                                    tempConnected = "Not Connected";
                                    location.isConnected = false;
                                    // } else if (!location.isConnected) {
                                } else if (!location.isExisting) {
                                    tempColor = "#00A36C";
                                    tempConnected = "Not Connected";
                                }
                                if(!location.isUsed && location.isExisting){
                                    tempColor = "#FFAE42"
                                }
                                if (pathVal.overview_path.length > 0) {
                                    var assetValue = assetDetails;
                                    assetValue.name =
                                        location.sourceName + " to " + location.destinationName;
                                    var assetCoor = [];
                                    pathVal.overview_path.forEach(function (val, index) {
                                        assetCoor.push({
                                            latitude: val.lat(),
                                            longitude: val.lng(),
                                        });

                                    });
                                    assetValue.connectedNode1 = location.sourceName;
                                    assetValue.connectedNode2 = location.destinationName;
                                    assetValue.assetCoordinates = assetCoor;
                                    assetValue.isChecked = true;
                                    assetValue.isConnected = location.isConnected;
                                    assetValue.isCycle = false;
                                    assetValue.inGraph = location.inGraph;
                                    assetValue.minCost = location.minCost;
                                    assetValue.block = location.block;
                                    assetValue.state = location.state;
                                    assetValue.district = location.district;

                                    assetValue.strStatus = tempConnected;
                                    assetValue.assetLength = distance;

                                    if (isCycle) {
                                        assetValue.isCycle = true;
                                        vm.tempCycleAssets.push(assetValue);
                                    }

                                    vm.mappedAssetsList.push(assetValue);
                                    vm.mappedAssetsListImport.push(assetValue);
                                }

                                if (markersConnect.length == 2) {
                                    clearMarkers();
                                }

                                drawPolyLines(
                                    assetValue,
                                    tempColor,
                                    pathVal.overview_path,
                                    locations.map
                                );
                                vm.allPath.push({
                                    assetValue: assetValue,
                                    tempColor: tempColor,
                                    path: pathVal.overview_path,
                                })
                            }
                        });
                    }
                })
                .catch(function (e) {
                    console.log("Directions request failed due to " + e);
                });
        }
        function simplify(path, tolerance) {
            if (!path || path.length < 3) return path;

            // Find the point with the maximum distance
            var maxDistance = 0;
            var maxIndex = 0;
            var end = path.length - 1;

            for (var i = 1; i < end; i++) {
                var distance = perpendicularDistance(path[i], path[0], path[end]);
                if (distance > maxDistance) {
                    maxDistance = distance;
                    maxIndex = i;
                }
            }

            var simplified;

            // If the maximum distance is greater than the tolerance, recursively simplify
            if (maxDistance > tolerance) {
                var simplified1 = simplify(path.slice(0, maxIndex + 1), tolerance);
                var simplified2 = simplify(
                    path.slice(maxIndex, path.length),
                    tolerance
                );

                // Concatenate the two simplified lists (excluding the duplicated point)
                simplified = simplified1.concat(simplified2.slice(1));
            } else {
                simplified = [path[0], path[end]];
            }

            return simplified;
        }

        // Calculate the perpendicular distance from a point to a line segment
        function perpendicularDistance(point, start, end) {
            var x = point.lng();
            var y = point.lat();
            var x1 = start.lng();
            var y1 = start.lat();
            var x2 = end.lng();
            var y2 = end.lat();

            var A = x - x1;
            var B = y - y1;
            var C = x2 - x1;
            var D = y2 - y1;

            var dot = A * C + B * D;
            var len_sq = C * C + D * D;
            var param = dot / len_sq;

            var xx, yy;

            if (param < 0 || (x1 == x2 && y1 == y2)) {
                xx = x1;
                yy = y1;
            } else if (param > 1) {
                xx = x2;
                yy = y2;
            } else {
                xx = x1 + param * C;
                yy = y1 + param * D;
            }

            var dx = x - xx;
            var dy = y - yy;
            return Math.sqrt(dx * dx + dy * dy);
        }

        locations.map = new google.maps.Map(
            document.getElementById("map_canvas_planning"),
            myOption(10, latlngs)
        );

        function getRandomColor() {
            var letters = "0123456789ABCDEF";
            var color = "#";
            do {
                color = "#";
                for (var i = 0; i < 6; i++) {
                    color += letters[Math.floor(Math.random() * 16)];
                }
            } while (color === "#FFFFFF"); // Exclude white color

            return color;
        }

        $scope.togglePolylines = function () {
            var temp = cyclePolylines;
            if ($scope.isShowCycles) {
                for (var i = 0; i < temp.length; i++) {
                    temp[i].setOptions({
                        strokeColor: "#FFD700",
                    });
                    temp[i].setMap(locations.importMap);
                }
                vm.mappedAssetsListImport = vm.mappedAssetsListImport.concat(
                    vm.tempCycleAssets
                );

                if (!vm.trRoute.tempId) {
                    vm.mappedAssetsList = vm.mappedAssetsListImport;
                }

                refreshPage();
            } else {
                vm.mappedAssetsListImport = vm.mappedAssetsListImport.filter(function (
                    element
                ) {
                    return !element.isCycle;
                });

                if (!vm.trRoute.tempId) {
                    vm.mappedAssetsList = vm.mappedAssetsListImport;
                }

                clearPolylines(cyclePolylines);
                refreshPage();
            }
        };

        $scope.isShowMinCost = false;
        $scope.isShowMinCostText = "Show";
        $scope.toggleMinCost = function () {
            $scope.isAnomaly = false;
            $scope.isAnomalyText = "Show";

            $scope.isShowMinCost = !$scope.isShowMinCost;
            if ($scope.isShowMinCost) {
                $scope.isShowMinCostText = "Hide";
                for (var i = 0; i < vm.layerItems.length; i++) {
                    vm.layerItems[i].selected = true;
                    vm.selectedLayers[vm.layerItems[i].name] = true;
                }
                var temp = minCostPolylines;
                initPlanningMap();
                for (var i = 0; i < temp.length; i++) {
                    temp[i].setMap(locations.map);
                }
                for (var i = 0; i < vm.mappedAssetsList.length; i++) {
                    if (vm.mappedAssetsList[i].assetType.layout == "FIXED") {
                        drawMarkers(vm.mappedAssetsList[i], locations.map, i);
                    }
                }
            } else {
                $scope.isShowMinCostText = "Show";
                minCostPolylines = [];
                refreshPage();
            }
        };

        function clearPolylines(arr) {
            for (var i = 0; i < arr.length; i++) {
                arr[i].setMap(null);
            }
        }

        function createMarkers(arr, img, map) {
            arr.forEach(function (each) {
                var marker = new google.maps.Marker({
                    position: { lat: each.lat, lng: each.lng },
                    map: map,
                    icon: {
                        scaledSize: new google.maps.Size(iconSize, iconSize),
                        url: img,
                        anchor: new google.maps.Point(iconSize / 2, iconSize / 2),
                        labelOrigin: new google.maps.Point(25, 22),
                    },
                });

                arr.push(marker);
            });
        }
        var polyLines = []
        function drawPolyLines(asset, color, path, map, isRingTopology) {
            tempCount++;
            var polyline;
            var tmpStatus = asset.strStatus
                ? "<br><b> Status </b><br>" + asset.strStatus
                : "";

            var distance = asset.assetLength
                ? "<br><b> Distance </b><br>" + Number(asset.assetLength).toFixed(2) + " km"
                : "";

            blockPolyLine = asset.block ? "<br><b> Block </b><br>" + asset.block : "";

            var strokeWeight = asset.isCycle ? 2 : 3;
            var strokeOpacity = asset.isCycle ? 0.7 : 0.7;

            if (color == "#0050B5") {
                strokeWeight = 3;
                strokeOpacity = 0.2;
            }
            if (color == "red") {
                strokeWeight = 15;
                strokeOpacity = 0.6;
            }

            if (color == "#000000") {
                var lineSymbol = {
                    path: "M 0,-1 0,1",
                    strokeOpacity: 1,
                    scale: 4,
                    strokeColor: "#000000",
                };
                polyline = new google.maps.Polyline({
                    path: path,
                    strokeOpacity: 0,
                    icons: [
                        {
                            icon: lineSymbol,
                            offset: "0",
                            repeat: "20px",
                        },
                    ],
                });
                polyLines.push(polyline);
            } else {
                polyline = new google.maps.Polyline({
                    path: path,
                    geodesic: true,
                    strokeColor: color,
                    strokeOpacity: strokeOpacity,
                    strokeWeight: strokeWeight,
                    block: asset.block,
                });
                polyLines.push(polyline);
            }

            if (isRingTopology) {
                vm.storeRingPolylines.push({
                    polyline: polyline,
                    index: asset.index + 1,
                });
            }

            google.maps.event.addListener(polyline, "click", function (event) {
                if (openedInfoWindow != null) {
                    openedInfoWindow.close();
                    if (spreadPoly != null) {
                        spreadPoly.setMap(null);
                    }
                }

                clearTimeout(polylineTimer);

                spreadPoly = new google.maps.Polyline({
                    path: path,
                    strokeColor: "#A938F3",
                    strokeOpacity: 0.6,
                    strokeWeight: 3,
                });

                spreadPoly.setMap(map);

                polylineTimer = setTimeout(function () {
                    if (spreadPoly != null) {
                        spreadPoly.setMap(null);
                        spreadPoly = null;
                    }
                }, 5000);

                var userContent = document.createElement("div"),
                    btnEditAsset,
                    brBreak,
                    btnDeleteAsset,
                    btnCreateSection,
                    btnCommonPath,
                    btnUpdateRoute,
                    btnShowAsset,
                    btnEditAttribute;


                userContent.innerHTML =
                    '<div class="infoWindowhead">' +
                    "<b> Name </b><br>" +
                    asset.name +
                    tmpStatus +
                    distance +
                    blockPolyLine;
                ("</br></div>");

                if (vm.trRoute.id || vm.trRoute.tempId) {
                    btnDeleteAsset = userContent.appendChild(
                        document.createElement("input")
                    );

                    btnDeleteAsset.type = "button";
                    btnDeleteAsset.value = "Delete";
                    btnDeleteAsset.className = "button";

                    google.maps.event.addDomListener(
                        btnDeleteAsset,
                        "click",
                        function () {
                            vm.deleteAssetModal(asset.name, asset.id);
                        }
                    );

                    btnEditAsset = userContent.appendChild(
                        document.createElement("input")
                    );

                    btnEditAsset.type = "button";
                    btnEditAsset.value = "Edit Asset";
                    btnEditAsset.className = "button";

                    google.maps.event.addDomListener(btnEditAsset, "click", function () {
                        $(":file").filestyle("clear");
                        AssetByID.get(asset.id, function (response) {
                            vm.assetattributevaluesDisplay = response;
                            vm.editAsset(vm.assetattributevaluesDisplay);
                        });
                        //vm.editAsset(asset);
                        //console.log(asset);
                        $scope.$apply();
                    });

                    if ((vm.trRoute.id || vm.trRoute.tempId) && asset.id) {
                        btnCreateSection = userContent.appendChild(
                            document.createElement("input")
                        );

                        btnCreateSection.type = "button";
                        btnCreateSection.value = "Add To Ring";
                        btnCreateSection.className = "button";

                        google.maps.event.addDomListener(
                            btnCreateSection,
                            "click",
                            function () {

                               /* if (!vm.ringRouteAssets.length) {
                                    vm.getRouteSections();
                                }*/
                                vm.addAssetToRingStack(asset);
                                if (openedInfoWindow != undefined) {
                                    openedInfoWindow.close();
                                }
                            }
                        );
                    }
                    if (vm.trRoute.id || vm.trRoute.tempId) {
                        btnShowAsset = userContent.appendChild(
                            document.createElement("input")
                        );

                        btnShowAsset.type = "button";
                        btnShowAsset.value = "Show attributes";
                        btnShowAsset.className = "button";

                        google.maps.event.addDomListener(
                            btnShowAsset,
                            "click",
                            function () {
                                AssetByID.get(asset.id, function (response) {
                                    showAssetAttributesModal(response);
                                });
                            }
                        );
                    }

                    if (vm.trRoute.id || vm.trRoute.tempId) {
                        btnEditAttribute = userContent.appendChild(
                            document.createElement("input")
                        );

                        btnEditAttribute.type = "button";
                        btnEditAttribute.value = "Edit attributes";
                        btnEditAttribute.className = "button";

                        google.maps.event.addDomListener(
                            btnEditAttribute,
                            "click",
                            function () {
                                AssetByID.get(asset.id, function (response) {
                                    vm.editAssetAttributesModal(response);
                                    if (openedInfoWindow != undefined) {
                                        openedInfoWindow.close();
                                    }
                                });
                            }
                        );
                    }
                    if ((vm.trRoute.id || vm.trRoute.tempId) && asset.id) {
                        btnUpdateRoute = userContent.appendChild(
                            document.createElement("input")
                        );

                        btnUpdateRoute.type = "button";
                        btnUpdateRoute.value = "Add to Exist Ring";
                        btnUpdateRoute.className = "button";

                        google.maps.event.addDomListener(
                            btnUpdateRoute,
                            "click",
                            function () {
                                vm.addExistAssetModal(asset);
                                if (openedInfoWindow != undefined) {
                                    openedInfoWindow.close();
                                }
                            }
                        );
                    }
                }
                infowindow.setContent(userContent);

                infowindow.open(map);
                infowindow.setPosition(event.latLng);
                openedInfoWindow = infowindow;
            });

            if (asset.isCycle) {
                cyclePolylines.push(polyline);
            }

            if (asset.minCost) {
                vm.optimalTotalLength += parseFloat(asset.assetLength);
                minCostPolylines.push(polyline);
            }

            if (color == "#000000") {
                anomalyPolylines.push(polyline);
            }

            if (asset.assetLength >= 10) {
                moreThan10KmPolylines.push(polyline);
            }

            polyline.setMap(map);

            if (tempCount == vm.storeLocations.length) {
                vm.isDisableNext = false;
                vm.isShowTotalLengthImport = true;
            }
        }

        function drawMarkers(asset, map, index) {
            if (asset.assetCoordinates.length > 0) {
                var tmpStatus = asset.isConnected
                    ? "<br><b> Status : </b>" + asset.isConnected
                    : "";
                var tempPhase = asset.phase ? "<br><b> Phase : </b>" + asset.phase : "";
                blockMarker = asset.block ? "<br><b> Block : </b>" + asset.block : "";
                vm.blockName = asset.block;
                vm.stateName = asset.state;
                vm.districtName = asset.district;
                iconSize = 27;
               var latitude = parseFloat(asset.assetCoordinates[0].latitude);
               var longitude = parseFloat(asset.assetCoordinates[0].longitude);  
                // var marker = new google.maps.Marker({
                //   position: { lat: latitude, lng: longitude },
                //   map: map,
                //   title: asset.name,
                //   icon: {
                //     scaledSize: new google.maps.Size(iconSize, iconSize),
                //     url: asset.assetType.imagePath,
                //     labelOrigin: new google.maps.Point(25, 40),
                //   },
                // });
                var marker = new google.maps.Marker({
                    position: { lat: latitude, lng: longitude },
                    map: map,
                    title: asset.name,
                    icon: {
                      scaledSize: new google.maps.Size(24, 24),
                      url: asset.assetType.imagePath,
                      anchor: new google.maps.Point(
                          12,24
                      ),
                      labelOrigin: new google.maps.Point(25, 40),
                    },
                  });
                markers.push(marker);
                if (asset.assetType.name === "OLT") {
                    marker.setZIndex(2000);
                } else {
                    marker.setZIndex(1000);
                }
                marker.assetDetails = asset;
                
                // var updateIconSize = function () {
                //     var zoom = map.getZoom();
                //     var newSize = zoom * 2;
                //     var icon = marker.getIcon();
                //     icon.scaledSize = new google.maps.Size(newSize, newSize);
                //     icon.anchor = new google.maps.Point(newSize / 2, newSize / 2);
                //     marker.setIcon(icon);
                // };
function updateMarkerLabelVisibility() {
                    var currentZoom = locations.map.getZoom();
                    if (currentZoom > 12) {
                        if(asset.assetType.name=="GP" || asset.assetType.name=="ONT"){
                            marker.setLabel({
                            color: "red",
                            fontWeight: "bold",
                            fontSize: "12px",
                            text: asset.name,
                            className: "asset_label top-label"
                        });
                        }
                    } else {
                        marker.setLabel(null);
                    }
                    var style = document.createElement('style');
                    style.innerHTML = '.top-label {' +
                        '    position: relative; /* Needed for top positioning */' +
                        '    top: 30px; /* Adjust this value to move the label higher */' +
                        '    left: 0;' +
                        '    transform: translateX(10%); /*center the label*/' +
                        '    white-space: nowrap; /*prevent wrapping*/' +
                        '}';
                    document.head.appendChild(style);
                }
                var updateIconSize = function () {
                    var zoom = map.getZoom();

                    // Define minimum and maximum zoom levels
                    var minZoom = 8;
                    var maxZoom = 21;

                    // Define minimum and maximum icon sizes
                    var minSize = 6;  // Smallest size at zoom 8
                    var maxSize = 60;  // Full size at zoom 21

                    // Compute new size based on zoom level
                    newSizeLevel = minSize + ((zoom - minZoom) / (maxZoom - minZoom)) * (maxSize - minSize);
                    var assetId = marker.assetDetails.id;

                    if (!assetId) return;

                    var isHighlighted = highlightedMarkers[assetId];
                    var newSize = isHighlighted ? newSizeLevel + 15 : newSizeLevel;
                    var icon = {
                        url: marker.getIcon().url,  // Keep the existing marker image
                        scaledSize: new google.maps.Size(newSize, newSize),  // Only use scaledSize
                    };

                    marker.setIcon(icon);
                };

                // Run updateIconSize once to initialize
                updateIconSize();

                // Listen for zoom changes
                google.maps.event.addListener(map, "zoom_changed", function () {
                    updateIconSize();
                    updateMarkerLabelVisibility()
                });


                google.maps.event.addListener(
                    marker,
                    "click",
                    (function (marker) {
                        var assetDetails = marker.assetDetails;
                        var userContent = document.createElement("div"),
                            btnEditAsset,
                            btnDeleteAsset,
                            btnShowAsset,
                            btnEditAttribute,
                            btnAssetAttach,
                            btnThreePointRef,
                            ADDTORing,
                            btnHighLightOlt,
                            btnSelectOlt,
                            btnNearBy,
                            btnUpdateRoute

                        userContent.innerHTML =
                            '<div class="infoWindowhead">' +
                            assetDetails.id +
                            "<br><b>Name </b> : " +
                            assetDetails.name +
                            '</div><div class="infoWindowContent">' +
                            "<b>Asset Type </b> : " +
                            assetDetails.assetType.name +
                            "<br><b>Latitude </b> : " +
                            assetDetails.assetCoordinates[0].latitude +
                            "<br><b>Longitude </b> : " +
                            assetDetails.assetCoordinates[0].longitude +
                            blockMarker +
                            tempPhase +
                            tmpStatus;
                        "<br>" + "</div><br>";

                        if (vm.trRoute.id || vm.trRoute.tempId) {
                            btnEditAsset = userContent.appendChild(
                                document.createElement("input")
                            );

                            btnEditAsset.type = "button";
                            btnEditAsset.value = "Edit asset";
                            btnEditAsset.className = "button";

                            google.maps.event.addDomListener(
                                btnEditAsset,
                                "click",
                                function () {
                                    AssetByID.get(assetDetails.id, function (response) {
                                        vm.assetToEdit = response;
                                        document.getElementById("assetEditName").textContent =
                                            "Asset - " + vm.assetToEdit.name;
                                        editAssetOnMapView(assetDetails);
                                    });
                                }
                            );
                        }
                        if (vm.trRoute.id || vm.trRoute.tempId) {
                            btnShowAsset = userContent.appendChild(
                                document.createElement("input")
                            );

                            btnShowAsset.type = "button";
                            btnShowAsset.value = "Show attributes";
                            btnShowAsset.className = "button";

                            google.maps.event.addDomListener(
                                btnShowAsset,
                                "click",
                                function () {
                                    AssetByID.get(assetDetails.id, function (response) {
                                        showAssetAttributesModal(response);
                                    });
                                }
                            );
                        }
                        if (vm.trRoute.id || vm.trRoute.tempId) {
                            btnEditAttribute = userContent.appendChild(
                                document.createElement("input")
                            );

                            btnEditAttribute.type = "button";
                            btnEditAttribute.value = "Edit attributes";
                            btnEditAttribute.className = "button";

                            google.maps.event.addDomListener(
                                btnEditAttribute,
                                "click",
                                function () {
                                    AssetByID.get(asset.id, function (response) {
                                        vm.editAssetAttributesModal(response);
                                        if (openedInfoWindow != undefined) {
                                            openedInfoWindow.close();
                                        }
                                    });
                                }
                            );
                        }
                        if (vm.trRoute.id || vm.trRoute.tempId) {
                            btnThreePointRef = userContent.appendChild(
                                document.createElement("input")
                            );

                            btnThreePointRef.type = "button";
                            btnThreePointRef.value = "3 Point Reference";
                            btnThreePointRef.className = "button";

                            google.maps.event.addDomListener(
                                btnThreePointRef,
                                "click",
                                function () {
                                    AssetByID.get(assetDetails.id, function (response) {
                                        showThreePontReferenceModal(response);
                                    });
                                }
                            );
                        }
                        if (vm.trRoute.id || vm.trRoute.tempId) {
                            btnAssetAttach = userContent.appendChild(
                                document.createElement("input")
                            );

                            btnAssetAttach.type = "button";
                            btnAssetAttach.value = "Attachments";
                            btnAssetAttach.className = "button";

                            google.maps.event.addDomListener(
                                btnAssetAttach,
                                "click",
                                function () {
                                    vm.assetAttachments.assetImages = [];
                                    $("#modalAttachment").show();
                                }
                            );
                        }
                        if (vm.trRoute.id || vm.trRoute.tempId) {
                            btnDeleteAsset = userContent.appendChild(
                                document.createElement("input")
                            );

                            btnDeleteAsset.type = "button";
                            btnDeleteAsset.value = "Delete";
                            btnDeleteAsset.className = "button";

                            google.maps.event.addDomListener(
                                btnDeleteAsset,
                                "click",
                                function () {
                                    vm.deleteAssetModal(assetDetails.name, assetDetails.id);
                                }
                            );
                        }
                        if (asset.assetType.name === "OLT") {
                            btnHighLightOlt = userContent.appendChild(
                                document.createElement("input")
                            );
                            btnHighLightOlt.type = "button";
                            btnHighLightOlt.value = "Show Rings";
                            btnHighLightOlt.className = "button";
                            google.maps.event.addDomListener(btnHighLightOlt, "click", function () {
                                vm.getOltRingsData(asset.id);
                                if (openedInfoWindow != undefined) {
                                    openedInfoWindow.close();
                                };
                            });
                        }
                        if (asset.assetType.name === "OLT") {
                            btnSelectOlt = userContent.appendChild(
                                document.createElement("input")
                            );
                            btnSelectOlt.type = "button";
                            btnSelectOlt.value = "Select";
                            btnSelectOlt.className = "button";
                            google.maps.event.addDomListener(btnSelectOlt, "click", function () {
                                vm.oltAssetDetails = asset;
                                vm.showDirectionClicked = false;
                                if (openedInfoWindow !== null) {
                                    openedInfoWindow.close();
                                };
                            });
                        }
                        if ((vm.trRoute.id || vm.trRoute.tempId) && asset.id) {
                            ADDTORing = userContent.appendChild(
                                document.createElement("input")
                            );

                            ADDTORing.type = "button";
                            ADDTORing.value = "Add To Ring";
                            ADDTORing.className = "button";

                            google.maps.event.addDomListener(
                                ADDTORing,
                                "click",
                                function () {
                                    var found = vm.routePayload.assets.find(function (item) {
                                        return item.id === asset.id;
                                    });

                                    if ($scope.tabTable != 11) {
                                        $scope.tabTable = 11;
                                    }

                                   /* if (vm.ringRouteAssets.length ===0) {
                                        vm.getRouteSections();
                                    }*/
                                    $scope.$apply(function () {
                                        if (!found) {
                                            vm.routePayload.assets.push(asset);
                                            vm.highlightSelectedSpan(asset);
                                        }
                                    });

                                    if (openedInfoWindow != undefined) {
                                        openedInfoWindow.close();
                                    }
                                }
                            );
                        }
                        if (vm.trRoute.id || vm.trRoute.tempId) {
                            btnNearBy = userContent.appendChild(
                                document.createElement("input")
                            );

                            btnNearBy.type = "button";
                            btnNearBy.value = "Near By GP";
                            btnNearBy.className = "button";
                            google.maps.event.addDomListener(btnNearBy, "click", function () {
                                var nearByGpLatLng = new google.maps.LatLng(
                                    assetDetails.assetCoordinates[0].latitude,
                                    assetDetails.assetCoordinates[0].longitude
                                );
                                nearByAssets(vm.trRoute.id, nearByGpLatLng)
                                vm.nearBySource = {
                                    lat: nearByGpLatLng.lat(),
                                    lng: nearByGpLatLng.lng(),
                                    block: vm.blockName,
                                    state: vm.stateName,
                                    district: vm.districtName
                                };
                            });

                        }
                        if ((vm.trRoute.id || vm.trRoute.tempId) && asset.id) {
                            btnUpdateRoute = userContent.appendChild(
                                document.createElement("input")
                            );

                            btnUpdateRoute.type = "button";
                            btnUpdateRoute.value = "Add to Exist Ring";
                            btnUpdateRoute.className = "button";

                            google.maps.event.addDomListener(
                                btnUpdateRoute,
                                "click",
                                function () {
                                    vm.addExistAssetModal(asset);
                                    if (openedInfoWindow != undefined) {
                                        openedInfoWindow.close();
                                    };
                                }
                            );
                        }
                      /*  vm.getAssets = function (assetDetails) {
                            AssetByID.get(assetDetails, function (response) { });
                        };*/

                        return function () {
                            infowindow.setContent(userContent);
                            infowindow.open(locations.map, marker);
                            infowindow.setPosition(
                                new google.maps.LatLng(
                                    marker.getPosition().lat(),
                                    marker.getPosition().lng()
                                )
                            );
                            openedInfoWindow = infowindow;
                            setTimeout(function () {
                                infowindow.close();
                            }, 15000);
                        };

                    })(marker, index)
                );
            }
        
        }
        Configs.get("AssetImage", function (response) {
            if (response.length > 0) {
                if (response[0].configValue == "True") {
                    vm.showAssetImage = true;
                }
            }
        });
        $("#assetImages").change(function () {
            filesSelected = document.getElementById("assetImages").files;
            for (var i = 0; i < filesSelected.length; i++) {
                if (
                    (filesSelected[i].type == "image/png" ||
                        filesSelected[i].type == "image/jpg" ||
                        filesSelected[i].type == "image/jpeg" ||
                        filesSelected[i].type == "application/pdf") &&
                    filesSelected[i].size <= 2621440
                ) {
                    vm.fileWarning = false;
                    var fileReader = new FileReader();
                    fileReader.onload = function (fileLoadedEvent) {
                        vm.assetAttachments.assetImages.push({
                            image: window.btoa(fileLoadedEvent.target.result),
                            asset: {
                                id: vm.assetIdImg,
                            },
                            imageName: fileLoadedEvent.target.name,
                            imageType: fileLoadedEvent.target.type,
                        });
                    };
                    fileReader.name = filesSelected[i].name.split(".")[0];
                    fileReader.type = filesSelected[i].type.split("/")[1].toUpperCase();
                    fileReader.readAsBinaryString(filesSelected[i]);
                } else {
                    filesSelected = null;
                    vm.fileWarning = true;
                }
            }
        });
        function showAssetAttributesModal(assetVal) {
            $("#modalAssetAttributes").show();
            var assetTypeAttributeValuesList = assetVal.assetTypeAttributeValues;
            document.getElementById("assetAttributeTable").innerHTML = "";

            var newTable =
                "<table align='center' style='border: 1px solid black; width: 50%;'>" +
                "<tr><th style='border: 1px solid black; text-align: center;'>Name</th>" +
                "<th style='border: 1px solid black; text-align: center;'>Attribute Value</th></tr>";
            var filteredAndSortedList = [];
            for (var i = 0; i < assetTypeAttributeValuesList.length; i++) {
                var value = assetTypeAttributeValuesList[i];
                filteredAndSortedList.push(value);
            }

            filteredAndSortedList.sort(function (a, b) {
                return (
                    a.assetTypeAttribute.assetTypeAttribOrder -
                    b.assetTypeAttribute.assetTypeAttribOrder
                );
            });

            for (var j = 0; j < filteredAndSortedList.length; j++) {
                var item = filteredAndSortedList[j];
                newTable +=
                    "<tr><td style='border: 1px solid black; text-align: center;'>" +
                    (item.assetTypeAttribute.name || "N/A") +
                    "</td><td style='border: 1px solid black; text-align: center; color:" +
                    (item.attributeValue === 'INCREMENTAL' ? '#00A36C' : item.attributeValue === 'NEW' ? '#ff0025' : 'black') +
                    "'>" + (item.attributeValue || "N/A") +
                    "</td></tr>"
            }

            newTable += "</table>";

            document.getElementById("assetNameAssetAttributes").textContent =
                assetVal.name + " - " + assetVal.assetType.name;
            document.getElementById("assetAttributeTable").innerHTML = newTable;
        }

        function showThreePontReferenceModal(assetVal) {
            $("#modalThreePointReference").show();
            var assetTypeAttributeValuesList = assetVal.assetTypeAttributeValues,
                assetReferenceAttributesList = assetVal.assetReferenceAttributes,
                referenceAttribute = [];
            var newTable =
                "<table align='center' style='border: 1px solid black;width:50%;'><tr><th style='border: 1px solid black;text-align: center;'>Object</th><th style='border: 1px solid black;text-align: center;'>Distance (mtr)</th></tr>";
            var ref = [];
            var dist = [];
            if (assetVal.assetReferenceAttributes.length) {
                assetReferenceAttributesList.forEach(function (val) {
                    referenceAttribute.push(val["assetAttributeName"]);
                    referenceAttribute.push(val["assetAttributeValue"]);
                });
                referenceAttribute.forEach(function (val) {
                    if (
                        val.assetTypeAttribute.assetAttributeTypes == "THREE_PNT_REFERENCE"
                    ) {
                        if (
                            val.assetTypeAttribute.name == "3 Point Reference1" &&
                            val.attributeValue
                        ) {
                            ref.push(val.attributeValue);
                        } else if (
                            val.assetTypeAttribute.name == "3 Point Reference2" &&
                            val.attributeValue
                        ) {
                            ref.push(val.attributeValue);
                        } else if (
                            val.assetTypeAttribute.name == "3 Point Reference3" &&
                            val.attributeValue
                        ) {
                            ref.push(val.attributeValue);
                        } else if (
                            val.assetTypeAttribute.name == "Distance1" &&
                            val.attributeValue
                        ) {
                            dist.push(val.attributeValue);
                        } else if (
                            val.assetTypeAttribute.name == "Distance2" &&
                            val.attributeValue
                        ) {
                            dist.push(val.attributeValue);
                        } else if (
                            val.assetTypeAttribute.name == "Distance3" &&
                            val.attributeValue
                        ) {
                            dist.push(val.attributeValue);
                        }
                    }
                });
            } else {
                assetTypeAttributeValuesList.forEach(function (value) {
                    if (
                        value.assetTypeAttribute.assetAttributeTypes ==
                        "THREE_PNT_REFERENCE"
                    ) {
                        if (value.assetTypeAttribute.name == "3 Point Reference1") {
                            ref.push(value.attributeValue);
                        } else if (value.assetTypeAttribute.name == "3 Point Reference2") {
                            ref.push(value.attributeValue);
                        } else if (value.assetTypeAttribute.name == "3 Point Reference3") {
                            ref.push(value.attributeValue);
                        } else if (value.assetTypeAttribute.name == "Distance1") {
                            dist.push(value.attributeValue);
                        } else if (value.assetTypeAttribute.name == "Distance2") {
                            dist.push(value.attributeValue);
                        } else if (value.assetTypeAttribute.name == "Distance3") {
                            dist.push(value.attributeValue);
                        }
                    }
                });
            }

            for (var i = 0; i < 3; i++) {
                if (ref[i] || dist[i]) {
                    newTable +=
                        "<tr><td style='border: 1px solid black;text-align: center;'>" +
                        ref[i] +
                        "</td><td style='border: 1px solid black;text-align: center;'>" +
                        dist[i] +
                        "</td></tr>";
                }
            }
            newTable += "</table>";
            document.getElementById("assetNameThreePointReference").textContent =
                assetVal.name + " - " + assetVal.assetType.name;
            document.getElementById("threePointReferenceTable").innerHTML = newTable;
        }
        function editAssetOnMapView(fixed) {
            $("#assetEditModal").show();
        }
        function closeEditAssetModal() {
            document.getElementById("assetEditName").textContent = "Asset";
            $("#assetEditModal").removeClass("in");
            $(".modal-backdrop").remove();
            $("#assetEditModal").hide();
        }

        function closeAssetAttributesModal() {
            $("#modalAssetAttributes").removeClass("in");
            $(".modal-backdrop").remove();
            $("#modalAssetAttributes").hide();
            $("#modalNeaeBy").removeClass("in");
            $("#modalNearBy").hide();
        }
        function closeAssetExistRing() {
            $("#Exist-Ring").removeClass("in");
            $(".modal-backdrop").remove();
            $("#Exist-Ring").hide();
        }
        function closeEditAssetAttributeModal() {
            $("#editAssetAttributeModal").removeClass("in");
            $(".modal-backdrop").remove();
            $('#editAssetAttributeModal').hide();
        }

        function closeRingNameAlreadyExist() {
            $("#Exist-Ring-name").removeClass("in");
            $(".modal-backdrop").remove();
            $("#Exist-Ring-name").hide();
        }
        function closeUpdateRingNameModel() {
            $("#updateRingNameModel").removeClass("in");
            $(".modal-backdrop").remove();
            $("#updateRingNameModel").hide();
        }

        function closeRingModal() {
            $("#ringTopology").removeClass("in");
            $(".modal-backdrop").remove();
            $("#ringTopology").hide();
        }

        function saveEditAssetModal() {
            Asset.update(vm.assetToEdit , function () {
				vm.closeEditAssetModal();
			});
        }
        function closeThreePointReference() {
            $("#modalThreePointReference").removeClass("in");
            $(".modal-backdrop").remove();
            $("#modalThreePointReference").hide();
        }
        function nearByAssets(id, payload) {
            getConnectedNodes.postNeighbouringFixed(id, payload, function (response) {
                vm.nearByGps = response;
                showNearByGpsModal()
            })
        }
        function showNearByGpsModal() {
            $("#modalNearBy").show();
        }
        vm.connectSelected = function () {

            angular.forEach(vm.nearByGps, function (item) {
                if (item.selected) {
                    vm.nearByDestination = {
                        lat: item.latitude,
                        lng: item.longitude,
                        name: item.name
                    };
                    vm.fetchRoute(vm.nearBySource, vm.nearByDestination);
                }
            });
            $("#modalNearBy").removeClass("in");
            $("#modalNearBy").hide();
        };

        vm.clearSelected = function () {
            vm.refreshPage();
        };
        function callAssetsRouteByID(routeId, lastId) {
            callAssets = true;
            vm.tempStoreAssetsList = [];
            assetsByRouteBundleId.get(routeId, lastId, function (data) {
                if (data.assets.length) {
                    vm.isShowing = false;
                    vm.tempStoreAssets = data.assets;

                    vm.tempStoreAssets.forEach(function (item) {

                        if (item.block) {
                            var isDuplicate = false;
                            for (var i = 0; i < vm.blockFilter.length; i++) {
                                if (vm.blockFilter[i].name === item.block) {
                                    isDuplicate = true;
                                    break;
                                }
                            }
                            if (!isDuplicate) {
                                vm.blockFilter.push({ name: item.block, selected: true });
                            }
                        }

                        item.assetType = {};
                        item.assetType.layout = item.assetTypeLayout;
                        item.assetType.imagePath = item.assetTypeImagePath;
                        item.assetType.name = item.assetTypeName;

                        var assetType = vm.storeAssetTypes.find(function (each) {
                            return each.name == item.assetTypeName;
                        });
                        item.assetType.id = assetType.id;

                        if (vm.storeAssetTypes.length) {
                            vm.storeAssetTypes.filter(function (eachElement) {
                                if (item.assetTypeName == eachElement.name) {
                                    item.assetTypeAttributeValues = getConsolidatedAssetTypeAttributeValue(
                                        eachElement.assetTypeAttributes
                                    );
                                }
                            });
                        }

                        delete item.assetTypeName;
                        delete item.assetTypeImagePath;
                        delete item.assetTypeLayout;

                        vm.mappedAssetsList.push(item);
                        vm.tempStoreAssetsList.push(item);
                    });

                    iterateMappedAssetsList(locations.map, vm.tempStoreAssetsList);

                    if (vm.mappedAssetsList.length > 0) {
                        var len = Math.floor(vm.mappedAssetsList.length / 2);
                        locations.map.setCenter(
                            new google.maps.LatLng(
                                vm.mappedAssetsList[len].assetCoordinates[0].latitude,
                                vm.mappedAssetsList[len].assetCoordinates[0].longitude
                            )
                        );
                    }
                }

                if (data.assets.length >= 100) {
                    callAssetsRouteByID(
                        vm.trRoute.id,
                        data.assets[data.assets.length - 1].id
                    );
                } else {
                    vm.assetsLoaded = false;
                }

                if (vm.mappedAssetsList.length) {
                    vm.legend = [];
                    vm.legend.push(
                        { name: "Not Connected", code: "#ff0025" },
                        { name: "Connected", code: "#00A36C" }
                    );
                }
            });
        }

        vm.navigate = function (asset) {
            clearPolylines();
            if (asset.assetType.layout == "SPREAD" && asset.assetCoordinates.length >0 ) {
                var path = [];

                asset.assetCoordinates.forEach(function (each) {
					if(each.latitude != null && each.longitude != null ){
						path.push({ lat: each.latitude, lng: each.longitude, id: each.id });
					}
                    
                });
                // path.sort(function (a, b) {
                //     return a.id - b.id;
                // });
                if (path[0].sortOrder != null) {
                    path.sort(function (a, b) {
                        return a.sortOrder - b.sortOrder; // Ascending order
                    });
                    // } else {
                    //     path.sort(function (a, b) {
                    //         return a.id - b.id; // Ascending order
                    //     });
                }

                spreadPoly = new google.maps.Polyline({
                    path: path,
                    strokeColor: "#A938F3",
                    strokeOpacity: 0.6,
                    strokeWeight: 19,
                });
                spreadPoly.setMap(locations.map);
                locations.map.setZoom(12);
                locations.map.setCenter(path[0]);
                polylineTimer = function () {
                    if (spreadPoly != null) {
                        spreadPoly.setMap(null);
                        spreadPoly = null;
                    }
                }
            } else if (asset.assetType.layout == "FIXED" && asset.assetCoordinates.length >0) {
                locations.map.setZoom(16);
                locations.map.setCenter({
                    lat: asset.assetCoordinates[0].latitude,
                    lng: asset.assetCoordinates[0].longitude,
                });
            }
        };
        function clearPolylines() {
            if (spreadPoly) {
                spreadPoly.setMap(null);
                spreadPoly = null;
            }

            polylines.forEach(function (poly) {
                poly.setMap(null);
            });
            polylines = [];

            if (polylineTimer) {
                clearTimeout(polylineTimer);
            }
        }
        var ringTopology = [];
        vm.storeRingPolylines = [];
        vm.onSelectedRingSize = function () {
            $scope.isShowMinCost = false;
            $scope.isShowMinCostText = "Show";

            if (vm.storeRingPolylines.length) {
                for (var i = 0; i < vm.storeRingPolylines.length; i++) {
                    vm.storeRingPolylines[i].polyline.setMap(null);
                }
            }

            vm.mappedAssetsList = vm.mappedAssetsList.filter(function (item) {
                return item.id != "True";
            });

            var tempId = vm.trRoute.id ? vm.trRoute.id : vm.trRoute.tempId;

            if (tempId) {
                assetsLinking.assetRings(
                    tempId,
                    vm.selectedRingSize,
                    function (ringResponse) {
                        if (ringResponse.length) {
                            vm.storeRingPolylines = [];
                            ringTopology = [];
                            vm.ringList = []
                            storeRingOptions = [];
                            tempRingAssetStore = [];
                            tempRingAssetStoreInGraph = [];

                            vm.ringResponse = ringResponse;

                            var latlng, spreadCoordinates, fiberDistance;
                            vm.ringResponse.forEach(function (each, index) {
                                vm.ringTotalDistance = 0;

                                each.forEach(function (eachInner) {
                                    if (eachInner.sourceNode.assetCoordinates.length > 2) {
                                        latlng = [];
                                        fiberDistance = 0;
                                        spreadCoordinates = eachInner.sourceNode.assetCoordinates;
                                        for (var i in spreadCoordinates) {
                                            if (i > 0) {
                                                fiberDistance += distanceCal(
                                                    spreadCoordinates[i].latitude,
                                                    spreadCoordinates[i].longitude,
                                                    spreadCoordinates[i - 1].latitude,
                                                    spreadCoordinates[i - 1].longitude
                                                );
                                                latlng.push({
                                                    lat: spreadCoordinates[i].latitude,
                                                    lng: spreadCoordinates[i].longitude,
                                                });
                                                fiberDistance = parseFloat(fiberDistance.toFixed(2));
                                            }
                                        }

                                        vm.ringTotalDistance += parseFloat(
                                            fiberDistance.toFixed(2)
                                        );

                                        ringTopology.push({
                                            name: eachInner.sourceNode.name,
                                            assetCoordinates: eachInner.sourceNode.assetCoordinates,
                                            assetType: {
                                                layout: "SPREAD",
                                                name: "Planned Route",
                                                id: vm.tempAssetDetail.id,
                                            },
                                            latlng: latlng,
                                            isChecked: false,
                                            isCycle: true,
                                            inGraph: true,
                                            index: index,
                                            id: null,
                                            assetColor: null,
                                            transparency: null,
                                            lineWidth: null,
                                            healthIndicator: null,
                                            healthRemarks: null,
                                            burried: null,
                                            minCost: null,
                                            phase: "PLANNING",
                                            assetLength: fiberDistance,
                                        });
                                    }
                                });

                                var temp = {
                                    name: "Ring Option " + (index + 1),
                                    index: index + 1,
                                    id: "True",
                                    assetType: {
                                        layout: " ",
                                        name: " ",
                                    },
                                    inGraph: true,
                                    isOption: true,
                                    assetLength: vm.ringTotalDistance,
                                };
                                // vm.mappedAssetsList.unshift(temp);
                                vm.ringList.push(temp)
                                if ($scope.tabTable != 12) {
                                    $scope.tabTable = 12;
                                }
                                storeRingOptions.push(temp);
                            });

                            vm.storeRingTopology = ringTopology;

                            vm.storeRingTopology.forEach(function (each) {
                                var index = vm.mappedAssetsList.findIndex(function (item) {
                                    return (
                                        each.name === item.name &&
                                        item.assetCoordinates &&
                                        each.assetCoordinates[0].latLong ===
                                        item.assetCoordinates[0].latLong &&
                                        each.assetCoordinates[each.assetCoordinates.length - 1]
                                            .latLong ===
                                        item.assetCoordinates[item.assetCoordinates.length - 1]
                                            .latLong
                                    );
                                });

                                if (index === -1) {
                                    tempRingAssetStore.push(each.name);
                                    vm.mappedAssetsList.push(each);
                                }
                            });

                            ringTopology.forEach(function (item) {
                                drawPolyLines(
                                    item,
                                    "red",
                                    item.latlng,
                                    locations.map,
                                    true
                                );
                            });
                        } else {
                            alert("Ring Topology Not Detected");
                        }
                    }
                );
            }

            $timeout(function () {
                closeRingModal();
            }, 500);
        };

        vm.ringModal = function () {
            $("#ringTopology").show();
        };

        vm.onChangeTopology = function (asset) {
            var temp = [];

            if (vm.storeRingPolylines.length) {
                temp = vm.storeRingPolylines;

                var tempPoly = temp.filter(function (item) {
                    return asset.index == item.index;
                });

                if (asset.isOption) {
                    for (var i = 0; i < tempPoly.length; i++) {
                        tempPoly[i].polyline.setMap(locations.map);
                    }
                } else if (!asset.isOption) {
                    for (var i = 0; i < tempPoly.length; i++) {
                        tempPoly[i].polyline.setMap(null);
                    }
                }
            }
        };

        Configs.get("Ring_Topology", function (response) {
            if (response.length) {
                response.forEach(function (item) {
                    if (item.configKey == "Ring_Size") {
                        tempSize = item.configValue;
                    }
                });
            }
        });

        function tenGps() {
            var tempId = vm.trRoute.id ? vm.trRoute.id : vm.trRoute.tempId;
            if (tempId) {
                assetsLinking.assetRings(tempId, tempSize, function (ringResponse) {
                    if (ringResponse.length) {
                        ringTopology = [];

                        vm.ringResponse = ringResponse;

                        vm.ringResponse.forEach(function (each, index) {
                            each.forEach(function (eachInner) {
                                var latlng;
                                if (eachInner.sourceNode.assetCoordinates.length > 2) {
                                    latlng = [];
                                    eachInner.sourceNode.assetCoordinates.forEach(function (
                                        item
                                    ) {
                                        latlng.push({ lat: item.latitude, lng: item.longitude });
                                    });
                                    ringTopology.push({
                                        name: eachInner.sourceNode.name,
                                        assetCoordinates: eachInner.sourceNode.assetCoordinates,
                                        assetType: {
                                            layout: "SPREAD",
                                            name: "Planned Route",
                                            id: vm.tempAssetDetail.id,
                                        },
                                        latlng: latlng,
                                        isChecked: false,
                                        isCycle: true,
                                        inGraph: true,
                                        index: index,
                                        id: null,
                                        assetColor: null,
                                        transparency: null,
                                        lineWidth: null,
                                        healthIndicator: null,
                                        healthRemarks: null,
                                        burried: null,
                                        minCost: null,
                                        phase: "PLANNING",
                                    });
                                }
                            });
                        });

                        vm.storeRingTopology = ringTopology;

                        vm.storeRingTopology.forEach(function (each) {
                            var index = vm.mappedAssetsList.findIndex(function (item) {
                                return (
                                    each.name === item.name &&
                                    item.assetCoordinates &&
                                    each.assetCoordinates[0].latLong ===
                                    item.assetCoordinates[0].latLong &&
                                    each.assetCoordinates[each.assetCoordinates.length - 1]
                                        .latLong ===
                                    item.assetCoordinates[item.assetCoordinates.length - 1]
                                        .latLong
                                );
                            });

                            if (vm.mappedAssetsList[index]) {
                                vm.mappedAssetsList[index].inAnomaly = true;
                            }

                            if (index === -1) {
                                vm.mappedAssetsList.push(each);
                            }
                        });

                        ringTopology.forEach(function (item) {
                            drawPolyLines(item, "#000000", item.latlng, locations.map, null);
                        });
                    }
                });
            }
        }

        $scope.isAnomaly = false;
        $scope.isAnomalyText = "Show";
        $scope.toggleAnomaly = function () {
            for (var i = 0; i < vm.layerItems.length; i++) {
                vm.layerItems[i].selected = true;
                vm.selectedLayers[vm.layerItems[i].name] = true;
            }
            $scope.isAnomaly = !$scope.isAnomaly;

            $scope.isShowMinCost = false;
            $scope.isShowMinCostText = "Show";
            if ($scope.isAnomaly) {
                $scope.isAnomalyText = "Hide";

                if (anomalyPolylines.length) {
                    var temp = moreThan10KmPolylines.concat(anomalyPolylines);

                    for (var i = 0; i < temp.length; i++) {
                        temp[i].setMap(locations.map);
                    }
                } else {
                    anomalyPolylines = [];
                    moreThan10KmPolylines = [];
                    tenGps();
                    for (var i = 0; i < vm.mappedAssetsList.length; i++) {
                        if (vm.mappedAssetsList[i].assetType.layout == "SPREAD") {
                            if (vm.mappedAssetsList[i].assetCoordinates) {
                                var assetCoordinateValues = [];
                                vm.mappedAssetsList[i].assetCoordinates.forEach(function (
                                    each
                                ) {
                                    assetCoordinateValues.push({
                                        lat: each.latitude,
                                        lng: each.longitude,
                                    });
                                });
                            }
                            if (vm.mappedAssetsList[i].assetLength >= 10) {
                                drawPolyLines(
                                    vm.mappedAssetsList[i],
                                    "#0050B5",
                                    assetCoordinateValues,
                                    locations.map
                                );
                            }
                        }
                    }
                }
            } else {
                $scope.isAnomalyText = "Show";
                refreshPage();
            }
        };

        vm.getProgressBarColor = function () {
            return vm.updateProgress >= 99 ? "#0BDA51" : "#FFC300";
        };

        function iterateMappedAssetsList(map, arr) {
            for (var i = 0; i < arr.length; i++) {
                if (arr[i].assetType.layout == "FIXED") {
                    drawMarkers(arr[i], map, i);
                } else if (arr[i].assetType.layout == "SPREAD") {
                    vm.routePlanningTotalLength += arr[i].assetLength
                        ? arr[i].assetLength
                        : 0;
                    if (arr[i].assetCoordinates) {
                        var assetCoordinateValues = [];
                        if (arr[i].minCost) {
                            vm.minCostTotalLength += arr[i].assetLength
                                ? arr[i].assetLength
                                : 0;
                            for (var index in arr[i].assetCoordinates) {
                                assetCoordinateValues.push({
                                    lat: arr[i].assetCoordinates[index].latitude,
                                    lng: arr[i].assetCoordinates[index].longitude,
                                    id: arr[i].assetCoordinates[index].id
                                });
                            }
                        } else {
                            arr[i].assetCoordinates.forEach(function (each) {
                                assetCoordinateValues.push({
                                    lat: each.latitude,
                                    lng: each.longitude,
                                    id: each.id,
                                });
                            });
                        }
                    }
                    // if (assetCoordinateValues[0].sortOrder != null) {
                    //     assetCoordinateValues.sort(function (a, b) {
                    //         return a.sortOrder - b.sortOrder; // Ascending order
                    //     });
                    //     // } else {
                    //     //     assetCoordinateValues.sort(function (a, b) {
                    //     //         return a.id - b.id; // Ascending order
                    //     //     });
                    // }

                    var tmpColor = "#00A36C";
                    if (arr[i].assetType.name != 'Planned Route') {
                        tmpColor = "#00A36C";
                    } else {
                        if (arr[i].isCycle) {
                            tmpColor = "#FFD700";
                            // } else if (!arr[i].isConnected) {
                        } else if (!arr[i].isExisting || arr[i].isExisting==null) {
                            tmpColor = "#ff0025"; //tmpColor = "blue";
                        }
                    }
  
                    // if (arr[i].isConnected) {
                    if (arr[i].isExisting) {
                        tmpColor = "#00A36C";
                        vm.connectedLength += arr[i].assetLength;
                    }
                    
                    if(!arr[i].isUsed && arr[i].isExisting){
                        tmpColor = "#FFAE42"
                    }
                    if (!arr[i].isCycle) {
                        drawPolyLines(arr[i], tmpColor, assetCoordinateValues, map);
                    }
                }
            }
        }

        vm.layerItems = [];
        vm.selectedLayers = {};
        vm.filteredAssetsList = [];
        vm.layersInitialized = false;

        vm.showLayers = function () {
            if (!vm.layersInitialized) {
                vm.layerItems = [];
                var uniqueAssetTypeNames = {};

                for (var i = 0; i < vm.mappedAssetsList.length; i++) {
                    var item = vm.mappedAssetsList[i];

                    var temp = vm.storeAssetTypes.find(function (storedAsset) {
                        return storedAsset.name == item.assetType.name;
                    });
                    item.assetType = temp;
                    item.assetTypeAttributeValues = getConsolidatedAssetTypeAttributeValue(
                        temp
                    );
                    var assetType = item.assetType.name.trim().toUpperCase();
                    var assetTypeName = ['OLT'].includes(assetType)
                        ? 'BLOCK'
                        : assetType === 'JOINT KIT'
                            ? 'JUNCTION POINT'
                            : assetType === 'GP'
                                ? 'GP Router'
                                : item.assetType.name;

                    if (assetTypeName === "Planned Route" || assetTypeName === "Planned_Route") {
                      if (item.isExisting === true && item.isUsed === true) {
                            if (!uniqueAssetTypeNames["Existing"]) {
                                uniqueAssetTypeNames["Existing"] = true;
                                var existingSelected = vm.selectedLayers["Existing"] !== undefined ? vm.selectedLayers["Existing"] : true;
                                vm.layerItems.push({ name: "Existing", selected: existingSelected });
                                vm.selectedLayers["Existing"] = existingSelected;
                            }
                        }
                        if (item.isExisting === true && item.isUsed === false) {
                            if (!uniqueAssetTypeNames["Unused"]) {
                                uniqueAssetTypeNames["Unused"] = true;
                                var unusedSelected = vm.selectedLayers["Unused"] !== undefined ? vm.selectedLayers["Unused"] : true;
                                vm.layerItems.push({ name: "Unused", selected: unusedSelected });
                                vm.selectedLayers["Unused"] = unusedSelected;
                            }
                        }
                        if (item.isExisting === false) {
                            if (!uniqueAssetTypeNames["New OFC"]) {
                                uniqueAssetTypeNames["New OFC"] = true;
                                var newSelected = vm.selectedLayers["New OFC"] !== undefined ? vm.selectedLayers["New OFC"] : true;
                                vm.layerItems.push({ name: "New OFC", selected: newSelected });
                                vm.selectedLayers["New OFC"] = newSelected;
                            }
                        }

                    
                    } else {
                        if (!uniqueAssetTypeNames[assetTypeName]) {
                            uniqueAssetTypeNames[assetTypeName] = true;
                            var layerSelected = vm.selectedLayers[assetTypeName] !== undefined ? vm.selectedLayers[assetTypeName] : true;
                            vm.layerItems.push({
                                name: assetTypeName,
                                selected: layerSelected
                            });
                            vm.selectedLayers[assetTypeName] = layerSelected;
                        }
                    }

                }
                vm.layersInitialized = true;
            }
        };

        vm.updateSelectedLayers = function () {
            vm.selectedLayers = {};
            for (var i = 0; i < vm.layerItems.length; i++) {
                var layer = vm.layerItems[i];
                if (layer.selected) {
                    vm.selectedLayers[layer.name] = true;
                }
            }
            vm.filterMapByLayers();
        };

        vm.filterMapByLayers = function () {
            clearMarkersPolyLine()
            vm.filteredAssetsList = vm.mappedAssetsList.filter(function (item) {
                var assetType = item.assetType.name.trim().toUpperCase();
                var assetTypeName = ['OLT'].includes(assetType)
                    ? 'BLOCK'
                    : assetType === 'JOINT KIT'
                        ? 'JUNCTION POINT'
                        : assetType === 'GP'
                            ? 'GP Router'
                            : item.assetType.name;
                if (assetTypeName === "Planned Route" || assetTypeName === "Planned_Route") {
                    var attrType = item.assetTypeAttributeValues[0] &&
                        item.assetTypeAttributeValues[0].assetTypeAttribute &&
                        item.assetTypeAttributeValues[0].assetTypeAttribute.assetAttributeTypes;


                     if (assetTypeName === "Planned Route" || assetTypeName === "Planned_Route") {
                        if (item.isExisting && item.isUsed && vm.selectedLayers["Existing"]) {
                            return true;
                        }
                        if (item.isExisting && item.isUsed === false && vm.selectedLayers["Unused"]) {
                            return true;
                        }
                        if (!item.isExisting && vm.selectedLayers["New OFC"]) {
                            return true;
                        }

                        return false;
                    }
                    return false;
                }

                return vm.selectedLayers[assetTypeName];
            });


            for (var k = 0; k < vm.filteredAssetsList.length; k++) {
                var asset = vm.filteredAssetsList[k];

                var tmpColor = "#ff0025";
                if (asset.isCycle) {
                    tmpColor = "#FFD700";
                } else if (!asset.isExisting) {
                    tmpColor = "#ff0025";
                } else if (asset.isExisting) {
                    tmpColor = "#00A36C";
                }

                if(!asset.isUsed && asset.isExisting){
                    tmpColor = "#FFAE42";
                }

                if (asset.assetCoordinates) {
                    var assetCoordinateValues = asset.assetCoordinates.map(function (each) {
                        return { lat: each.latitude, lng: each.longitude };
                    });

                    if (assetCoordinateValues.length > 0) {
                        if (assetCoordinateValues[0].sortOrder != null) {
                            assetCoordinateValues.sort(function (a, b) {
                                return a.sortOrder - b.sortOrder;
                            });
                        }
                    }

                    if (asset.assetType.layout === "SPREAD") {
                        drawPolyLines(asset, tmpColor, assetCoordinateValues, locations.map);
                    } else if (asset.assetType.layout === "FIXED") {
                        drawMarkers(asset, locations.map, k);
                    }
                }
            }

        };

        function clearMarkersPolyLine() {
            for (var i = 0; i < markers.length; i++) {
                markers[i].setMap(null);
            }
            markers = [];
            for (var j = 0; j < polyLines.length; j++) {
                polyLines[j].setMap(null);
            }
            polyLines = [];
        }
        $scope.toggleBlock = function () {
            if (vm.selectedBlock.length) {
                clearPhase();
                vm.selectedBlock.forEach(function (each) {
                    for (var i = 0; i < phasePolylines.length; i++) {
                        if (
                            phasePolylines[i].block ===
                            each.name
                        ) {
                            if (each.selected) {
                                phasePolylines[i].setMap(locations.map);
                            }
                        }
                    }
                    for (var i = 0; i < phaseMarkers.length; i++) {
                        if (
                            phaseMarkers[i].block ===
                            each.name
                        ) {
                            if (each.selected) {
                                phaseMarkers[i].setMap(locations.map);
                            }
                        }
                    }
                });
            } else {
                clearPhase();
            }
        };

        vm.removeMarker = function () {
            commonPathMarkers.forEach(function (marker) {
                marker.setMap(null);
            });

            // Clear the commonPathMarkers array
            commonPathMarkers = [];
        };

        function addMarker(location) {
            var markerText;
            if (commonPathMarkers.length == 0) {
                markerText = "from";
            } else if (commonPathMarkers.length == 1) {
                markerText = "to";
            }
            // Create a marker
            var marker = new google.maps.Marker({
                position: location,
                map: locations.map,
                label: {
                    text: markerText,
                },
            });

            // Add the marker to the commonPathMarkers array
            commonPathMarkers.push(marker);
        }

        vm.saveRoute = function () {
            if (!vm.trRoute.id) {
                TrRouteBundle.save(vm.trRoute, function (response) {
                    $scope.setTab(4);
                    vm.trRoute.id = response.id;
                });
            } else if (vm.trRoute.id) {
                $scope.setTab(4);
                TrRouteBundle.update(vm.trRoute, function (response) { });
            }
        };

        $scope.setTabTable = function (newTab) {
            $scope.tabTable = newTab;
        };

        $scope.isSetTable = function (tabNum) {
            return $scope.tabTable === tabNum;
        };

        vm.ringSaveValidation = function () {
            var newRingName = vm.routePayload.name;

            var ringNameExist = vm.ringRouteAssets.some(function (ringItem) {
                return ringItem.name === newRingName;
            });

            if (ringNameExist) {
                $("#Exist-Ring-name").show();
            } else {
                vm.ringSave();
            }
        };

        vm.ringSave = function () {
            vm.closeRingNameAlreadyExist();
            TrRoute.save(
                vm.routePayload,
                function () {
                    alert("Ring Created");
                    clearPolylines();
                    vm.routePayload.name = null;
                    vm.routePayload.assets = [];
                    $scope.tabTable = 10;
                },
                function (err) {
                    console.log(err);
                }
            );
        };


        vm.deleteSpanOrGpAsset = function (index, asset) {
            clearPolylines();
            if (asset.assetType.layout == "SPREAD") {
                vm.totalLength -= parseFloat(asset.assetLength);
            }
            vm.routePayload.assets.splice(index, 1);
            vm.routePayload.assets.forEach(function (item) {
                vm.highlightSelectedSpan(item);
            });
        };

        vm.ringRouteAssets = [];
        vm.getRouteSections = function () {
            routeDetail.getRingsByRoute(vm.trRoute.id, function (response) {
                clearPolylines();
                highlightedMarkers = {};
                vm.highLightMarkers([]);
                var ringResponse = response;
                ringResponse.sort(function (a, b) {
                    return a.name - b.name;
                });
                vm.ringRouteAssets = ringResponse;
            });
        };

        vm.getSecAssetDetails = function (routeId) {
            routeDetail.getAssetsBySections(routeId, function (response) {
                vm.displayRingDetails = "true";
                vm.sectionAssetDetails = response;
                ringId = routeId;
                var itemIds = vm.sectionAssetDetails.map(function (item) {
                    return item.id;
                });
                vm.highlight(itemIds);
            });
        };

        vm.getFixedAssets = function (routeId) {
            vm.routeFixedAssets = [];
            routeDetail.getFixedAssetsByRouteId(routeId, function (response) {

                vm.routeFixedAssets = response;
                var itemIds = vm.routeFixedAssets.map(function (item) {
                    return item.id;
                });

                vm.highLightMarkers(itemIds);

            })
        };

        vm.getSecAssetCount = function (sectionId) {
            routeDetail.getAssetsCount(sectionId, function (response) {
                vm.sectionAssetCount = response;
            });
        };

        vm.deleteRingAssetas = function (assetId) {

            var assetDetails;
            var routePointData = [];
            var uuid = generateUUID();
            assetDetails = vm.mappedAssetsList.find(function (item) {
                return item.id === assetId;
            });
            assetDetails.assetCoordinates.forEach(function (assetCoord, index) {
                var routepoints = {
                    "routePointType": "COORDINATE",
                    "phase": "PLANNING",
                    "sessionNumber": uuid,
                    "routePointNumber": index,
                    "routeId": ringId,
                    "latitude": assetCoord.latitude,
                    "longitude": assetCoord.longitude
                };
                routePointData.push(routepoints);
            })
            //routeDetail.removeBulkRoutePoints(routePointData, function (response) {
            //console.log(response);
            routeDetail.removeAssetFromRing(ringId, assetId, function () {
                alert("Asset Removed From Ring");
                vm.getSecAssetDetails(ringId);
                vm.getSecAssetCount(ringId);
            });
            //});

        };

        var highlightedMarkers = {};

        vm.highLightMarkers = function (Ids) {
            var highlightedSize = 40;

            markers.forEach(function (marker) {
                var assetId = marker.assetDetails ? marker.assetDetails.id : null;

                if (!assetId) {
                    return;
                }

                var isHighlighted = Ids.indexOf(assetId) !== -1;
                var newSize = isHighlighted ? newSizeLevel + 15 : newSizeLevel;
                var currentIcon = marker.getIcon();

                if (currentIcon) {
                    if (isHighlighted) {
                        highlightedMarkers[assetId] = true;
                    } else {
                        delete highlightedMarkers[assetId];
                    }

                    setTimeout(function () {
                        marker.setIcon({
                            url: currentIcon.url,
                            scaledSize: new google.maps.Size(newSize, newSize),
                            anchor: new google.maps.Point(newSize / 2, newSize / 2),
                            labelOrigin: currentIcon.labelOrigin
                        });
                    }, 50);
                }
            });
        };
        vm.highlight = function (Ids) {
            clearPolylines();

            var path = {};

            if (Ids.length !== 0) {
                Ids.forEach(function (Id) {
                    var polyline = vm.mappedAssetsList.find(function (p) {
                        return p.id === Id;
                    });
                    if (polyline) {
                        if (!path[polyline.id]) {
                            path[polyline.id] = { coordinates: [] };
                        }
                        polyline.assetCoordinates.forEach(function (each) {
                            path[polyline.id].coordinates.push({
                                lat: each.latitude,
                                lng: each.longitude,
                                id: each.id,
                                sortOrder: each.sortOrder
                            });
                        });
                    }
                });

                Object.keys(path).forEach(function (id) {
                    var sessionData = path[id];
                    // sessionData.coordinates.sort(function (a, b) {
                    //     return a.id - b.id;
                    // });
                    if (sessionData.coordinates[0].sortOrder != null) {
                        sessionData.coordinates.sort(function (a, b) {
                            return a.sortOrder - b.sortOrder; // Ascending order
                        });
                        // } else {
                        //     sessionData.coordinates.sort(function (a, b) {
                        //         return a.id - b.id; // Ascending order
                        //     });
                    }
                    if (sessionData.coordinates.length !== 0) {
                        var newPolyline = new google.maps.Polyline({
                            path: sessionData.coordinates,
                            strokeColor: "#A938F3",
                            strokeOpacity: 0.6,
                            strokeWeight: 16
                        });
                        newPolyline.setMap(locations.map);
                        polylines.push(newPolyline);
                    }
                });
                // locations.map.setZoom(12);
                if (path[0]) {
                    locations.map.setCenter(path[0].coordinates[0]);
                }
                polylineTimer = setTimeout(function () {
                    clearPolylines();
                }, 100000);
            }
        };

        function addExistAssetModal(asset) {
            $("#Exist-Ring").show();

            vm.assetId = asset;
            var routeResponse = [];

            routeDetail.getRingsByRoute(vm.trRoute.id, function (response) {
                routeResponse = response;

                document.getElementById("existRingTable").innerHTML = "";

                var newTable =
                    "<table align='center' class='jh-table table table-responsive table-hover' style='border: 1px solid black; width: 40%;'>" +
                    "<tr><th style='border: 1px solid black; text-align: center;'>Rings</th></tr>";

                for (var j = 0; j < routeResponse.length; j++) {
                    var item = routeResponse[j];
                    newTable +=
                        "<tr class='ring-row' data-index='" +
                        j +
                        "'>" +
                        "<td style='text-align: center;'>" +
                        (item.name || "N/A") +
                        "</td>" +
                        "</tr>";
                }

                newTable += "</table>";

                document.getElementById("addAssetExistRing").textContent = asset.name;

                document.getElementById("existRingTable").innerHTML = newTable;

                var rows = document.querySelectorAll(".ring-row");
                rows.forEach(function (row, index) {
                    row.addEventListener("click", function () {
                        vm.SaveToExitingRing(routeResponse[index], asset);
                    });
                });
            });
        }

        vm.SaveToExitingRing = function (route, asset) {
            closeAssetExistRing();
            var routePointData = [];
            var uuid = generateUUID();
            asset.assetCoordinates.forEach(function (assetCoord, index) {
                var routepoints = {
                    "routePointType": "COORDINATE",
                    "phase": "PLANNING",
                    "sessionNumber": uuid,
                    "routePointNumber": index,
                    "routeId": route.id,
                    "latitude": assetCoord.latitude,
                    "longitude": assetCoord.longitude
                };
                routePointData.push(routepoints);
            });

            asset.routeId = route.id;
            (asset.userId = vm.userId), (asset.ownedBy = []);
            routeDetail.saveBulkRoutePoints(routePointData, function (response) {
                if (response.length > 0) {
                    routeDetail.addAseetsToExistingRing(route.id, asset.id, function () {
                        alert("Asset Added To Ring");
                        vm.getSecAssetDetails(ringId);
                        vm.getSecAssetCount(ringId);
                        vm.getRouteSections();
                    });

                } else {
                    alert("Unable to save routepoints");
                }
            });
        };

        vm.getOltRingsData = function (assetId) {
            var assetDetailsEachRings = {};
            var itemIds = [];
            var remainingCalls = 0;

            var predefinedColors = [
                "#FF5733",
                "#33FF57",
                "#3357FF",
                "#F1C40F",
                "#9B59B6",
                "#E74C3C",
                "#1ABC9C",
                "#34495E"
            ];

            var ringColors = {};
            var colorIndex = 0;

            routeDetail.getSectionByRouteIdAssetId(vm.trRoute.id, assetId, function (sectionResponse) {
                if (!sectionResponse || sectionResponse.length === 0) {
                    return;
                }
                remainingCalls = sectionResponse.length;

                sectionResponse.forEach(function (ringId) {
                    if (!ringColors[ringId.id]) {
                        ringColors[ringId.id] = predefinedColors[colorIndex];
                        colorIndex = (colorIndex + 1) % predefinedColors.length;
                    }

                    routeDetail.getAssetsBySections(ringId.id, function (assetResponse) {
                        if (assetResponse) {
                            assetDetailsEachRings[ringId.id] = assetResponse;
                        } else {
                            console.error('No assets found for ringId:', ringId.id);
                        }
                        remainingCalls--;

                        if (remainingCalls === 0) {
                            Object.keys(assetDetailsEachRings).forEach(function (ringId) {
                                var assetData = assetDetailsEachRings[ringId];
                                var color = ringColors[ringId];

                                itemIds = itemIds.concat(assetData.map(function (item) {
                                    return {
                                        id: item.id,
                                        color: color
                                    };
                                }));
                            });
                            vm.highlightOltRings(itemIds);
                        }
                    });
                });
            });
        };

        vm.highlightOltRings = function (itemIds) {
            var path = {};

            if (itemIds.length !== 0) {
                itemIds.forEach(function (item) {
                    var polyline = vm.mappedAssetsList.find(function (p) {
                        return p.id === item.id;
                    });

                    if (polyline) {

                        if (!path[polyline.id]) {
                            path[polyline.id] = { coordinates: [], color: item.color };
                        }

                        polyline.assetCoordinates.forEach(function (each) {
                            path[polyline.id].coordinates.push({
                                lat: each.latitude,
                                lng: each.longitude,
                                id: each.id,
                            });
                        });
                    }
                });

                polylines.forEach(function (poly) {
                    poly.setMap(null);
                });
                polylines = [];

                Object.keys(path).forEach(function (id) {
                    var sessionData = path[id];
                    if (sessionData.coordinates[0].sortOrder != null) {
                        sessionData.coordinates.sort(function (a, b) {
                            return a.sortOrder - b.sortOrder; // Ascending order
                        });
                        // } else {
                        //     sessionData.coordinates.sort(function (a, b) {
                        //         return a.id - b.id; // Ascending order
                        //     });
                    }
                    if (sessionData.coordinates.length !== 0) {
                        var newPolyline = new google.maps.Polyline({
                            path: sessionData.coordinates,
                            strokeColor: sessionData.color,
                            strokeOpacity: 0.6,
                            strokeWeight: 16,
                        });

                        newPolyline.setMap(locations.map);
                        polylines.push(newPolyline);
                    }
                });

                locations.map.setZoom(11);
                locations.map.setCenter(path[0]);
            } else {
                polylines.forEach(function (poly) {
                    poly.setMap(null);
                });
                polylines = [];
            }
        };
        vm.highlightSelectedSpan = function (asset) {
            if (asset.assetType.layout == "SPREAD") {
                var path = [];
                asset.assetCoordinates.forEach(function (each) {
                    path.push({ lat: each.latitude, lng: each.longitude, id: each.id,sortOrder:each.sortOrder });
                });

                if (path[0].sortOrder != null) {
                    path.sort(function (a, b) {
                        return a.sortOrder - b.sortOrder;
                    });
                    // } else {
                    //     path.sort(function (a, b) {
                    //         return a.id - b.id;
                    //     });
                }
                var newPolyline = new google.maps.Polyline({
                    path: path,
                    strokeColor: "#A938F3",
                    strokeOpacity: 0.6,
                    strokeWeight: 19,
                });

                newPolyline.setMap(locations.map);
                polylines.push(newPolyline);

            }
        };

        function generateUUID() {
            var d = new Date().getTime(); // Timestamp
            var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = (d + Math.random() * 16) % 16 | 0;
                d = Math.floor(d / 16);
                return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
            });
            return uuid;
        }
        vm.addAssetToRingStack = function (asset) {
            var found = vm.routePayload.assets.find(function (item) {
                return item.id === asset.id;
            });

            if ($scope.tabTable != 11) {
                $scope.tabTable = 11;
            }
          /*  if (vm.ringRouteAssets.length ===0) {
                vm.getRouteSections();
            }*/
            $scope.$apply(function () {
                if (!found) {
                    var assetCoordinatesValues = asset.assetCoordinates;
                    var assetCoordinatesSort = [];
                    for (var index = 0; index < assetCoordinatesValues.length; index++) {
                        var assetCoorByIndex = assetCoordinatesValues[index];
                        assetCoorByIndex.sortOrder = index;
                        assetCoordinatesSort.push(assetCoorByIndex);
                    }
                    asset.assetCoordinates = assetCoordinatesSort;
                    vm.routePayload.assets.push(asset);
                    vm.totalLength += parseFloat(asset.assetLength);
                    setTimeout(function () {
                        vm.highlightSelectedSpan(asset);
                    }, 100);
                }
            });
        }



        vm.updateSelectedAssets = function (asset) {
            var index = -1;
            for (var i = 0; i < vm.selectedAssetsToHighlightMultiRing.length; i++) {
                if (vm.selectedAssetsToHighlightMultiRing[i].id === asset.id) {
                    index = i;
                    break;
                }
            }

            if (asset.isOption) {
                if (index === -1) {
                    vm.selectedAssetsToHighlightMultiRing.push(asset);
                }
            } else {
                if (index !== -1) {
                    vm.selectedAssetsToHighlightMultiRing.splice(index, 1);
                }
            }
            if (vm.selectedAssetsToHighlightMultiRing.length === 0) {
                vm.routeFixedAssets = [];
                vm.sectionAssetDetails = [];
                vm.sectionAssetCount = [];
                clearPolylines();
            } else if (vm.selectedAssetsToHighlightMultiRing.length > 1) {
                vm.displayRingDetails = "false";
            }


            var polyItemIds = [];
            var markerItemIds = [];
            var pendingRequests = vm.selectedAssetsToHighlightMultiRing.length * 2;

            vm.selectedAssetsToHighlightMultiRing.forEach(function (ringId) {
                routeDetail.getAssetsBySections(ringId.id, function (response) {

                    for (var j = 0; j < response.length; j++) {
                        polyItemIds.push(response[j].id);
                    }
                    checkAndExecuteHighlight();
                });

                routeDetail.getFixedAssetsByRouteId(ringId.id, function (response) {
                    for (var k = 0; k < response.length; k++) {
                        markerItemIds.push(response[k].id);
                    }
                    checkAndExecuteHighlight();
                });
            });

            function checkAndExecuteHighlight() {
                pendingRequests--;
                if (pendingRequests === 0) {
                    vm.highlight(polyItemIds);
                    vm.highLightMarkers(markerItemIds);
                }
            }
        };
        vm.selectOnlyThisAsset = function (selectedAsset) {
            vm.selectedAssetsToHighlightMultiRing = [];
            angular.forEach(vm.ringRouteAssets, function (asset) {
                asset.isOption = (asset.id === selectedAsset.id);
            });

            vm.updateSelectedAssets(selectedAsset);
        };

        vm.editAssetAttributesModal = function (asset) {
            vm.asset = asset;
            vm.assetId = asset.id;
            $('#editAssetAttributeModal').show();
        }

        vm.saveEditAssetAttribute = function () {
            if (vm.assetId) {
                var assetCoordinatesValues = vm.asset.assetCoordinates;
                var assetCoordinatesSort = [];
                for (var index = 0; index < assetCoordinatesValues.length; index++) {
                    var assetCoorByIndex = assetCoordinatesValues[index];
                    assetCoorByIndex.sortOrder = index;
                    assetCoordinatesSort.push(assetCoorByIndex);
                }
                vm.asset.assetCoordinates = assetCoordinatesSort;
                (vm.asset.userId = vm.userId),
                    Asset.update(vm.asset, function () { });
                $('#editAssetAttributeModal').hide();
            }

        }
        vm.updateRingName = function (routeId) {
            $('#updateRingNameModel').show();
            vm.updateRingNameRingId = routeId;
        }


        vm.updateRingNameValidation = function () {
            vm.duplicateName = false;

            var newRingName = vm.newRingName;
            //var newRingNameTrim =newRingName.trim(); 
            var ringNameExist = vm.ringRouteAssets.some(function (ringItem) {
                return ringItem.name === newRingName;
            });

            if (!ringNameExist) {
                $('#updateRingNameModel').hide();
                routeDetail.updateRingName(vm.trRoute.id, vm.updateRingNameRingId, newRingName, function (response) {
                    if (response === 1) {
                        clearPolylines();
                        vm.newRingName = "";
                        $scope.tabTable = 10;
                    } else {
                        alert("Update Failed.")
                    }

                });

            } else {
                vm.duplicateName = true;
                $('#updateRingNameModel').show();
            }
        };
     
        vm.toggleAssetTable=function(){
            vm.isSidebarVisible = !vm.isSidebarVisible;
        }
    }
})();